export const moduleDetails = {
  "first-year": {
    1: [
      {
        title: "Mathematics For CSE",
        code: "BMATS101",
        vtuCode: "BMATS101",
        credits: 4,
        modules: [
          {
            id: "math-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1s__ib0S7BVMtYVWCU6G3wiwJqXlyDpXk",
            previewUrl: "https://drive.google.com/file/d/1s__ib0S7BVMtYVWCU6G3wiwJqXlyDpXk/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "4.2",
            tags: ["module-1", "theory", "mathematics"]
          },
          {
            id: "math-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1KHVZG-p6tFYMfcRhgj8GJ2y6v7xBqI2C",
            previewUrl: "https://drive.google.com/file/d/1KHVZG-p6tFYMfcRhgj8GJ2y6v7xBqI2C/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.8",
            tags: ["module-2", "theory", "mathematics"]
          },
          {
            id: "math-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1-IwKiWyX413t3ttm_nLlX1DHeMTIBZsG",
            previewUrl: "https://drive.google.com/file/d/1-IwKiWyX413t3ttm_nLlX1DHeMTIBZsG/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.5",
            tags: ["module-3", "theory", "mathematics"]
          },
          {
            id: "math-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1OnesfEvKWdqHx2HfXV046dx-QN7eZXSc",
            previewUrl: "https://drive.google.com/file/d/1OnesfEvKWdqHx2HfXV046dx-QN7eZXSc/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "4.0",
            tags: ["module-4", "theory", "mathematics"]
          },
          {
            id: "math-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Mxfj8jZl1T9NlM8Mu-5MHiFEsninrxFV",
            previewUrl: "https://drive.google.com/file/d/1Mxfj8jZl1T9NlM8Mu-5MHiFEsninrxFV/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-25",
            fileSize: "3.9",
            tags: ["module-5", "theory", "mathematics"]
          },
          {
            id: "math-6",
            title: "Mathematics Question Paper",
            description: "Past question paper for Mathematics for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1lykWhoLSLbdD66PywFOvqKadpjZnPO41",
            previewUrl: "https://drive.google.com/file/d/1lykWhoLSLbdD66PywFOvqKadpjZnPO41/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "2.8",
            tags: ["PYQ", "question-paper", "exam"]
          },
          {
            id: "math-7",
            title: "Question Paper Solutions 1",
            description: "Past question paper solutions for Mathematics for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1yI2Fs_AqYSwB55JyYhz8lSvghi1jmKUy",
            previewUrl: "https://drive.google.com/file/d/1yI2Fs_AqYSwB55JyYhz8lSvghi1jmKUy/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-30",
            fileSize: "5.6",
            tags: ["solutions", "solved", "answers"]
          },
          {
            id: "math-8",
            title: "Question Paper Solutions 2",
            description: "Past question paper solutions for Mathematics for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1MuMVnSVrLteIfq0KzNT506KtaQZeZxLh",
            previewUrl: "https://drive.google.com/file/d/1MuMVnSVrLteIfq0KzNT506KtaQZeZxLh/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-01",
            fileSize: "4.8",
            tags: ["solutions", "solved", "answers"]
          },
          {
            id: "math-9",
            title: "Question Paper Solutions 3",
            description: "Past question paper solutions for Mathematics for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1NTy9LapYCGOeUA8y5TruF72X_H7VQ9Eo",
            previewUrl: "https://drive.google.com/file/d/1NTy9LapYCGOeUA8y5TruF72X_H7VQ9Eo/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-03",
            fileSize: "4.5",
            tags: ["solutions", "solved", "answers"]
          },
          {
            id: "math-10",
            title: "Mathematics Question Bank",
            description: "Question bank for Mathematics for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1dytNuksweWVZ4o0uedFM8wrI0fnxYmBc",
            previewUrl: "https://drive.google.com/file/d/1dytNuksweWVZ4o0uedFM8wrI0fnxYmBc/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-02-05",
            fileSize: "3.2",
            tags: ["question-bank", "practice", "questions"]
          },
        ],
      },
      {
        title: "Applied Physics For CSE",
        code: "BPHYS102/202",
        vtuCode: "BPHYS102/202",
        credits: 4,
        modules: [
          {
            id: "phy-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1fxNcviU2MkJtSpdN3KhF_QuyIBHl4gvo",
            previewUrl: "https://drive.google.com/file/d/1fxNcviU2MkJtSpdN3KhF_QuyIBHl4gvo/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "4.5",
            tags: ["module-1", "physics", "theory"]
          },
          {
            id: "phy-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=174lgTaTm2_2yxxlAjUO-JWAfJt1wHlx8",
            previewUrl: "https://drive.google.com/file/d/174lgTaTm2_2yxxlAjUO-JWAfJt1wHlx8/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "4.0",
            tags: ["module-2", "physics", "theory"]
          },
          {
            id: "phy-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1IpCD0rOzck5qE6iVd25Ul5ZksMi_Ulxa",
            previewUrl: "https://drive.google.com/file/d/1IpCD0rOzck5qE6iVd25Ul5ZksMi_Ulxa/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.8",
            tags: ["module-3", "physics", "theory"]
          },
          {
            id: "phy-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1fbateF4uIDpn3Wprfm0egzENJMNw8WPE",
            previewUrl: "https://drive.google.com/file/d/1fbateF4uIDpn3Wprfm0egzENJMNw8WPE/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "4.2",
            tags: ["module-4", "physics", "theory"]
          },
          {
            id: "phy-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1QLF1kJz8HpWxQXzUX2pdkrKk6iqgyOe-",
            previewUrl: "https://drive.google.com/file/d/1QLF1kJz8HpWxQXzUX2pdkrKk6iqgyOe-/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "3.9",
            tags: ["module-5", "physics", "theory"]
          },
          {
            id: "phy-6",
            title: "Applied Physics Question Paper 1",
            description: "Past question paper for Applied Physics for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1EPo4fKtVC-pRv-31K1ngNobA9hJn4kDo",
            previewUrl: "https://drive.google.com/file/d/1EPo4fKtVC-pRv-31K1ngNobA9hJn4kDo/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.2",
            tags: ["PYQ", "question-paper", "exam"]
          },
          {
            id: "phy-7",
            title: "Applied Physics Question Paper 2",
            description: "Past question paper for Applied Physics for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cj3-3mlvepcXP5lVMqbjlydqMzOYCRgN",
            previewUrl: "https://drive.google.com/file/d/1Cj3-3mlvepcXP5lVMqbjlydqMzOYCRgN/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-30",
            fileSize: "3.0",
            tags: ["PYQ", "question-paper", "exam"]
          },
          {
            id: "phy-8",
            title: "Applied Physics Question Paper Solutions",
            description: "Question bank for Applied Physics for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Eq3hyKXbgBeVgPw_rgG5xFsU3pIl9VCA",
            previewUrl: "https://drive.google.com/file/d/1Eq3hyKXbgBeVgPw_rgG5xFsU3pIl9VCA/preview",
            type: "solutions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-02-01",
            fileSize: "4.5",
            tags: ["question-bank", "solutions", "practice"]
          },
        ],
      },
      {
        title: "Principle of Programming Using C",
        code: "BPOP103/203",
        vtuCode: "BPOP103/203",
        credits: 3,
        modules: [
          {
            id: "cprog-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1DOdW_T-H2f4Y_seK2hTuXrleK5bLZX86",
            previewUrl: "https://drive.google.com/file/d/1DOdW_T-H2f4Y_seK2hTuXrleK5bLZX86/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-1", "c-programming", "theory"]
          },
          {
            id: "cprog-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=10aNa2X7NHtHUx6eOOfzQpyJSrtGvIJYl",
            previewUrl: "https://drive.google.com/file/d/10aNa2X7NHtHUx6eOOfzQpyJSrtGvIJYl/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-2", "c-programming", "theory"]
          },
          {
            id: "cprog-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1AHMX2rp_EFTtZDIysXgKZrxJ8-_b9Hma",
            previewUrl: "https://drive.google.com/file/d/1AHMX2rp_EFTtZDIysXgKZrxJ8-_b9Hma/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.8",
            tags: ["module-3", "c-programming", "theory"]
          },
          {
            id: "cprog-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1J70Q4Ra0zfaqJrcTiyuU3RbdNKa-a9hD",
            previewUrl: "https://drive.google.com/file/d/1J70Q4Ra0zfaqJrcTiyuU3RbdNKa-a9hD/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.6",
            tags: ["module-4", "c-programming", "theory"]
          },
          {
            id: "cprog-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=16qt-Tq3FDCdnt7mTQy3uUPbKoAoHwKVI",
            previewUrl: "https://drive.google.com/file/d/16qt-Tq3FDCdnt7mTQy3uUPbKoAoHwKVI/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.4",
            tags: ["module-5", "c-programming", "theory"]
          },
          {
            id: "cprog-6",
            title: "Question Paper With Solutions 1",
            description: "Past question paper for Principle of Programming Using C",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Gx8ywx2qLVmGyxMlZQSV8sq7s9vcHlRG",
            previewUrl: "https://drive.google.com/file/d/1Gx8ywx2qLVmGyxMlZQSV8sq7s9vcHlRG/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "4.2",
            tags: ["PYQ", "solutions", "exam"]
          },
          {
            id: "cprog-7",
            title: "Question Paper With Solutions 2",
            description: "Question bank for Principle of Programming Using C",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Lyy-k8PAf6fpSkYI3hWjmEwiGHAJyGbj",
            previewUrl: "https://drive.google.com/file/d/1Lyy-k8PAf6fpSkYI3hWjmEwiGHAJyGbj/preview",
            type: "solutions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "4.0",
            tags: ["question-bank", "solutions", "practice"]
          },
        ],
      },
      {
        title: "Communicative English",
        code: "BENGK106",
        vtuCode: "BENGK106",
        credits: 2,
        modules: [
          {
            id: "english-1",
            title: "All Modules: Notes",
            description: "Comprehensive notes for all modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ex__XzQIgffF0i2FxJLWBVKrE_86iD0O",
            previewUrl: "https://drive.google.com/file/d/1ex__XzQIgffF0i2FxJLWBVKrE_86iD0O/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "5.2",
            tags: ["all-modules", "english", "complete"]
          },
          {
            id: "english-2",
            title: "Question Paper: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1J1SrDpWDM0hYceSUuNOygjMzpKIE7om9",
            previewUrl: "https://drive.google.com/file/d/1J1SrDpWDM0hYceSUuNOygjMzpKIE7om9/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.8",
            tags: ["question-paper", "english", "exam"]
          },
        ],
      },
      {
        title: "Indian Constitution",
        code: "BICOK107",
        vtuCode: "BICOK107",
        credits: 1,
        modules: [
          {
            id: "iconst-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1l45DXBLpO0rjkJx39pyOsTIZ6K6Aqayn",
            previewUrl: "https://drive.google.com/file/d/1l45DXBLpO0rjkJx39pyOsTIZ6K6Aqayn/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "2.8",
            tags: ["module-1", "constitution", "theory"]
          },
          {
            id: "iconst-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=18XeWQyqLhr-LbA-tb2s0PZyCL1W5OSSC",
            previewUrl: "https://drive.google.com/file/d/18XeWQyqLhr-LbA-tb2s0PZyCL1W5OSSC/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.0",
            tags: ["module-2", "constitution", "theory"]
          },
          {
            id: "iconst-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=13s0LdIbsaAQ6By-l4Ox7Qm0KRxin6VI7",
            previewUrl: "https://drive.google.com/file/d/13s0LdIbsaAQ6By-l4Ox7Qm0KRxin6VI7/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "2.5",
            tags: ["module-3", "constitution", "theory"]
          },
          {
            id: "iconst-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=10GVFaHnbmXd2GAd1W6INNbo7XhtxjKuT",
            previewUrl: "https://drive.google.com/file/d/10GVFaHnbmXd2GAd1W6INNbo7XhtxjKuT/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "2.8",
            tags: ["module-4", "constitution", "theory"]
          },
          {
            id: "iconst-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1P5AKy9coI0kGbne6HDGv5JaZkNZfjQkt",
            previewUrl: "https://drive.google.com/file/d/1P5AKy9coI0kGbne6HDGv5JaZkNZfjQkt/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "2.6",
            tags: ["module-5", "constitution", "theory"]
          },
          {
            id: "iconst-6",
            title: "Question Bank",
            description: "Question bank for Indian Constitution",
            fileUrl: "https://drive.google.com/uc?export=download&id=17WIR2HLEBRT0QQM4kw1WevirttZs7GeS",
            previewUrl: "https://drive.google.com/file/d/17WIR2HLEBRT0QQM4kw1WevirttZs7GeS/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "3.2",
            tags: ["question-bank", "practice", "exam"]
          },
        ],
      },
      {
        title: "Scientific Foundation Of Health",
        code: "BSFHK158",
        vtuCode: "BSFHK158",
        credits: 1,
        modules: [
          {
            id: "sfh-1",
            title: "Module 1 To 5: Notes",
            description: "Comprehensive notes for all modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=11L8jsTLfh8-JsISUo4GDU9Neq4DA7gQK",
            previewUrl: "https://drive.google.com/file/d/11L8jsTLfh8-JsISUo4GDU9Neq4DA7gQK/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "4.5",
            tags: ["all-modules", "health", "complete"]
          },
          {
            id: "sfh-2",
            title: "Question Paper Solutions: Notes",
            description: "Question paper solutions for Scientific Foundation Of Health",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.8",
            tags: ["solutions", "question-paper", "exam"]
          },
        ],
      },
      {
        title: "Introduction to Civil Engineering",
        code: "BESCK104A",
        vtuCode: "BESCK104A",
        credits: 3,
        modules: [
          {
            id: "civil-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1MoFtUIMqSt2eghdz8F28GXH1HCEFDjot",
            previewUrl: "https://drive.google.com/file/d/1MoFtUIMqSt2eghdz8F28GXH1HCEFDjot/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.2",
            tags: ["module-1", "civil", "theory"]
          },
          {
            id: "civil-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1JxEkRaUwuK8V3T2aOQpHocwa0kdvpg3l",
            previewUrl: "https://drive.google.com/file/d/1JxEkRaUwuK8V3T2aOQpHocwa0kdvpg3l/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.5",
            tags: ["module-2", "civil", "theory"]
          },
          {
            id: "civil-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=11tN1-pn4VnhwhOTfqs5Dpr89OHtfFp1R",
            previewUrl: "https://drive.google.com/file/d/11tN1-pn4VnhwhOTfqs5Dpr89OHtfFp1R/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.8",
            tags: ["module-3", "civil", "theory"]
          },
          {
            id: "civil-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1jBfzEuW11oISuvKWVxr082DDhYO0Kw9B",
            previewUrl: "https://drive.google.com/file/d/1jBfzEuW11oISuvKWVxr082DDhYO0Kw9B/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.6",
            tags: ["module-4", "civil", "theory"]
          },
          {
            id: "civil-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1QJ4wQU-KobTDanBtL11C0W2cjq-BHShQ",
            previewUrl: "https://drive.google.com/file/d/1QJ4wQU-KobTDanBtL11C0W2cjq-BHShQ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.4",
            tags: ["module-5", "civil", "theory"]
          },
          {
            id: "civil-6",
            title: "Question Paper",
            description: "Question paper for Introduction to Civil Engineering",
            fileUrl: "https://drive.google.com/uc?export=download&id=1QJ4wQU-KobTDanBtL11C0W2cjq-BHShQ",
            previewUrl: "https://drive.google.com/file/d/1QJ4wQU-KobTDanBtL11C0W2cjq-BHShQ/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["PYQ", "question-paper", "exam"]
          },
          {
            id: "civil-7",
            title: "Question Bank",
            description: "Question bank for Introduction to Civil Engineering",
            fileUrl: "https://drive.google.com/uc?export=download&id=1hgoSu8mT6Z6IkMJfHUSFmGuV9OR-m1Vi",
            previewUrl: "https://drive.google.com/file/d/1hgoSu8mT6Z6IkMJfHUSFmGuV9OR-m1Vi/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.5",
            tags: ["question-bank", "practice", "questions"]
          },
        ],
      },

    ],
    2: [
      {
        title: "Mathematics For CSE",
        code: "BMATS201",
        vtuCode: "BMATS201",
        credits: 4,
        modules: [
          {
            id: "math2-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1V1oKb8kALhD5mNAYZkb7Z5zkicbSxRYP",
            previewUrl: "https://drive.google.com/file/d/1V1oKb8kALhD5mNAYZkb7Z5zkicbSxRYP/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.8",
            tags: ["module-1", "mathematics", "theory"]
          },
          {
            id: "math2-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1w-BYdgRW7EGkqXnogAj-sm5XTCRNG5Yr",
            previewUrl: "https://drive.google.com/file/d/1w-BYdgRW7EGkqXnogAj-sm5XTCRNG5Yr/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.5",
            tags: ["module-2", "mathematics", "theory"]
          },
          {
            id: "math2-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1uxmv3kbTRT33Z7Klm6cg-B4XwrNFZmUQ",
            previewUrl: "https://drive.google.com/file/d/1uxmv3kbTRT33Z7Klm6cg-B4XwrNFZmUQ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.2",
            tags: ["module-3", "mathematics", "theory"]
          },
          {
            id: "math2-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1_31eml29PMNaq9E8y-2tv4xK0YikP6Qg",
            previewUrl: "https://drive.google.com/file/d/1_31eml29PMNaq9E8y-2tv4xK0YikP6Qg/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.6",
            tags: ["module-4", "mathematics", "theory"]
          },
          {
            id: "math2-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1S3G0chd80RccZ3b9bvrfx5j_s8l_IVzx",
            previewUrl: "https://drive.google.com/file/d/1S3G0chd80RccZ3b9bvrfx5j_s8l_IVzx/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.4",
            tags: ["module-5", "mathematics", "theory"]
          },
          {
            id: "math2-6",
            title: "Question Solutions",
            description: "Past question paper solutions for Mathematics for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1BXyhq4ZiTLbhpIwJHGkRYe60rbJQqQne",
            previewUrl: "https://drive.google.com/file/d/1BXyhq4ZiTLbhpIwJHGkRYe60rbJQqQne/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "4.2",
            tags: ["solutions", "question-paper", "exam"]
          },
          {
            id: "math2-7",
            title: "Question Paper Solution",
            description: "Question paper solutions for Mathematics for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1vHxAXnHlBBglr-K3ZUAGqzwP5SC0qNki",
            previewUrl: "https://drive.google.com/file/d/1vHxAXnHlBBglr-K3ZUAGqzwP5SC0qNki/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.8",
            tags: ["solutions", "question-paper", "answers"]
          },
          {
            id: "math2-8",
            title: "Old QP'S",
            description: "Old question papers for Mathematics for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1cWG4jvZRZ2iBJA09t0WRW78dqw2vdm9x",
            previewUrl: "https://drive.google.com/file/d/1cWG4jvZRZ2iBJA09t0WRW78dqw2vdm9x/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-30",
            fileSize: "3.0",
            tags: ["PYQ", "old-papers", "exam"]
          },
        ],
      },
      {
        title: "Applied Chemistry For CSE",
        code: "BCHES102/202",
        vtuCode: "BCHES102/202",
        credits: 4,
        modules: [
          {
            id: "chem-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1UqN74vxRKMK7nduE-o8hqPBGQjXlBKD2",
            previewUrl: "https://drive.google.com/file/d/1UqN74vxRKMK7nduE-o8hqPBGQjXlBKD2/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-1", "chemistry", "theory"]
          },
          {
            id: "chem-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1hBuNu8Kr-pfcP_12BD7F5IKIIoO4oMnw",
            previewUrl: "https://drive.google.com/file/d/1hBuNu8Kr-pfcP_12BD7F5IKIIoO4oMnw/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-2", "chemistry", "theory"]
          },
          {
            id: "chem-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1rWU-U4keAIU5eNUs9Ivmjiaa3zNRH_tP",
            previewUrl: "https://drive.google.com/file/d/1rWU-U4keAIU5eNUs9Ivmjiaa3zNRH_tP/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.8",
            tags: ["module-3", "chemistry", "theory"]
          },
          {
            id: "chem-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1lXhQo1TwgXsuKw8JQW7yWLODRECaLJwU",
            previewUrl: "https://drive.google.com/file/d/1lXhQo1TwgXsuKw8JQW7yWLODRECaLJwU/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.6",
            tags: ["module-4", "chemistry", "theory"]
          },
          {
            id: "chem-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1VBRZDrTut8xPBlVvYb6zUm8yMXnJwr7i",
            previewUrl: "https://drive.google.com/file/d/1VBRZDrTut8xPBlVvYb6zUm8yMXnJwr7i/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.4",
            tags: ["module-5", "chemistry", "theory"]
          },
          {
            id: "chem-6",
            title: "Question Paper Solution 1",
            description: "Question paper solutions for Chemistry for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=15WLqIDiaKljyJWdl0XsWBWfB-lTJiiS1",
            previewUrl: "https://drive.google.com/file/d/15WLqIDiaKljyJWdl0XsWBWfB-lTJiiS1/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "4.0",
            tags: ["solutions", "question-paper", "answers"]
          },
          {
            id: "chem-7",
            title: "Question Paper Solution",
            description: "Question bank for Chemistry for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1lnD5TTvI5X_8sng4E0qzT5pGCr74z6LL",
            previewUrl: "https://drive.google.com/file/d/1lnD5TTvI5X_8sng4E0qzT5pGCr74z6LL/preview",
            type: "solutions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.8",
            tags: ["question-bank", "solutions", "practice"]
          },
        ],
      },
      {
        title: "Introduction to Python Programming",
        code: "BPLCK105/205B",
        vtuCode: "BPLCK105/205B",
        credits: 3,
        modules: [
          {
            id: "python-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=176FQ4JP8TBnVp13Up3kU3e2NnwqZepwM",
            previewUrl: "https://drive.google.com/file/d/176FQ4JP8TBnVp13Up3kU3e2NnwqZepwM/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.8",
            tags: ["module-1", "python", "programming"]
          },
          {
            id: "python-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1oxEARMoSL3mNe__8pb9pg_kZO4rc0Hwo",
            previewUrl: "https://drive.google.com/file/d/1oxEARMoSL3mNe__8pb9pg_kZO4rc0Hwo/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.5",
            tags: ["module-2", "python", "programming"]
          },
          {
            id: "python-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1dOyBTLBoYHYpWl9mOL0QOId3cW1UFLLk",
            previewUrl: "https://drive.google.com/file/d/1dOyBTLBoYHYpWl9mOL0QOId3cW1UFLLk/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.6",
            tags: ["module-3", "python", "programming"]
          },
          {
            id: "python-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1kVzP3a-n7vcltowW8HpJez68622gXCQM",
            previewUrl: "https://drive.google.com/file/d/1kVzP3a-n7vcltowW8HpJez68622gXCQM/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.4",
            tags: ["module-4", "python", "programming"]
          },
          {
            id: "python-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1BS2HK9KGuc191E8NM6JZoG6oxJBtev-3",
            previewUrl: "https://drive.google.com/file/d/1BS2HK9KGuc191E8NM6JZoG6oxJBtev-3/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.2",
            tags: ["module-5", "python", "programming"]
          },
          {
            id: "python-6",
            title: "Question Paper",
            description: "Past question paper for Python Programming",
            fileUrl: "https://drive.google.com/uc?export=download&id=1aylHWxDTEvZ9W3oZDX2vUy3luveUwKlX",
            previewUrl: "https://drive.google.com/file/d/1aylHWxDTEvZ9W3oZDX2vUy3luveUwKlX/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["PYQ", "question-paper", "exam"]
          },
          {
            id: "python-7",
            title: "Question Bank",
            description: "Question bank for Python Programming",
            fileUrl: "https://drive.google.com/uc?export=download&id=1aylHWxDTEvZ9W3oZDX2vUy3luveUwKlX",
            previewUrl: "https://drive.google.com/file/d/1aylHWxDTEvZ9W3oZDX2vUy3luveUwKlX/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.0",
            tags: ["question-bank", "practice", "questions"]
          },
        ],
      },
      {
        title: "Computer Aided Engineering Drawing",
        code: "BCEDK203",
        vtuCode: "BCEDK203",
        credits: 3,
        modules: [
          {
            id: "caed-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK",
            previewUrl: "https://drive.google.com/file/d/1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "4.2",
            tags: ["module-1", "engineering-drawing", "cad"]
          },
          {
            id: "caed-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK",
            previewUrl: "https://drive.google.com/file/d/1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "4.2",
            tags: ["module-2", "engineering-drawing", "cad"]
          },
          {
            id: "caed-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK",
            previewUrl: "https://drive.google.com/file/d/1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "4.2",
            tags: ["module-3", "engineering-drawing", "cad"]
          },
          {
            id: "caed-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK",
            previewUrl: "https://drive.google.com/file/d/1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "4.2",
            tags: ["module-4", "engineering-drawing", "cad"]
          },
          {
            id: "caed-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK",
            previewUrl: "https://drive.google.com/file/d/1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "4.2",
            tags: ["module-5", "engineering-drawing", "cad"]
          },
          {
            id: "caed-6",
            title: "Question Paper",
            description: "Past question paper for CAED",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK",
            previewUrl: "https://drive.google.com/file/d/1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "3.5",
            tags: ["PYQ", "question-paper", "exam"]
          },
          {
            id: "caed-7",
            title: "Question Bank",
            description: "Question bank for CAED",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK",
            previewUrl: "https://drive.google.com/file/d/1Fc3yVkZZ2aBnQ5fiuGPxHKZ79tDIAgRK/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.5",
            tags: ["question-bank", "practice", "questions"]
          },
        ],
      },
      {
        title: "Professional Writing Skills in English",
        code: "BPWSK206",
        vtuCode: "BPWSK206",
        credits: 2,
        modules: [
          {
            id: "english2-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RsTzr_2in3Ht-iAVJj2nhR_6iAU6aTY4",
            previewUrl: "https://drive.google.com/file/d/1RsTzr_2in3Ht-iAVJj2nhR_6iAU6aTY4/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.2",
            tags: ["module-1", "english", "writing"]
          },
          {
            id: "english2-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RsTzr_2in3Ht-iAVJj2nhR_6iAU6aTY4",
            previewUrl: "https://drive.google.com/file/d/1RsTzr_2in3Ht-iAVJj2nhR_6iAU6aTY4/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-2", "english", "writing"]
          },
          {
            id: "english2-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RsTzr_2in3Ht-iAVJj2nhR_6iAU6aTY4",
            previewUrl: "https://drive.google.com/file/d/1RsTzr_2in3Ht-iAVJj2nhR_6iAU6aTY4/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.2",
            tags: ["module-3", "english", "writing"]
          },
          {
            id: "english2-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RsTzr_2in3Ht-iAVJj2nhR_6iAU6aTY4",
            previewUrl: "https://drive.google.com/file/d/1RsTzr_2in3Ht-iAVJj2nhR_6iAU6aTY4/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.2",
            tags: ["module-4", "english", "writing"]
          },
          {
            id: "english2-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RsTzr_2in3Ht-iAVJj2nhR_6iAU6aTY4",
            previewUrl: "https://drive.google.com/file/d/1RsTzr_2in3Ht-iAVJj2nhR_6iAU6aTY4/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.2",
            tags: ["module-5", "english", "writing"]
          },
        ],
      },
      {
        title: "Samskrutika Kannada",
        code: "BKSKK207",
        vtuCode: "BKSKK207",
        credits: 2,
        modules: [
          {
            id: "kannada-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=18Te010SE2eAZNBvhmCDHnKjH4kyqCvPr",
            previewUrl: "https://drive.google.com/file/d/18Te010SE2eAZNBvhmCDHnKjH4kyqCvPr/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.0",
            tags: ["module-1", "kannada", "language"]
          },
          {
            id: "kannada-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=18Te010SE2eAZNBvhmCDHnKjH4kyqCvPr",
            previewUrl: "https://drive.google.com/file/d/18Te010SE2eAZNBvhmCDHnKjH4kyqCvPr/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.0",
            tags: ["module-2", "kannada", "language"]
          },
          {
            id: "kannada-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=18Te010SE2eAZNBvhmCDHnKjH4kyqCvPr",
            previewUrl: "https://drive.google.com/file/d/18Te010SE2eAZNBvhmCDHnKjH4kyqCvPr/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.0",
            tags: ["module-3", "kannada", "language"]
          },
          {
            id: "kannada-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=18Te010SE2eAZNBvhmCDHnKjH4kyqCvPr",
            previewUrl: "https://drive.google.com/file/d/18Te010SE2eAZNBvhmCDHnKjH4kyqCvPr/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.0",
            tags: ["module-4", "kannada", "language"]
          },
          {
            id: "kannada-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=18Te010SE2eAZNBvhmCDHnKjH4kyqCvPr",
            previewUrl: "https://drive.google.com/file/d/18Te010SE2eAZNBvhmCDHnKjH4kyqCvPr/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.0",
            tags: ["module-5", "kannada", "language"]
          },
          {
            id: "kannada-6",
            title: "Question Paper",
            description: "Past question paper for Samskrutika Kannada",
            fileUrl: "https://drive.google.com/uc?export=download&id=1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0",
            previewUrl: "https://drive.google.com/file/d/1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.5",
            tags: ["PYQ", "question-paper", "exam"]
          },
          {
            id: "kannada-7",
            title: "Question Bank",
            description: "Question bank for Samskrutika Kannada",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.2",
            tags: ["question-bank", "practice", "questions"]
          },
        ],
      },
      {
        title: "Innovation and Design Thinking",
        code: "BIDTK258",
        vtuCode: "BIDTK258",
        credits: 2,
        modules: [
          {
            id: "idt-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1gH6HN4aKKjH-PIhUOPBQBZJYI3m0bdRG",
            previewUrl: "https://drive.google.com/file/d/1gH6HN4aKKjH-PIhUOPBQBZJYI3m0bdRG/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-1", "innovation", "design-thinking"]
          },
          {
            id: "idt-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=10_XpzvURU7n9fTqu0PpEIEBnEEvS7xCZ",
            previewUrl: "https://drive.google.com/file/d/10_XpzvURU7n9fTqu0PpEIEBnEEvS7xCZ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-2", "innovation", "design-thinking"]
          },
          {
            id: "idt-9",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=10_XpzvURU7n9fTqu0PpEIEBnEEvS7xCZ",
            previewUrl: "https://drive.google.com/file/d/10_XpzvURU7n9fTqu0PpEIEBnEEvS7xCZ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-2", "innovation", "design-thinking"]
          },
          {
            id: "idt-9",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=10_XpzvURU7n9fTqu0PpEIEBnEEvS7xCZ",
            previewUrl: "https://drive.google.com/file/d/10_XpzvURU7n9fTqu0PpEIEBnEEvS7xCZ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-2", "innovation", "design-thinking"]
          },
          {
            id: "idt-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RtljOIxNyCEN8zr0g5eLA7VCI0ocfDUT",
            previewUrl: "https://drive.google.com/file/d/1RtljOIxNyCEN8zr0g5eLA7VCI0ocfDUT/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.6",
            tags: ["module-3", "innovation", "design-thinking"]
          },
          {
            id: "idt-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1kiWFMMzf5c4JdZ1-Y5wpJeEjyD3kze3w",
            previewUrl: "https://drive.google.com/file/d/1kiWFMMzf5c4JdZ1-Y5wpJeEjyD3kze3w/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.4",
            tags: ["module-4", "innovation", "design-thinking"]
          },
          {
            id: "idt-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1kiWFMMzf5c4JdZ1-Y5wpJeEjyD3kze3w",
            previewUrl: "https://drive.google.com/file/d/1kiWFMMzf5c4JdZ1-Y5wpJeEjyD3kze3w/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.4",
            tags: ["module-5", "innovation", "design-thinking"]
          },
          {
            id: "idt-6",
            title: "Question Paper",
            description: "Past question paper for Innovation and Design Thinking",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cb5HxUCDqcRz9VxyLF6di55NKhlmuYYF",
            previewUrl: "https://drive.google.com/file/d/1Cb5HxUCDqcRz9VxyLF6di55NKhlmuYYF/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["PYQ", "question-paper", "exam"]
          },
          {
            id: "idt-7",
            title: "Question Bank",
            description: "Question bank for Innovation and Design Thinking",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cb5HxUCDqcRz9VxyLF6di55NKhlmuYYF",
            previewUrl: "https://drive.google.com/file/d/1Cb5HxUCDqcRz9VxyLF6di55NKhlmuYYF/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.0",
            tags: ["question-bank", "practice", "questions"]
          },
        ],
      },
      {
        title: "Introduction to Electrical Engineering",
        code: "BESCK104/204B",
        vtuCode: "BESCK104/204B",
        credits: 3,
        modules: [
          {
            id: "elec-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1xPPIkAHaOdAQp3axlMRqs-NenKxszI4_",
            previewUrl: "https://drive.google.com/file/d/1xPPIkAHaOdAQp3axlMRqs-NenKxszI4_/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.8",
            tags: ["module-1", "electrical", "engineering"]
          },
          {
            id: "elec-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1_dhN72FrHIF_SKWjnmHMPTotq3pjKxLZ",
            previewUrl: "https://drive.google.com/file/d/1_dhN72FrHIF_SKWjnmHMPTotq3pjKxLZ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.5",
            tags: ["module-2", "electrical", "engineering"]
          },
          {
            id: "elec-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1kKijLrPMLH2VAUULszKSt7tHPNLILlMu",
            previewUrl: "https://drive.google.com/file/d/1kKijLrPMLH2VAUULszKSt7tHPNLILlMu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.6",
            tags: ["module-3", "electrical", "engineering"]
          },
          {
            id: "elec-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1H0aicsDIdGfwoT3UcZ5XXGyswiwL9PXc",
            previewUrl: "https://drive.google.com/file/d/1H0aicsDIdGfwoT3UcZ5XXGyswiwL9PXc/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.4",
            tags: ["module-4", "electrical", "engineering"]
          },
          {
            id: "elec-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1H0aicsDIdGfwoT3UcZ5XXGyswiwL9PXc",
            previewUrl: "https://drive.google.com/file/d/1H0aicsDIdGfwoT3UcZ5XXGyswiwL9PXc/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.4",
            tags: ["module-5", "electrical", "engineering"]
          },
          {
            id: "elec-6",
            title: "Question Paper",
            description: "Past question paper for Electrical Engineering",
            fileUrl: "https://drive.google.com/uc?export=download&id=1H0aicsDIdGfwoT3UcZ5XXGyswiwL9PXc",
            previewUrl: "https://drive.google.com/file/d/1H0aicsDIdGfwoT3UcZ5XXGyswiwL9PXc/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["PYQ", "question-paper", "exam"]
          },
          {
            id: "elec-7",
            title: "Question Bank",
            description: "Question bank for Electrical Engineering",
            fileUrl: "https://drive.google.com/uc?export=download&id=1H0aicsDIdGfwoT3UcZ5XXGyswiwL9PXc",
            previewUrl: "https://drive.google.com/file/d/1H0aicsDIdGfwoT3UcZ5XXGyswiwL9PXc/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.0",
            tags: ["question-bank", "practice", "questions"]
          },
        ],
      },
    ],

  },
  cse: {
    3: [
      {
        title: "Mathematics For CSE",
        code: "BMATS301",
        vtuCode: "BMATS301",
        credits: 4,
        modules: [
          {
            id: "math3-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/file/d/1wMnLoK_lPI8G46cs94yCWv074OwXpS7B",
            previewUrl: "https://drive.google.com/file/d/1wMnLoK_lPI8G46cs94yCWv074OwXpS7B/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-25",
            fileSize: "3.8",
            tags: ["module-1", "mathematics", "theory"]
          },
          {
            id: "math3-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/file/d/1sr418op6UVyOSJBjNNLjereec4Ms98qE",
            previewUrl: "https://drive.google.com/file/d/1sr418op6UVyOSJBjNNLjereec4Ms98qE/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-25",
            fileSize: "3.5",
            tags: ["module-2", "mathematics", "theory"]
          },
          {
            id: "math3-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/file/d/1ioqyxJxAO64HRLBJFn24CaToa6m6fR7W",
            previewUrl: "https://drive.google.com/file/d/1ioqyxJxAO64HRLBJFn24CaToa6m6fR7W/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.6",
            tags: ["module-3", "mathematics", "theory"]
          },
          {
            id: "math3-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/file/d/1Flfs8mR4DT3Tk97rn19Bjvh8Oj-_L-Xp",
            previewUrl: "https://drive.google.com/file/d/1Flfs8mR4DT3Tk97rn19Bjvh8Oj-_L-Xp/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.4",
            tags: ["module-4", "mathematics", "theory"]
          },
          {
            id: "math3-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/file/d/1fKYDtg4pRm8-gv2HqUo1b3r0nw5A7Vxf",
            previewUrl: "https://drive.google.com/file/d/1fKYDtg4pRm8-gv2HqUo1b3r0nw5A7Vxf/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.2",
            tags: ["module-5", "mathematics", "theory"]
          },
          {
            id: "math3-6",
            title: "Hand Book",
            description: "Hand Book for Mathematics M3 for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1sw60XigOotMxYz7Z-kg4OOhCP_rTHosA",
            previewUrl: "https://drive.google.com/file/d/1sw60XigOotMxYz7Z-kg4OOhCP_rTHosA/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "4.2",
            tags: ["handbook", "reference", "complete"]
          },
          {
            id: "math3-7",
            title: "Model Question Paper Solutions 1",
            description: "Model Question Paper Solutions for Mathematics",
            fileUrl: "https://drive.google.com/file/d/1hgCehi2mfVkYhNfveEEZqCgLLoW4RIFF",
            previewUrl: "https://drive.google.com/file/d/1hgCehi2mfVkYhNfveEEZqCgLLoW4RIFF/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.8",
            tags: ["model-paper", "solutions", "practice"]
          },
          {
            id: "math3-8",
            title: "Model Question Paper Solutions 2",
            description: "Model Question Paper Solutions for Mathematics",
            fileUrl: "https://drive.google.com/uc?export=download&id=1nPXbLEwRwi_Kqe6ZErRvWNcUEHWyeK2c",
            previewUrl: "https://drive.google.com/file/d/1nPXbLEwRwi_Kqe6ZErRvWNcUEHWyeK2c/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-30",
            fileSize: "3.6",
            tags: ["model-paper", "solutions", "practice"]
          },
          {
            id: "math3-9",
            title: "Previous Year Question Paper",
            description: "Previous Year Question Paper for Mathematics",
            fileUrl: "https://drive.google.com/file/d/1tN6tJ98BmS1r_Z6LagP4S8JS-mqLPTnf",
            previewUrl: "https://drive.google.com/file/d/1tN6tJ98BmS1r_Z6LagP4S8JS-mqLPTnf/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-02-01",
            fileSize: "2.8",
            tags: ["PYQ", "previous-year", "exam"]
          },
          {
            id: "math3-10",
            title: "Question Bank",
            description: "Question Bank for Mathematics",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ZlfCQX1dAHU6UERsaOlEiA4PeSKWWNk5",
            previewUrl: "https://drive.google.com/file/d/1ZlfCQX1dAHU6UERsaOlEiA4PeSKWWNk5/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-02-03",
            fileSize: "3.5",
            tags: ["question-bank", "practice", "questions"]
          },
        ],
      },
      {
        title: "Digital Design and Computer Organization",
        code: "BCS302",
        vtuCode: "BCS302",
        credits: 4,
        modules: [
          {
            id: "ddco-1",
            title: "Module 1: Notes",
            description: "Introduction to Digital Design",
            fileUrl: "https://drive.google.com/uc?export=download&id=17Xcfk02ShPbiC68v30mR64JyLN8Zlxo6",
            previewUrl: "https://drive.google.com/file/d/17Xcfk02ShPbiC68v30mR64JyLN8Zlxo6/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.8",
            tags: ["module-1", "digital-design", "theory"]
          },
          {
            id: "ddco-2",
            title: "Module 2: Notes",
            description: "Combinational Logic",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ImRmWzwac1ZO39qNLDdSD8DvjPKBwpcp",
            previewUrl: "https://drive.google.com/file/d/1ImRmWzwac1ZO39qNLDdSD8DvjPKBwpcp/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.5",
            tags: ["module-2", "combinational", "logic"]
          },
          {
            id: "ddco-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1IBDOIlh_HHs7KF5GS6BzCuEyYH50gS0U",
            previewUrl: "https://drive.google.com/file/d/1IBDOIlh_HHs7KF5GS6BzCuEyYH50gS0U/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.6",
            tags: ["module-3", "digital-design", "theory"]
          },
          {
            id: "ddco-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Tg3_F919P-Ll4l_QP85dnoSfuTxDtsKk",
            previewUrl: "https://drive.google.com/file/d/1Tg3_F919P-Ll4l_QP85dnoSfuTxDtsKk/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.4",
            tags: ["module-4", "computer-organization", "theory"]
          },
          {
            id: "ddco-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ekZbe8Uef5enZtEffWbkgM6Qe7OAlFoo",
            previewUrl: "https://drive.google.com/file/d/1ekZbe8Uef5enZtEffWbkgM6Qe7OAlFoo/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.2",
            tags: ["module-5", "computer-organization", "theory"]
          },
          {
            id: "ddco-6",
            title: "Module 1: HandWritten Notes",
            description: "Handwritten notes for Module 1",
            fileUrl: "https://drive.google.com/file/d/1nKKthJhBO8Od_64exVgNg9SCbdjYG-_Z",
            previewUrl: "https://drive.google.com/file/d/1nKKthJhBO8Od_64exVgNg9SCbdjYG-_Z/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-25",
            fileSize: "4.0",
            tags: ["handwritten", "module-1", "digital-design"]
          },
          {
            id: "ddco-7",
            title: "Module 2: HandWritten Notes",
            description: "Handwritten notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1wYZXAgA_1lWUmI7VWoEGi2bKeLB3c1Ga",
            previewUrl: "https://drive.google.com/file/d/1wYZXAgA_1lWUmI7VWoEGi2bKeLB3c1Ga/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.8",
            tags: ["handwritten", "module-2", "combinational"]
          },
          {
            id: "ddco-8",
            title: "Question Paper",
            description: "Past question paper for DDCO",
            fileUrl: "https://drive.google.com/file/d/1NiPGff-dHUVkhmlroj51BvWtax-2odpG/view?usp=d",
            previewUrl: "https://drive.google.com/file/d/1NiPGff-dHUVkhmlroj51BvWtax-2odpG/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-30",
            fileSize: "2.8",
            tags: ["PYQ", "question-paper", "exam"]
          },
          {
            id: "ddco-9",
            title: "Question Bank With Answers",
            description: "Question bank with answers for DDCO",
            fileUrl: "https://drive.google.com/uc?export=download&id=1xROR5IqItpPVinhNgAJ0RBexaho7LEcE",
            previewUrl: "https://drive.google.com/file/d/1xROR5IqItpPVinhNgAJ0RBexaho7LEcE/preview",
            type: "solutions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-02-01",
            fileSize: "4.2",
            tags: ["question-bank", "solutions", "answers"]
          },
          {
            id: "ddco-10",
            title: "Sample Question Paper Solved 1",
            description: "Sample question paper with solutions",
            fileUrl: "https://drive.google.com/file/d/1vjXxgwsn3Saq320ihRb7TSCqrftQmEJj",
            previewUrl: "https://drive.google.com/file/d/1vjXxgwsn3Saq320ihRb7TSCqrftQmEJj/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-03",
            fileSize: "3.8",
            tags: ["sample-paper", "solutions", "practice"]
          },
          {
            id: "ddco-11",
            title: "Sample Question Paper Solved 2",
            description: "Sample question paper with solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1xROR5IqItpPVinhNgAJ0RBexaho7LEcE",
            previewUrl: "https://drive.google.com/file/d/1xROR5IqItpPVinhNgAJ0RBexaho7LEcE/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-05",
            fileSize: "4.0",
            tags: ["sample-paper", "solutions", "practice"]
          },
          {
            id: "ddco-12",
            title: "Module wise Question Bank",
            description: "Module-wise question bank for DDCO",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Iv1twGqOay_6AgutRMQ0ith-5rbcniR_",
            previewUrl: "https://drive.google.com/file/d/1Iv1twGqOay_6AgutRMQ0ith-5rbcniR_/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-02-07",
            fileSize: "3.6",
            tags: ["module-wise", "question-bank", "practice"]
          },
        ],
      },
      {
        title: "OPERATING SYSTEMS",
        code: "BCS303",
        vtuCode: "21CS33/33",
        credits: 4,
        modules: [
          {
            id: "os-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1rIRXuo8dlDKCeMF3M5dfHOBk4pH1u7-a",
            previewUrl: "https://drive.google.com/file/d/1rIRXuo8dlDKCeMF3M5dfHOBk4pH1u7-a/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.8",
            tags: ["module-1", "operating-systems", "theory"]
          },
          {
            id: "os-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1JV1vRbkjEqoHAAzTWwpxJY1Kn2TNlNPd",
            previewUrl: "https://drive.google.com/file/d/1JV1vRbkjEqoHAAzTWwpxJY1Kn2TNlNPd/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.5",
            tags: ["module-2", "operating-systems", "theory"]
          },
          {
            id: "os-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1lyXnXMBt6kv3kKNMiE3Dmzizsu-KAw20",
            previewUrl: "https://drive.google.com/file/d/1lyXnXMBt6kv3kKNMiE3Dmzizsu-KAw20/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.6",
            tags: ["module-3", "operating-systems", "theory"]
          },
          {
            id: "os-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1rDoTPJ7b6p0UuaftTjgGqqclFROvbBFn",
            previewUrl: "https://drive.google.com/file/d/1rDoTPJ7b6p0UuaftTjgGqqclFROvbBFn/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.4",
            tags: ["module-4", "operating-systems", "theory"]
          },
          {
            id: "os-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Kg26VTSML1ycedhsZe4h3Quq4sgI2cD9",
            previewUrl: "https://drive.google.com/file/d/1Kg26VTSML1ycedhsZe4h3Quq4sgI2cD9/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.2",
            tags: ["module-5", "operating-systems", "theory"]
          },
          {
            id: "os-6",
            title: "Previous Year Question Paper",
            description: "Previous Year Question Paper for OS",
            fileUrl: "https://drive.google.com/file/d/15HBsmBHnOXNhRycK_8pQ0pfTpUIjplMt",
            previewUrl: "https://drive.google.com/file/d/15HBsmBHnOXNhRycK_8pQ0pfTpUIjplMt/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["PYQ", "previous-year", "exam"]
          },
          {
            id: "os-7",
            title: "Passing Question And Answer",
            description: "Important questions with answers for OS",
            fileUrl: "https://drive.google.com/uc?export=download&id=1LZTpPvlsoJKFuyVyIseHuRxbVqdIqw9Y",
            previewUrl: "https://drive.google.com/file/d/1LZTpPvlsoJKFuyVyIseHuRxbVqdIqw9Y/preview",
            type: "solutions",
            category: "important-questions",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.5",
            tags: ["important", "questions", "answers"]
          },
          {
            id: "os-8",
            title: "Question Bank",
            description: "Question bank for Operating Systems",
            fileUrl: "https://drive.google.com/file/d/1enDKUJLGxdjgsEMOuEeNiQFaoQP9m7gN",
            previewUrl: "https://drive.google.com/file/d/1enDKUJLGxdjgsEMOuEeNiQFaoQP9m7gN/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-30",
            fileSize: "3.8",
            tags: ["question-bank", "practice", "questions"]
          },

           {
            id: "os-9",
            title: "Question Bank-02",
            description: "Question bank  for Operating Systems problems",
            fileUrl: "https://drive.google.com/file/d/1enDKUJLGxdjgsEMOuEeNiQFaoQP9m7gN",
            previewUrl: "https://drive.google.com/file/d/1enDKUJLGxdjgsEMOuEeNiQFaoQP9m7gN/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-30",
            fileSize: "3.8",
            tags: ["question-bank", "practice", "questions", "problems"]
          },
          {
            id: "os-10",
            title: "Module 1-5: HandWritten Notes",
            description: "Handwritten notes for Module 1",
            fileUrl: "https://drive.google.com/file/d/1fo9ZxihWN3YXgLnu1W8kiaaROxGbCLnH",
            previewUrl: "https://drive.google.com/file/d/1fo9ZxihWN3YXgLnu1W8kiaaROxGbCLnH/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-25",
            fileSize: "4.0",
            tags: ["handwritten", "module-1", "HandwrittenALLModules"]
          },
           {
            id: "os-11",
            title: "ALL Question important-questions",
            description: "All question papers for Operating Systems",
            fileUrl: "https://drive.google.com/file/d/1vA13taepu_xwYmq6-SQkLbORsEBQm-IU",
            previewUrl: "https://drive.google.com/file/d/1vA13taepu_xwYmq6-SQkLbORsEBQm-IU/preview",
            type: "important-questions",
            category: "important-questions",
            essential: true,
            uploadedDate: "2025-03-12",
            fileSize: "4.5",
            tags: ["all-papers", "collection", "exam"]
          },

          {
            id: "os-12",
            title: "Previous Year Question Paper",
            description: "Previous Year Question Paper - BCS303",
            fileUrl: "https://drive.google.com/file/d/1AFqAjGQhSeD9ATfkdMQoa_sAQP7GSSSJ/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1AFqAjGQhSeD9ATfkdMQoa_sAQP7GSSSJ/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "operating-systems", "bcs303"]
          }
        ],
      },
      {
        title: "DATA STRUCTURES AND APPLICATIONS",
        code: "BCS304",
        vtuCode: "BCS304",
        credits: 4,
        modules: [
          {
            id: "dsa-1",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/file/d/1WV-nCHFlWs9xghqSSiMxi03XC9LkJsut",
            previewUrl: "https://drive.google.com/file/d/1WV-nCHFlWs9xghqSSiMxi03XC9LkJsut/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-2", "data-structures", "theory"]
          },
           {
            id: "dsa-8",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/file/d/1uPLLZ8O7DKno1RPoBM50WqYVUZXvnLGs",
            previewUrl: "https://drive.google.com/file/d/1uPLLZ8O7DKno1RPoBM50WqYVUZXvnLGs/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-2", "data-structures", "theory"]
          },
          {
            id: "dsa-2",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1HQxcfYqsHJyII7rd_2vuYZBI0srTO95s",
            previewUrl: "https://drive.google.com/file/d/1HQxcfYqsHJyII7rd_2vuYZBI0srTO95s/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-3", "data-structures", "theory"]
          },
          {
            id: "dsa-3",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1yOHt9GHZR2vzglQ3JxhRCY_j9mh6M7rK",
            previewUrl: "https://drive.google.com/file/d/1yOHt9GHZR2vzglQ3JxhRCY_j9mh6M7rK/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.8",
            tags: ["module-4", "data-structures", "theory"]
          },
          {
            id: "dsa-4",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1E53vCWzN6WWbUZ37VHRESlznDMPvSfC5",
            previewUrl: "https://drive.google.com/file/d/1E53vCWzN6WWbUZ37VHRESlznDMPvSfC5/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.6",
            tags: ["module-5", "data-structures", "theory"]
          },
          {
            id: "dsa-5",
            title: "Previous Year Question Paper",
            description: "Previous Year Question Paper for DSA",
            fileUrl: "https://drive.google.com/file/d/1GLq4quNzdSomnGh6Y2ilFvjQuXM9JO6z",
            previewUrl: "https://drive.google.com/file/d/1GLq4quNzdSomnGh6Y2ilFvjQuXM9JO6z/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "2.8",
            tags: ["PYQ", "previous-year", "exam"]
          },
          {
            id: "dsa-6",
            title: "Question Paper With Solutions",
            description: "Question paper with solutions for DSA",
            fileUrl: "https://drive.google.com/uc?export=download&id=1NT_kKeN4Z0UiW-OhHwgq-8vxWoW2RRAS",
            previewUrl: "https://drive.google.com/file/d/1NT_kKeN4Z0UiW-OhHwgq-8vxWoW2RRAS/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "4.2",
            tags: ["solutions", "question-paper", "answers"]
          },
          {
            id: "dsa-7",
            title: "Question Bank",
            description: "Question bank for Data Structures",
            fileUrl: "https://drive.google.com/file/d/16hGQQlfOdePqioOpN0oBN8ZbQBAzlA2X",
            previewUrl: "https://drive.google.com/file/d/16hGQQlfOdePqioOpN0oBN8ZbQBAzlA2X/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.8",
            tags: ["question-bank", "practice", "questions"]
          },
          {
            id: "dsa-9",
            title: "ALL Question important-questions",
            description: "All question papers for Operating Systems",
            fileUrl: "https://drive.google.com/file/d/16hGQQlfOdePqioOpN0oBN8ZbQBAzlA2X",
            previewUrl: "https://drive.google.com/file/d/16hGQQlfOdePqioOpN0oBN8ZbQBAzlA2X/preview",
            type: "important-questions",
            category: "important-questions",
            essential: true,
            uploadedDate: "2025-03-12",
            fileSize: "4.5",
            tags: ["all-papers", "collection", "exam"]
          },
          {
            id: "dsa-10",
            title: "Previous Year Question Paper",
            description: "Previous Year Question Paper - BCS304",
            fileUrl: "https://drive.google.com/file/d/1ACZ7ewUdJsN5eHMdMLJDyArxfMXSbIca/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1ACZ7ewUdJsN5eHMdMLJDyArxfMXSbIca/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "dsa", "bcs304"]
          }
        ],
      },
      {
        title: "Object Oriented Programming with JAVA",
        code: "BCS306A'",
        vtuCode: "BCS306A'",
        credits: 4,
        modules: [
          {
            id: "java-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1_FYFYH-jMk0iTJdbD3KzvyCzPaZARhgY",
            previewUrl: "https://drive.google.com/file/d/1_FYFYH-jMk0iTJdbD3KzvyCzPaZARhgY/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.8",
            tags: ["module-1", "java", "oop"]
          },
          {
            id: "java-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1XZY3CWnQ1Nw-5JOVlX4yzXFwEonN8i7V",
            previewUrl: "https://drive.google.com/file/d/1XZY3CWnQ1Nw-5JOVlX4yzXFwEonN8i7V/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.5",
            tags: ["module-2", "java", "oop"]
          },
          {
            id: "java-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1jItwo8T0w5FjGZsnk7k427TE4eZ_Idur",
            previewUrl: "https://drive.google.com/file/d/1jItwo8T0w5FjGZsnk7k427TE4eZ_Idur/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.6",
            tags: ["module-3", "java", "oop"]
          },
          {
            id: "java-4",
            title: "Module 4 and 5: Notes",
            description: "Comprehensive notes for Module 4 and 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=162G10sOkk5L8dd2o4REW0jBcWsi2XY1M",
            previewUrl: "https://drive.google.com/file/d/162G10sOkk5L8dd2o4REW0jBcWsi2XY1M/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "4.2",
            tags: ["module-4", "module-5", "java"]
          },
          {
            id: "java-5",
            title: "Module 1 and 2: Notes Question Bank",
            description: "Question Bank for Module 1 and 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1q05hkIDeTilr4zqIaEwGFD_daN7hpIw5",
            previewUrl: "https://drive.google.com/file/d/1q05hkIDeTilr4zqIaEwGFD_daN7hpIw5/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.8",
            tags: ["question-bank", "module-1", "module-2"]
          },
          {
            id: "java-6",
            title: "Module 3: Notes Question Bank",
            description: "Question Bank for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1wj3e8ibE2BGqbmyS-CgKRk6_0SDAegF1",
            previewUrl: "https://drive.google.com/file/d/1wj3e8ibE2BGqbmyS-CgKRk6_0SDAegF1/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "3.5",
            tags: ["question-bank", "module-3", "java"]
          },
          {
            id: "java-7",
            title: "Module 4,5: Notes Question Bank",
            description: "Question Bank for Module 4 and 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=18ybC3I6mC6EuuioRCmV5Vj2yz77bmPL9",
            previewUrl: "https://drive.google.com/file/d/18ybC3I6mC6EuuioRCmV5Vj2yz77bmPL9/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.6",
            tags: ["question-bank", "module-4", "module-5"]
          },
          {
            id: "java-8",
            title: "Previous Year Question Paper",
            description: "Previous Year Question Paper for Java",
            fileUrl: "https://drive.google.com/uc?export=download&id=15AxKh0_v5kcOybfxEQniFcHBRz7ywQUH",
            previewUrl: "https://drive.google.com/file/d/15AxKh0_v5kcOybfxEQniFcHBRz7ywQUH/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-30",
            fileSize: "2.8",
            tags: ["PYQ", "previous-year", "exam"]
          },
          {
            id: "java-9",
            title: "Model Question Paper Solutions",
            description: "Model Question Paper Solutions for Java",
            fileUrl: "https://drive.google.com/file/d/1iVE_rPUCBYQKJU9OKhZ8D_zmI33D8a7T",
            previewUrl: "https://drive.google.com/file/d/1iVE_rPUCBYQKJU9OKhZ8D_zmI33D8a7T/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-01",
            fileSize: "4.0",
            tags: ["model-paper", "solutions", "practice"]
          },
          {
            id: "java-10",
            title: "All modules notes",
            description: "Complete notes for all modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Sv7zn3oq8E1cqv_l4JNH-F_FrxQvpgD6",
            previewUrl: "https://drive.google.com/file/d/1Sv7zn3oq8E1cqv_l4JNH-F_FrxQvpgD6/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-03",
            fileSize: "5.2",
            tags: ["complete", "all-modules", "java"]
          },
          {
            id: "java-11",
            title: "Question Paper",
            description: "Question paper for Java",
            fileUrl: "https://drive.google.com/uc?export=download&id=1pert6LRVKbuT2XJ-vfaMSs9D_IvxixUv",
            previewUrl: "https://drive.google.com/file/d/1pert6LRVKbuT2XJ-vfaMSs9D_IvxixUv/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-02-05",
            fileSize: "3.0",
            tags: ["question-paper", "exam", "java"]
          },
          {
            id: "java-12",
            title: "Lab Manual",
            description: "Lab manual for Java programming",
            fileUrl: "https://drive.google.com/uc?export=download&id=159A_S3C9ipXLJCoZDt1CjRrY49svfuPU",
            previewUrl: "https://drive.google.com/file/d/159A_S3C9ipXLJCoZDt1CjRrY49svfuPU/preview",
            type: "notes",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-02-07",
            fileSize: "4.5",
            tags: ["lab-manual", "practical", "java"]
          },
          {
            id: "java-13",
            title: "Previous Year Question Paper",
            description: "Previous Year Question Paper - BCS306A",
            fileUrl: "https://drive.google.com/file/d/1OFU-2H6hGy6AddWa1AGItHVu8W-tb-NQ/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1OFU-2H6hGy6AddWa1AGItHVu8W-tb-NQ/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "java", "bcs306a"]
          }
        ],
      },
      {
        title: "OBJECT ORIENTED PROGRAMMING with C++",
        code: "BCS306B",
        vtuCode: "BCS306B",
        credits: 3,
        modules: [
          {
            id: "cpp-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1_RfN83ev0JKW1Qd60UJnaNj2Z-mO2DWM",
            previewUrl: "https://drive.google.com/file/d/1_RfN83ev0JKW1Qd60UJnaNj2Z-mO2DWM/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.8",
            tags: ["module-1", "c++", "oop"]
          },
          {
            id: "cpp-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Wd7PYicstD6Im-d1sdsOavyDvhlZw38w",
            previewUrl: "https://drive.google.com/file/d/1Wd7PYicstD6Im-d1sdsOavyDvhlZw38w/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.5",
            tags: ["module-2", "c++", "oop"]
          },
          {
            id: "cpp-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Wd7PYicstD6Im-d1sdsOavyDvhlZw38w",
            previewUrl: "https://drive.google.com/file/d/1Wd7PYicstD6Im-d1sdsOavyDvhlZw38w/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.5",
            tags: ["module-3", "c++", "oop"]
          },
          {
            id: "cpp-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1j0OIKwBlkWTw07wKWB8quBHIIgv98AoP",
            previewUrl: "https://drive.google.com/file/d/1j0OIKwBlkWTw07wKWB8quBHIIgv98AoP/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.6",
            tags: ["module-4", "c++", "oop"]
          },
          {
            id: "cpp-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1mNOnt2Tvkegvx-zAvGelFCC4bmwOfIV3",
            previewUrl: "https://drive.google.com/file/d/1mNOnt2Tvkegvx-zAvGelFCC4bmwOfIV3/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.4",
            tags: ["module-5", "c++", "oop"]
          },
          {
            id: "cpp-6",
            title: "Question Paper",
            description: "Question paper for C++",
            fileUrl: "https://drive.google.com/uc?export=download&id=1mNOnt2Tvkegvx-zAvGelFCC4bmwOfIV3",
            previewUrl: "https://drive.google.com/file/d/1mNOnt2Tvkegvx-zAvGelFCC4bmwOfIV3/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["question-paper", "exam", "c++"]
          },
          {
            id: "cpp-7",
            title: "Question Bank",
            description: "Question bank for C++",
            fileUrl: "https://drive.google.com/uc?export=download&id=1mNOnt2Tvkegvx-zAvGelFCC4bmwOfIV3",
            previewUrl: "https://drive.google.com/file/d/1mNOnt2Tvkegvx-zAvGelFCC4bmwOfIV3/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.0",
            tags: ["question-bank", "practice", "c++"]
          },
          {
            id: "cpp-8",
            title: "Previous Year Question Paper",
            description: "Previous Year Question Paper - BCS306B",
            fileUrl: "https://drive.google.com/file/d/1N-cgZloM_NdhwAMmMELojjdcQHI3HzPv/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1N-cgZloM_NdhwAMmMELojjdcQHI3HzPv/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "c++", "bcs306b"]
          }
        ],
      },
      {
        title: "DATA STRUCTURES LABORATORY",
        code: "",
        vtuCode: "",
        credits: 2,
        modules: [
          {
            id: "dslab-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1muk8PYpH-w2OHQrpSF7cPDTwnL_4e7qs",
            previewUrl: "https://drive.google.com/file/d/1muk8PYpH-w2OHQrpSF7cPDTwnL_4e7qs/preview",
            type: "notes",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-1", "lab", "data-structures"]
          },
          {
            id: "dslab-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "notes",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-2", "lab", "data-structures"]
          },
          {
            id: "dslab-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0",
            previewUrl: "https://drive.google.com/file/d/1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0/preview",
            type: "notes",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.8",
            tags: ["module-3", "lab", "data-structures"]
          },
          {
            id: "dslab-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1muk8PYpH-w2OHQrpSF7cPDTwnL_4e7qs",
            previewUrl: "https://drive.google.com/file/d/1muk8PYpH-w2OHQrpSF7cPDTwnL_4e7qs/preview",
            type: "notes",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.5",
            tags: ["module-4", "lab", "data-structures"]
          },
          {
            id: "dslab-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "notes",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.2",
            tags: ["module-5", "lab", "data-structures"]
          },
          {
            id: "dslab-6",
            title: "Question Paper",
            description: "Question paper for Data Structures Lab",
            fileUrl: "https://drive.google.com/uc?export=download&id=1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0",
            previewUrl: "https://drive.google.com/file/d/1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.5",
            tags: ["question-paper", "exam", "lab"]
          },
          {
            id: "dslab-7",
            title: "Question Bank",
            description: "Question bank for Data Structures Lab",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.0",
            tags: ["question-bank", "practice", "lab"]
          },
        ],
      },
      {
        title: "Social Connect & Responsibility",
        code: "21SCR38",
        vtuCode: "21SCR38/38",
        credits: 1,
        modules: [
          {
            id: "scr-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1muk8PYpH-w2OHQrpSF7cPDTwnL_4e7qs",
            previewUrl: "https://drive.google.com/file/d/1muk8PYpH-w2OHQrpSF7cPDTwnL_4e7qs/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "2.8",
            tags: ["module-1", "social", "responsibility"]
          },
          {
            id: "scr-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "2.5",
            tags: ["module-2", "social", "responsibility"]
          },
          {
            id: "scr-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0",
            previewUrl: "https://drive.google.com/file/d/1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "2.8",
            tags: ["module-3", "social", "responsibility"]
          },
          {
            id: "scr-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1muk8PYpH-w2OHQrpSF7cPDTwnL_4e7qs",
            previewUrl: "https://drive.google.com/file/d/1muk8PYpH-w2OHQrpSF7cPDTwnL_4e7qs/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "2.8",
            tags: ["module-4", "social", "responsibility"]
          },
          {
            id: "scr-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "2.5",
            tags: ["module-5", "social", "responsibility"]
          },
          {
            id: "scr-6",
            title: "Question Paper",
            description: "Question paper for Social Connect & Responsibility",
            fileUrl: "https://drive.google.com/uc?export=download&id=1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0",
            previewUrl: "https://drive.google.com/file/d/1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.2",
            tags: ["question-paper", "exam", "social"]
          },
          {
            id: "scr-7",
            title: "Question Bank",
            description: "Question bank for Social Connect & Responsibility",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "2.5",
            tags: ["question-bank", "practice", "social"]
          },
        ],
      },
    ],
    4: [
      {
        title: "Analysis & Design of Algorithms",
        code: "BCS402",
        vtuCode: "BCS402",
        credits: 4,
        modules: [
          {
            id: "ada-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=135I6KMJ1MIq-vSNONF3c8kR2mLElEJ_5",
            previewUrl: "https://drive.google.com/file/d/135I6KMJ1MIq-vSNONF3c8kR2mLElEJ_5/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.8",
            tags: ["module-1", "algorithms", "analysis"]
          },
          {
            id: "ada-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1J_yd0l-cfRByzqRTW60gcDs8Ku1ik15l",
            previewUrl: "https://drive.google.com/file/d/1J_yd0l-cfRByzqRTW60gcDs8Ku1ik15l/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.5",
            tags: ["module-2", "algorithms", "design"]
          },
          {
            id: "ada-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=16or942srHaywuhLBQeegJuHPHyQA6wJ9",
            previewUrl: "https://drive.google.com/file/d/16or942srHaywuhLBQeegJuHPHyQA6wJ9/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.6",
            tags: ["module-3", "algorithms", "analysis"]
          },
          {
            id: "ada-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Vj0yQcZxBF5-bnXxiDzeexWDCHZDSJrY",
            previewUrl: "https://drive.google.com/file/d/1Vj0yQcZxBF5-bnXxiDzeexWDCHZDSJrY/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.4",
            tags: ["module-4", "algorithms", "design"]
          },
          {
            id: "ada-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Vj0yQcZxBF5-bnXxiDzeexWDCHZDSJrY",
            previewUrl: "https://drive.google.com/file/d/1Vj0yQcZxBF5-bnXxiDzeexWDCHZDSJrY/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.4",
            tags: ["module-5", "algorithms", "analysis"]
          },
          {
            id: "ada-6",
            title: "Question Papers with solutions",
            description: "Question papers with solutions for Algorithms",
            fileUrl: "https://drive.google.com/uc?export=download&id=1U-laCBUAydCFwnqFW5nmPgGHVWv3lPt1",
            previewUrl: "https://drive.google.com/file/d/1U-laCBUAydCFwnqFW5nmPgGHVWv3lPt1/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "4.2",
            tags: ["solutions", "question-papers", "exam"]
          },
        ],
      },
      {
        title: "MICROCONTROLLERS",
        code: "BCS402",
        vtuCode: "BCS402",
        credits: 4,
        modules: [
          {
            id: "micro-1",
            title: "Module 1: Notes",
            description: "Introduction to Microcontrollers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1EMoMc0Y-JfSwheP5Z7RD5N97dFtds4m4",
            previewUrl: "https://drive.google.com/file/d/1EMoMc0Y-JfSwheP5Z7RD5N97dFtds4m4/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.8",
            tags: ["module-1", "microcontrollers", "introduction"]
          },
          {
            id: "micro-2",
            title: "Module 2: Notes",
            description: "Microcontroller Architecture",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Xl1kyr0BRimocDCGDYS3e2N6qghVunw6",
            previewUrl: "https://drive.google.com/file/d/1Xl1kyr0BRimocDCGDYS3e2N6qghVunw6/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.5",
            tags: ["module-2", "architecture", "microcontrollers"]
          },
          {
            id: "micro-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=163Jtzh-qZBT4Y_ybP0Oru6v96VDL7mgu",
            previewUrl: "https://drive.google.com/file/d/163Jtzh-qZBT4Y_ybP0Oru6v96VDL7mgu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.6",
            tags: ["module-3", "microcontrollers", "theory"]
          },
          {
            id: "micro-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1UVpPakkPiRr5aGFOdZK4g6C9Pv1Tux6I",
            previewUrl: "https://drive.google.com/file/d/1UVpPakkPiRr5aGFOdZK4g6C9Pv1Tux6I/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.4",
            tags: ["module-4", "microcontrollers", "applications"]
          },
          {
            id: "micro-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1gBPIaF-2ArT1_t0sbkvzWXh8RNbhz6WL",
            previewUrl: "https://drive.google.com/file/d/1gBPIaF-2ArT1_t0sbkvzWXh8RNbhz6WL/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.2",
            tags: ["module-5", "microcontrollers", "advanced"]
          },
          {
            id: "micro-6",
            title: "PYQ",
            description: "Previous Year Question Paper 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1bFd7GbQA6GycngDouhlvhnjNAoPW6t6q",
            previewUrl: "https://drive.google.com/file/d/1bFd7GbQA6GycngDouhlvhnjNAoPW6t6q/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["PYQ", "question-paper", "exam"]
          },
          {
            id: "micro-7",
            title: "PYQ",
            description: "Previous Year Question Paper 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1aVBwZ8K9iHTS_uTiROIZjYcNovQUbv3b",
            previewUrl: "https://drive.google.com/file/d/1aVBwZ8K9iHTS_uTiROIZjYcNovQUbv3b/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "2.6",
            tags: ["PYQ", "question-paper", "exam"]
          },
        ],
      },
      {
        title: "DATABASE MANAGEMENT SYSTEM",
        code: "BCS403",
        vtuCode: "BCS403",
        credits: 4,
        modules: [
          {
            id: "dbms-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1n1__pgOLZE_r1eMy3Cq_ds4L6mVs874j",
            previewUrl: "https://drive.google.com/file/d/1n1__pgOLZE_r1eMy3Cq_ds4L6mVs874j/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.8",
            tags: ["module-1", "dbms", "database"]
          },
          {
            id: "dbms-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1qNasFNTZzzJVu0KmGyopb-6Dhuh4Xj6m",
            previewUrl: "https://drive.google.com/file/d/1qNasFNTZzzJVu0KmGyopb-6Dhuh4Xj6m/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.5",
            tags: ["module-2", "dbms", "sql"]
          },
          {
            id: "dbms-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1H3O_uleWOhfIF8D4lzxNJCyDrIBn0TYf",
            previewUrl: "https://drive.google.com/file/d/1H3O_uleWOhfIF8D4lzxNJCyDrIBn0TYf/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.6",
            tags: ["module-3", "dbms", "normalization"]
          },
          {
            id: "dbms-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1nXR1qjmQpMgkR-CuM2pPEU_OPdLYVn8-",
            previewUrl: "https://drive.google.com/file/d/1nXR1qjmQpMgkR-CuM2pPEU_OPdLYVn8-/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.4",
            tags: ["module-4", "dbms", "transactions"]
          },
          {
            id: "dbms-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1vfHVSP0s9yIwy3981iRsCoThaQUZXij7",
            previewUrl: "https://drive.google.com/file/d/1vfHVSP0s9yIwy3981iRsCoThaQUZXij7/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.2",
            tags: ["module-5", "dbms", "advanced"]
          },
          {
            id: "dbms-6",
            title: "Question Paper",
            description: "Question paper for DBMS",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ZIuMbL4yJbnBgp8NrU-PqwO35udCZlA1",
            previewUrl: "https://drive.google.com/file/d/1ZIuMbL4yJbnBgp8NrU-PqwO35udCZlA1/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["question-paper", "exam", "dbms"]
          },
        ],
      },
      {
        title: "DISCRETE MATHEMATICAL STRUCTURES",
        code: "BCS405A",
        vtuCode: "BCS405A",
        credits: 4,
        modules: [
          {
            id: "dms-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1qMa9r_JFzeczxadAG0jMmIPVBnFZcJ4M",
            previewUrl: "https://drive.google.com/file/d/1qMa9r_JFzeczxadAG0jMmIPVBnFZcJ4M/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-1", "discrete", "mathematics"]
          },
          {
            id: "dms-2",
            title: "Module 1: Notes",
            description: "Additional notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1onVWqZzob1p3pJ--A2t4TwHeoRQZ_Qjy",
            previewUrl: "https://drive.google.com/file/d/1onVWqZzob1p3pJ--A2t4TwHeoRQZ_Qjy/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-1", "discrete", "sets"]
          },
          {
            id: "dms-3",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1V8WLIHttGjc3_IMgLx6p-6S39SSFpTaO",
            previewUrl: "https://drive.google.com/file/d/1V8WLIHttGjc3_IMgLx6p-6S39SSFpTaO/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.8",
            tags: ["module-2", "discrete", "relations"]
          },
          {
            id: "dms-4",
            title: "Module 3-1: Notes",
            description: "Comprehensive notes for Module 3 Part 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=15GXogCcBWNjCFPAGDzx63TfNn1DHbLmR",
            previewUrl: "https://drive.google.com/file/d/15GXogCcBWNjCFPAGDzx63TfNn1DHbLmR/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.6",
            tags: ["module-3", "discrete", "graphs"]
          },
          {
            id: "dms-5",
            title: "Module 3-2: Notes",
            description: "Comprehensive notes for Module 3 Part 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=15rZluF7iK1_50nR_8yx1wqO73J_KCYUG",
            previewUrl: "https://drive.google.com/file/d/15rZluF7iK1_50nR_8yx1wqO73J_KCYUG/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.4",
            tags: ["module-3", "discrete", "trees"]
          },
          {
            id: "dms-6",
            title: "Question Paper",
            description: "Question paper for Discrete Mathematics",
            fileUrl: "https://drive.google.com/uc?export=download&id=1rFJKUntE4UNWRL1IMg2QjWzkVoeEFeuG",
            previewUrl: "https://drive.google.com/file/d/1rFJKUntE4UNWRL1IMg2QjWzkVoeEFeuG/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["question-paper", "exam", "discrete"]
          },
          {
            id: "dms-7",
            title: "Model Question Paper Solution",
            description: "Model question paper with solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1wiliZvzo0-Zc2E_UMZDhXuNa2mKgKjw5",
            previewUrl: "https://drive.google.com/file/d/1wiliZvzo0-Zc2E_UMZDhXuNa2mKgKjw5/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "4.0",
            tags: ["model-paper", "solutions", "practice"]
          },
          {
            id: "dms-8",
            title: "Question Paper June/July 2024 Solution",
            description: "June/July 2024 question paper solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=10bsSqzZMxz-Ve1DldYWZ1Sv7wAhKNUYT",
            previewUrl: "https://drive.google.com/file/d/10bsSqzZMxz-Ve1DldYWZ1Sv7wAhKNUYT/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-30",
            fileSize: "3.8",
            tags: ["2024", "solutions", "recent"]
          },
        ],
      },
      {
        title: "Computer Graphics and Visualization",
        code: "BCG402",
        vtuCode: "BCG402",
        credits: 3,
        modules: [
          {
            id: "cgv-1",
            title: "Module 1: Notes",
            description: "Study material for Module 1",
            fileUrl: "https://drive.google.com/file/d/1wi50xrFyj2Qm1P_OdxMhzx0Gsi2p3iuR/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1wi50xrFyj2Qm1P_OdxMhzx0Gsi2p3iuR/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "—",
            tags: ["module-1", "computer-graphics", "visualization"]
          },
          {
            id: "cgv-2",
            title: "Module 2: Notes",
            description: "Study material for Module 2",
            fileUrl: "https://drive.google.com/file/d/1OmvJ0qHlC3K0HwuoDaYO_gxL69nHd6ua/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1OmvJ0qHlC3K0HwuoDaYO_gxL69nHd6ua/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "—",
            tags: ["module-2", "computer-graphics", "visualization"]
          },
          {
            id: "cgv-3",
            title: "Module 3: Notes",
            description: "Study material for Module 3",
            fileUrl: "https://drive.google.com/file/d/1nPiQjUwU0ycI9WHcnht-gUryn_aEFo3Z/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1nPiQjUwU0ycI9WHcnht-gUryn_aEFo3Z/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "—",
            tags: ["module-3", "computer-graphics", "visualization"]
          },
          {
            id: "cgv-4",
            title: "Module 4: Notes",
            description: "Study material for Module 4",
            fileUrl: "https://drive.google.com/file/d/1snY1h-45ZfEFE6LRmfJ6b75aZ_kRCPM8/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1snY1h-45ZfEFE6LRmfJ6b75aZ_kRCPM8/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "—",
            tags: ["module-4", "computer-graphics", "visualization"]
          },
          {
            id: "cgv-5",
            title: "Module 5: Notes",
            description: "Study material for Module 5",
            fileUrl: "https://drive.google.com/file/d/1-dMQYXb3CyRQlQPNkszAf62BKCMoyisa/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1-dMQYXb3CyRQlQPNkszAf62BKCMoyisa/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "—",
            tags: ["module-5", "computer-graphics", "visualization"]
          },
          {
            id: "cgv-6",
            title: "Model Question Paper (MQP)",
            description: "Model Question Paper for Computer Graphics",
            fileUrl: "https://drive.google.com/file/d/1DoyyiVA985WIJymbFa0hCyWmzAOI6pb1/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1DoyyiVA985WIJymbFa0hCyWmzAOI6pb1/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "—",
            tags: ["mqp", "model-paper", "computer-graphics"]
          }
        ]
      },
      {
        title: "GRAPH THEORY",
        code: "BCS405B",
        vtuCode: "BCS405B",
        credits: 3,
        modules: [
          {
            id: "graph-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1qxvOHrVApg0wi2AwLTpp_0dAaVSojYHk",
            previewUrl: "https://drive.google.com/file/d/1qxvOHrVApg0wi2AwLTpp_0dAaVSojYHk/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-1", "graph-theory", "basics"]
          },
          {
            id: "graph-2",
            title: "Module 1: Notes",
            description: "Additional notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1dN7Oilwe875Kk3hRdpd3TQqs6_hznS-5",
            previewUrl: "https://drive.google.com/file/d/1dN7Oilwe875Kk3hRdpd3TQqs6_hznS-5/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-1", "graph-theory", "introduction"]
          },
          {
            id: "graph-3",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1L5NmNHOPyutMGby6IqqqbTl8h34kpGsS",
            previewUrl: "https://drive.google.com/file/d/1L5NmNHOPyutMGby6IqqqbTl8h34kpGsS/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.8",
            tags: ["module-2", "graph-theory", "connectivity"]
          },
          {
            id: "graph-4",
            title: "Module 2: Notes",
            description: "Additional notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=18EF-lYMgoR-AqTZ9SQXFy7-p3JQLkZgK",
            previewUrl: "https://drive.google.com/file/d/18EF-lYMgoR-AqTZ9SQXFy7-p3JQLkZgK/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.6",
            tags: ["module-2", "graph-theory", "paths"]
          },
          {
            id: "graph-5",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=121Fs3LqOK7hPbIFTB75BBzmvdpoP0Vhi",
            previewUrl: "https://drive.google.com/file/d/121Fs3LqOK7hPbIFTB75BBzmvdpoP0Vhi/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.4",
            tags: ["module-3", "graph-theory", "trees"]
          },
          {
            id: "graph-6",
            title: "Module 4 and 5: Notes",
            description: "Comprehensive notes for Module 4 and 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1aU5nIgPWUYdA1ou4c9_pYbBoGUQFD-Wd",
            previewUrl: "https://drive.google.com/file/d/1aU5nIgPWUYdA1ou4c9_pYbBoGUQFD-Wd/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "4.2",
            tags: ["module-4", "module-5", "graph-theory"]
          },
          {
            id: "graph-7",
            title: "Module 4 & 5: Notes",
            description: "Additional notes for Module 4 and 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1GpBgOazBXvVWIppxvOf29zPVtm9wTOpM",
            previewUrl: "https://drive.google.com/file/d/1GpBgOazBXvVWIppxvOf29zPVtm9wTOpM/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "4.0",
            tags: ["module-4", "module-5", "advanced"]
          },
          {
            id: "graph-8",
            title: "Question Papers",
            description: "Collection of question papers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Jdgxk2UiVeXb-TJJywapMucYhW_HLqj3",
            previewUrl: "https://drive.google.com/file/d/1Jdgxk2UiVeXb-TJJywapMucYhW_HLqj3/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-30",
            fileSize: "3.5",
            tags: ["question-papers", "collection", "exam"]
          },
          {
            id: "graph-9",
            title: "All In One Question Papers",
            description: "Complete collection of question papers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Sb3hCekSG3Z9fdEq0H_qRqxTzz7w8XIE",
            previewUrl: "https://drive.google.com/file/d/1Sb3hCekSG3Z9fdEq0H_qRqxTzz7w8XIE/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-02-01",
            fileSize: "4.5",
            tags: ["complete", "question-bank", "all"]
          },
          {
            id: "graph-10",
            title: "MQP-01 SOL",
            description: "Model Question Paper 1 Solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=15m3xXKv-Os6JlQI6QvlTnBet7lI2ynCx",
            previewUrl: "https://drive.google.com/file/d/15m3xXKv-Os6JlQI6QvlTnBet7lI2ynCx/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-03",
            fileSize: "3.8",
            tags: ["model-paper", "solutions", "mqp-1"]
          },
          {
            id: "graph-11",
            title: "MQP-2 SOL",
            description: "Model Question Paper 2 Solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1JYXanZ2aJXagTh-aAv3G0G2GuhV5KuqN",
            previewUrl: "https://drive.google.com/file/d/1JYXanZ2aJXagTh-aAv3G0G2GuhV5KuqN/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-05",
            fileSize: "3.6",
            tags: ["model-paper", "solutions", "mqp-2"]
          },
          {
            id: "graph-12",
            title: "Question Paper",
            description: "Additional question paper",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Sssc99LmtoGGYh6KyMx2jHcV-pHt02WS",
            previewUrl: "https://drive.google.com/file/d/1Sssc99LmtoGGYh6KyMx2jHcV-pHt02WS/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-02-07",
            fileSize: "2.8",
            tags: ["question-paper", "exam", "graph-theory"]
          },
          {
            id: "graph-13",
            title: "Question Bank",
            description: "Question bank for Graph Theory",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Sssc99LmtoGGYh6KyMx2jHcV-pHt02WS",
            previewUrl: "https://drive.google.com/file/d/1Sssc99LmtoGGYh6KyMx2jHcV-pHt02WS/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-02-09",
            fileSize: "3.2",
            tags: ["question-bank", "practice", "graph-theory"]
          },
        ],
      },
      {
        title: "Analysis & Design of Algorithms Lab",
        code: "BCSL404",
        vtuCode: "BCSL404",
        credits: 2,
        modules: [
          {
            id: "adalab-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Sssc99LmtoGGYh6KyMx2jHcV-pHt02WS",
            previewUrl: "https://drive.google.com/file/d/1Sssc99LmtoGGYh6KyMx2jHcV-pHt02WS/preview",
            type: "notes",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-1", "lab", "algorithms"]
          },
          {
            id: "adalab-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "notes",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-2", "lab", "algorithms"]
          },
          {
            id: "adalab-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0",
            previewUrl: "https://drive.google.com/file/d/1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0/preview",
            type: "notes",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.8",
            tags: ["module-3", "lab", "algorithms"]
          },
          {
            id: "adalab-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1muk8PYpH-w2OHQrpSF7cPDTwnL_4e7qs",
            previewUrl: "https://drive.google.com/file/d/1muk8PYpH-w2OHQrpSF7cPDTwnL_4e7qs/preview",
            type: "notes",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.6",
            tags: ["module-4", "lab", "algorithms"]
          },
          {
            id: "adalab-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "notes",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.2",
            tags: ["module-5", "lab", "algorithms"]
          },
          {
            id: "adalab-6",
            title: "Question Paper",
            description: "Question paper for Algorithms Lab",
            fileUrl: "https://drive.google.com/uc?export=download&id=1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0",
            previewUrl: "https://drive.google.com/file/d/1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["question-paper", "exam", "lab"]
          },
          {
            id: "adalab-7",
            title: "Question Bank",
            description: "Question bank for Algorithms Lab",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.0",
            tags: ["question-bank", "practice", "lab"]
          },
        ],
      },
      {
        title: "ARTIFICIAL INTELLIGENCE",
        code: "BAD402",
        vtuCode: "BAD402",
        credits: 3,
        modules: [
          {
            id: "ai-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.8",
            tags: ["module-1", "ai", "introduction"]
          },
          {
            id: "ai-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.8",
            tags: ["module-2", "ai", "search"]
          },
          {
            id: "ai-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.8",
            tags: ["module-3", "ai", "knowledge"]
          },
          {
            id: "ai-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.8",
            tags: ["module-4", "ai", "planning"]
          },
          {
            id: "ai-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.8",
            tags: ["module-5", "ai", "learning"]
          },
          {
            id: "ai-6",
            title: "Question Paper",
            description: "Question paper for AI",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["question-paper", "exam", "ai"]
          },
          {
            id: "ai-7",
            title: "Question Bank",
            description: "Question bank for AI",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.0",
            tags: ["question-bank", "practice", "ai"]
          },
        ],
      },
      {
        title: "BIOLOGY FOR ENGINEERS",
        code: "BCS405C",
        vtuCode: "'BCS405C",
        credits: 2,
        modules: [
          {
            id: "bio-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1T8wYGZdPx8V0QeGDMb3cAOifdLFZXoZk",
            previewUrl: "https://drive.google.com/file/d/1T8wYGZdPx8V0QeGDMb3cAOifdLFZXoZk/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-1", "biology", "introduction"]
          },
          {
            id: "bio-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Tkra5ZzuWkKlfd99gBlp97EhjYzIAUXj",
            previewUrl: "https://drive.google.com/file/d/1Tkra5ZzuWkKlfd99gBlp97EhjYzIAUXj/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-2", "biology", "cells"]
          },
          {
            id: "bio-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=19VqgzZgvaE5Wt_aDcuR7pQH2StnzAqRF",
            previewUrl: "https://drive.google.com/file/d/19VqgzZgvaE5Wt_aDcuR7pQH2StnzAqRF/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.8",
            tags: ["module-3", "biology", "genetics"]
          },
          {
            id: "bio-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1mR8sVnrpFZlFhQd61EsdBQ5u6N5IKWPd",
            previewUrl: "https://drive.google.com/file/d/1mR8sVnrpFZlFhQd61EsdBQ5u6N5IKWPd/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.6",
            tags: ["module-4", "biology", "biotechnology"]
          },
          {
            id: "bio-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=12NRJCozzG3BmFdob8kcHd8Oe2yYx0xQ8",
            previewUrl: "https://drive.google.com/file/d/12NRJCozzG3BmFdob8kcHd8Oe2yYx0xQ8/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.4",
            tags: ["module-5", "biology", "applications"]
          },
          {
            id: "bio-6",
            title: "Question Paper",
            description: "Question paper for Biology",
            fileUrl: "https://drive.google.com/uc?export=download&id=1h_udrhNRqd0UiwdM8bVeH_PTXyWsVcKB",
            previewUrl: "https://drive.google.com/file/d/1h_udrhNRqd0UiwdM8bVeH_PTXyWsVcKB/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "2.8",
            tags: ["question-paper", "exam", "biology"]
          },
          {
            id: "bio-7",
            title: "Question Paper 2",
            description: "Additional question paper",
            fileUrl: "https://drive.google.com/uc?export=download&id=1aD7ZjnBroS5GvDCcULUJ-F9mrkRgU826",
            previewUrl: "https://drive.google.com/file/d/1aD7ZjnBroS5GvDCcULUJ-F9mrkRgU826/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "2.6",
            tags: ["question-paper", "exam", "biology"]
          },
        ],
      },
    ],
    5: [
      {
        title: "Software Engineering & Project Management",
        code: "BCS501",
        vtuCode: "BCS501",
        credits: 4,
        modules: [
          {
            id: "sepm-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=14htN4dswag4Pm9tuqWnQOCPvUB8-BQMo",
            previewUrl: "https://drive.google.com/file/d/14htN4dswag4Pm9tuqWnQOCPvUB8-BQMo/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-01",
            fileSize: "3.5",
            tags: ["module-1", "software-engineering", "project-management"]
          },
          {
            id: "sepm-2",
            title: "Module 1: New Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1qQrjUOTMKHEKZt9RsBqAZ5ejtNf5fq_J",
            previewUrl: "https://drive.google.com/file/d/1qQrjUOTMKHEKZt9RsBqAZ5ejtNf5fq_J/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-03",
            fileSize: "3.8",
            tags: ["module-1", "updated", "software-engineering"]
          },
          {
            id: "sepm-3",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1-RibizuedU-k5TgYSk9panOpyoSogNvC",
            previewUrl: "https://drive.google.com/file/d/1-RibizuedU-k5TgYSk9panOpyoSogNvC/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-05",
            fileSize: "3.6",
            tags: ["module-2", "software-engineering", "requirements"]
          },
          {
            id: "sepm-4",
            title: "Module 2: New Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1AY06kg3xmclh-wM815S2gjHgzZTIhCn9",
            previewUrl: "https://drive.google.com/file/d/1AY06kg3xmclh-wM815S2gjHgzZTIhCn9/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-07",
            fileSize: "3.7",
            tags: ["module-2", "updated", "design"]
          },
          {
            id: "sepm-5",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1bAm05nOtffFzZ6rEhRp1VCjQTqrb86Fz",
            previewUrl: "https://drive.google.com/file/d/1bAm05nOtffFzZ6rEhRp1VCjQTqrb86Fz/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-09",
            fileSize: "3.9",
            tags: ["module-3", "software-engineering", "testing"]
          },
          {
            id: "sepm-6",
            title: "Module 3: New Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1g49h6F8cegbTlEYchutMDahr9DuP0AZB",
            previewUrl: "https://drive.google.com/file/d/1g49h6F8cegbTlEYchutMDahr9DuP0AZB/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-11",
            fileSize: "4.1",
            tags: ["module-3", "updated", "quality-assurance"]
          },
          {
            id: "sepm-7",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1cpPl4-NTAs09C9gplu6s53m-FblYikpk",
            previewUrl: "https://drive.google.com/file/d/1cpPl4-NTAs09C9gplu6s53m-FblYikpk/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-13",
            fileSize: "3.8",
            tags: ["module-4", "project-management", "planning"]
          },
          {
            id: "sepm-8",
            title: "Module 4: New Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ZiykwzFKrVrF0lV2jXKRVmwUjM7h0Eaj",
            previewUrl: "https://drive.google.com/file/d/1ZiykwzFKrVrF0lV2jXKRVmwUjM7h0Eaj/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-15",
            fileSize: "4.0",
            tags: ["module-4", "updated", "scheduling"]
          },
          {
            id: "sepm-9",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1uFRlNWRLIu07OrMl_IhYRTmyFaJNxx0E",
            previewUrl: "https://drive.google.com/file/d/1uFRlNWRLIu07OrMl_IhYRTmyFaJNxx0E/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-17",
            fileSize: "3.7",
            tags: ["module-5", "risk-management", "maintenance"]
          },
          {
            id: "sepm-10",
            title: "Module 5: New Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1LydiLZek-2_n2klxXLyCwiilhtpjuLCu",
            previewUrl: "https://drive.google.com/file/d/1LydiLZek-2_n2klxXLyCwiilhtpjuLCu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-19",
            fileSize: "3.9",
            tags: ["module-5", "updated", "agile"]
          },
          {
            id: "sepm-11",
            title: "All Module: Notes",
            description: "Comprehensive notes for all modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=1W5YQTnHRW9lpHG3j-BLABkV72kZwd_fO",
            previewUrl: "https://drive.google.com/file/d/1W5YQTnHRW9lpHG3j-BLABkV72kZwd_fO/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-21",
            fileSize: "5.2",
            tags: ["complete", "all-modules", "comprehensive"]
          },
          {
            id: "sepm-12",
            title: "Model Question Paper Solutions",
            description: "Model question paper solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1aHbJ6mj2m71hYtjnTt-ODAZXLnavDPF4",
            previewUrl: "https://drive.google.com/file/d/1aHbJ6mj2m71hYtjnTt-ODAZXLnavDPF4/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-23",
            fileSize: "4.5",
            tags: ["model-paper", "solutions", "exam-prep"]
          },
          {
            id: "sepm-13",
            title: "Handwritten Question Bank With Answers",
            description: "Handwritten question bank with answers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1TUx_F_ldZje158xHr-7juovCHZanzDQU",
            previewUrl: "https://drive.google.com/file/d/1TUx_F_ldZje158xHr-7juovCHZanzDQU/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-02-25",
            fileSize: "4.8",
            tags: ["handwritten", "question-bank", "answers"]
          },
          {
            id: "sepm-14",
            title: "Question Bank",
            description: "Question bank for Software Engineering",
            fileUrl: "https://drive.google.com/uc?export=download&id=1cgqyDznfxuOM3QmEgtWn0-YBiNv3B-il",
            previewUrl: "https://drive.google.com/file/d/1cgqyDznfxuOM3QmEgtWn0-YBiNv3B-il/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-02-27",
            fileSize: "3.9",
            tags: ["question-bank", "practice", "exam"]
          },
          {
            id: "sepm-15",
            title: "Question Bank with Answer",
            description: "Question bank with answers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Pl8eVmmpfH1ytwraru6A3VMC6vFvelA8",
            previewUrl: "https://drive.google.com/file/d/1Pl8eVmmpfH1ytwraru6A3VMC6vFvelA8/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-03-01",
            fileSize: "4.2",
            tags: ["question-bank", "answers", "solved"]
          },
          {
            id: "sepm-16",
            title: "Text Book",
            description: "Text Book for Software Engineering",
            fileUrl: "https://drive.google.com/uc?export=download&id=184MXwac2OaFvdkX0UIsL8QMcVlCeasce",
            previewUrl: "https://drive.google.com/file/d/184MXwac2OaFvdkX0UIsL8QMcVlCeasce/preview",
            type: "textbook",
            category: "reference",
            essential: true,
            uploadedDate: "2024-03-03",
            fileSize: "8.5",
            tags: ["textbook", "reference", "official"]
          }
        ]
      },
      {
        title: "COMPUTER NETWORKS",
        code: "BCS502",
        vtuCode: "BCS502",
        credits: 4,
        modules: [
          {
            id: "cn-1",
            title: "COMPUTER NETWORKS : SYLLABUS",
            description: "Course syllabus for Computer Networks",
            fileUrl: "https://drive.google.com/uc?export=download&id=1M2MG5Of1KaXjPRADzErO8nMNVG2ZpWxB",
            previewUrl: "https://drive.google.com/file/d/1M2MG5Of1KaXjPRADzErO8nMNVG2ZpWxB/preview",
            type: "syllabus",
            category: "reference",
            essential: true,
            uploadedDate: "2024-02-01",
            fileSize: "1.2",
            tags: ["syllabus", "course-outline", "structure"]
          },
          {
            id: "cn-2",
            title: "Module 1: Notes",
            description: "Introduction to Computer Networks",
            fileUrl: "https://drive.google.com/uc?export=download&id=1kPbN-KeYwX2CS1m_CdbMP13T6z3EppTJ",
            previewUrl: "https://drive.google.com/file/d/1kPbN-KeYwX2CS1m_CdbMP13T6z3EppTJ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-03",
            fileSize: "3.8",
            tags: ["module-1", "networks", "introduction"]
          },
          {
            id: "cn-3",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1zxmlNshpanuaVQr5ouDYaFaSM-fBhkrV",
            previewUrl: "https://drive.google.com/file/d/1zxmlNshpanuaVQr5ouDYaFaSM-fBhkrV/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-05",
            fileSize: "4.1",
            tags: ["module-2", "networks", "protocols"]
          },
          {
            id: "cn-4",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=10bxnMK1Wy4M2cIOh4-o9zjOGTtBMCaXx",
            previewUrl: "https://drive.google.com/file/d/10bxnMK1Wy4M2cIOh4-o9zjOGTtBMCaXx/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-07",
            fileSize: "3.9",
            tags: ["module-3", "networks", "transport"]
          },
          {
            id: "cn-5",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1_DNrrK51JVbFq0cEzBBQY91k_P4hVe80",
            previewUrl: "https://drive.google.com/file/d/1_DNrrK51JVbFq0cEzBBQY91k_P4hVe80/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-09",
            fileSize: "4.0",
            tags: ["module-4", "networks", "network-layer"]
          },
          {
            id: "cn-6",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1CTXPFi-biY3Kk60jlac2ep4LQo41hpsZ",
            previewUrl: "https://drive.google.com/file/d/1CTXPFi-biY3Kk60jlac2ep4LQo41hpsZ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-11",
            fileSize: "3.8",
            tags: ["module-5", "networks", "application-layer"]
          },
          {
            id: "cn-7",
            title: "BCS502 MQP SOLUTION 1",
            description: "Model question paper solutions 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=10ENVRIXIu0mJDN-9HfkDIyciEWItiXb6",
            previewUrl: "https://drive.google.com/file/d/10ENVRIXIu0mJDN-9HfkDIyciEWItiXb6/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-13",
            fileSize: "4.3",
            tags: ["model-paper", "solutions", "mqp-1"]
          },
          {
            id: "cn-8",
            title: "BCS502 MQP SOLUTION 2",
            description: "Model question paper solutions 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1iCTpYPH9_tWGcbeadabuaTno9ZDJnM5D",
            previewUrl: "https://drive.google.com/file/d/1iCTpYPH9_tWGcbeadabuaTno9ZDJnM5D/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-15",
            fileSize: "4.1",
            tags: ["model-paper", "solutions", "mqp-2"]
          },
          {
            id: "cn-9",
            title: "All Module: Notes",
            description: "Comprehensive notes for Module 1 to 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ABvQ3t0q7JHXMM2zPZaD-uQdFPot0LC6",
            previewUrl: "https://drive.google.com/file/d/1ABvQ3t0q7JHXMM2zPZaD-uQdFPot0LC6/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-02-17",
            fileSize: "5.5",
            tags: ["complete", "all-modules", "comprehensive"]
          },
          {
            id: "cn-10",
            title: "CN previous year question paper",
            description: "CN previous year question paper for 2021 scheme for reference",
            fileUrl: "https://drive.google.com/uc?export=download&id=1hN5bPv6Ida2mef6CXeJoE4YXCoZ4UfHr",
            previewUrl: "https://drive.google.com/file/d/1hN5bPv6Ida2mef6CXeJoE4YXCoZ4UfHr/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-02-19",
            fileSize: "3.2",
            tags: ["previous-year", "question-paper", "reference"]
          },
          {
            id: "cn-11",
            title: "CN previous year question paper with solutions",
            description: "CN previous year question paper with solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1yy8X_H3x5hV20nCDUqbMaZ8TLrPOmlZo",
            previewUrl: "https://drive.google.com/file/d/1yy8X_H3x5hV20nCDUqbMaZ8TLrPOmlZo/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-21",
            fileSize: "4.8",
            tags: ["previous-year", "solutions", "solved"]
          },
          {
            id: "cn-12",
            title: "Question Paper",
            description: "Question paper for Computer Networks",
            fileUrl: "https://drive.google.com/uc?export=download&id=1MQ0_LjfVOgeB0UFW6LTSnVjy_4Uw-Z0N",
            previewUrl: "https://drive.google.com/file/d/1MQ0_LjfVOgeB0UFW6LTSnVjy_4Uw-Z0N/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-02-23",
            fileSize: "3.0",
            tags: ["question-paper", "exam", "networks"]
          },
          {
            id: "cn-13",
            title: "Question Bank With Answer",
            description: "Question bank with answers for Computer Networks",
            fileUrl: "https://drive.google.com/uc?export=download&id=13oBzGeclCmHM6ckKBtWdbsw0OfO-NauQ",
            previewUrl: "https://drive.google.com/file/d/13oBzGeclCmHM6ckKBtWdbsw0OfO-NauQ/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-02-25",
            fileSize: "4.6",
            tags: ["question-bank", "answers", "solved"]
          },
          {
            id: "cn-14",
            title: "Text Book",
            description: "Text Book for Computer Networks",
            fileUrl: "https://drive.google.com/uc?export=download&id=1uyAPk03up5k7ZD2IMix7jTq7I-Q6XssR",
            previewUrl: "https://drive.google.com/file/d/1uyAPk03up5k7ZD2IMix7jTq7I-Q6XssR/preview",
            type: "textbook",
            category: "reference",
            essential: true,
            uploadedDate: "2024-02-27",
            fileSize: "9.2",
            tags: ["textbook", "reference", "official"]
          }
        ]
      },
      {
  title: "ARTIFICIAL INTELLIGENCE",
  code: "BCS515B",
  vtuCode: "BCS515B",
  credits: 3,
  modules: [
    {
      id: "ai-1",
      title: "Module 1: Notes",
      description: "Comprehensive notes for Module 1",
      fileUrl: "https://drive.google.com/uc?export=download&id=1mOWeYRy_qV9mmSCykIpuhDv4j96UUPrx",
      previewUrl: "https://drive.google.com/file/d/1mOWeYRy_qV9mmSCykIpuhDv4j96UUPrx/preview",
      type: "notes",
      category: "notes",
      essential: true,
      uploadedDate: "2024-03-01",
      fileSize: "—",
      tags: ["module-1", "ai", "introduction"]
    },
    {
      id: "ai-2",
      title: "Module 2: Notes",
      description: "Comprehensive notes for Module 2",
      fileUrl: "https://drive.google.com/uc?export=download&id=1HiAp5__YrLO0j9AnN1qaZ9Qhh6wESzua",
      previewUrl: "https://drive.google.com/file/d/1HiAp5__YrLO0j9AnN1qaZ9Qhh6wESzua/preview",
      type: "notes",
      category: "notes",
      essential: true,
      uploadedDate: "2024-03-03",
      fileSize: "—",
      tags: ["module-2", "ai", "search-algorithms"]
    },
    {
      id: "ai-3",
      title: "Module 3: Notes",
      description: "Comprehensive notes for Module 3",
      fileUrl: "https://drive.google.com/uc?export=download&id=1WNKkLqFUGeMpz4q7zYdD1zVrgx5ao1EQ",
      previewUrl: "https://drive.google.com/file/d/1WNKkLqFUGeMpz4q7zYdD1zVrgx5ao1EQ/preview",
      type: "notes",
      category: "notes",
      essential: true,
      uploadedDate: "2024-03-05",
      fileSize: "—",
      tags: ["module-3", "ai", "knowledge-representation"]
    },
    {
      id: "ai-4",
      title: "Module 4: Notes",
      description: "Comprehensive notes for Module 4",
      fileUrl: "https://drive.google.com/uc?export=download&id=1YUYrH-d7A0PNbEoOu8nCTk3znY_W2ps5",
      previewUrl: "https://drive.google.com/file/d/1YUYrH-d7A0PNbEoOu8nCTk3znY_W2ps5/preview",
      type: "notes",
      category: "notes",
      essential: true,
      uploadedDate: "2024-03-07",
      fileSize: "—",
      tags: ["module-4", "ai", "planning"]
    },
    {
      id: "ai-5",
      title: "Module 5: Notes",
      description: "Comprehensive notes for Module 5",
      fileUrl: "https://drive.google.com/uc?export=download&id=1DGXmm9bfdj4bAw7NKw--HyXbNJWiMjyc",
      previewUrl: "https://drive.google.com/file/d/1DGXmm9bfdj4bAw7NKw--HyXbNJWiMjyc/preview",
      type: "notes",
      category: "notes",
      essential: true,
      uploadedDate: "2024-03-09",
      fileSize: "—",
      tags: ["module-5", "ai", "machine-learning"]
    },
    {
      id: "ai-6",
      title: "Model Question Paper (MQP)",
      description: "Model Question Paper for AI",
      fileUrl: "https://drive.google.com/uc?export=download&id=1BBPUfcyKaJqLUkCjQFuXK8usTDg55W-e",
      previewUrl: "https://drive.google.com/file/d/1BBPUfcyKaJqLUkCjQFuXK8usTDg55W-e/preview",
      type: "questions",
      category: "model-qp",
      essential: true,
      uploadedDate: "2024-03-11",
      fileSize: "—",
      tags: ["mqp", "exam-prep", "ai"]
    },
    {
      id: "ai-7",
      title: "Model Question Paper – Solution (MQPS)",
      description: "Solutions for Model Question Paper",
      fileUrl: "https://drive.google.com/uc?export=download&id=1y16INSBwfyCL1iQzJ-qhKELLYagNEJ3R",
      previewUrl: "https://drive.google.com/file/d/1y16INSBwfyCL1iQzJ-qhKELLYagNEJ3R/preview",
      type: "solutions",
      category: "solved-qp",
      essential: true,
      uploadedDate: "2024-03-12",
      fileSize: "—",
      tags: ["solutions", "mqp", "ai"]
    },
    {
      id: "ai-8",
      title: "Previous Year Question Paper (Dec–Jan)",
      description: "Dec–Jan Previous Year Question Paper",
      fileUrl: "https://drive.google.com/uc?export=download&id=1jCgaVy29RXmYfUbomWV613fY53YpxTR_",
      previewUrl: "https://drive.google.com/file/d/1jCgaVy29RXmYfUbomWV613fY53YpxTR_/preview",
      type: "questions",
      category: "pyq",
      essential: true,
      uploadedDate: "2024-03-13",
      fileSize: "—",
      tags: ["pyq", "dec-jan", "ai"]
    },
    {
      id: "ai-9",
      title: "Previous Year Question Paper (June–July 2025 Makeup)",
      description: "June–July 2025 Makeup Exam Question Paper",
      fileUrl: "https://drive.google.com/uc?export=download&id=1o5bLKMUiVEYCP7X1vwrv8LFF_2ATZXXd",
      previewUrl: "https://drive.google.com/file/d/1o5bLKMUiVEYCP7X1vwrv8LFF_2ATZXXd/preview",
      type: "questions",
      category: "pyq",
      essential: true,
      uploadedDate: "2025-07-01",
      fileSize: "—",
      tags: ["pyq", "makeup", "ai"]
    },
    {
      id: "ai-10",
      title: "Previous Year Question Paper (June–July 2025)",
      description: "June–July 2025 Question Paper",
      fileUrl: "https://drive.google.com/uc?export=download&id=1X3_5AKVwIdv9UWm9uyPyhv56bqmoig8s",
      previewUrl: "https://drive.google.com/file/d/1X3_5AKVwIdv9UWm9uyPyhv56bqmoig8s/preview",
      type: "questions",
      category: "pyq",
      essential: true,
      uploadedDate: "2025-07-15",
      fileSize: "—",
      tags: ["pyq", "june-july", "ai"]
    }
  ]
      },
  
      {
        title: "FULL STACK DEVELOPMENT",
        code: "21CS55",
        vtuCode: "21CS55/55",
        credits: 3,
        modules: [
          {
            id: "fsd-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "",
            previewUrl: "",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-03-17",
            fileSize: "0",
            tags: ["module-1", "full-stack", "frontend"]
          },
          {
            id: "fsd-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "",
            previewUrl: "",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-03-19",
            fileSize: "0",
            tags: ["module-2", "full-stack", "backend"]
          },
          {
            id: "fsd-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "",
            previewUrl: "",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-03-21",
            fileSize: "0",
            tags: ["module-3", "full-stack", "databases"]
          },
          {
            id: "fsd-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "",
            previewUrl: "",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-03-23",
            fileSize: "0",
            tags: ["module-4", "full-stack", "apis"]
          },
          {
            id: "fsd-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "",
            previewUrl: "",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-03-25",
            fileSize: "0",
            tags: ["module-5", "full-stack", "deployment"]
          },
          {
            id: "fsd-6",
            title: "Question Paper",
            description: "Question paper for Full Stack Development",
            fileUrl: "https://drive.google.com/uc?export=download&id=1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0",
            previewUrl: "https://drive.google.com/file/d/1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-03-27",
            fileSize: "3.0",
            tags: ["question-paper", "exam", "full-stack"]
          },
          {
            id: "fsd-7",
            title: "Question Bank",
            description: "Question bank for Full Stack Development",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-03-29",
            fileSize: "3.5",
            tags: ["question-bank", "practice", "full-stack"]
          }
        ]
      },
      {
        title: "RESEARCH AND METHO AND IPR",
        code: "BRMK557",
        vtuCode: "BRMK557",
        credits: 3,
        modules: [
          {
            id: "rmipr-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/file/d/1o0XGDRWLlgHxxjIbzZob-nk7SxB4d5rS",
            previewUrl: "https://drive.google.com/file/d/1o0XGDRWLlgHxxjIbzZob-nk7SxB4d5rS/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "3.6",
            tags: ["module-1", "research", "methodology"]
          },
          {
            id: "rmipr-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/file/d/1CVV5FFQDCwhxmgmtlUmBk66YxKoMxoB0",
            previewUrl: "https://drive.google.com/file/d/1CVV5FFQDCwhxmgmtlUmBk66YxKoMxoB0/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "3.8",
            tags: ["module-2", "research", "literature-review"]
          },
          {
            id: "rmipr-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/file/d/1H6I3v94zQElgkMEopAqQ9rPXb5jHuXBU/preview",
            previewUrl: "https://drive.google.com/file/d/1H6I3v94zQElgkMEopAqQ9rPXb5jHuXBU/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "3.7",
            tags: ["module-3", "research", "data-analysis"]
          },
          {
            id: "rmipr-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/file/d/11uVrT-3CUb7NQXDSfXUsHpQWGUsBFKL-",
            previewUrl: "https://drive.google.com/file/d/11uVrT-3CUb7NQXDSfXUsHpQWGUsBFKL-/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "3.9",
            tags: ["module-4", "ipr", "patents"]
          },
          {
            id: "rmipr-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/file/d/11uVrT-3CUb7NQXDSfXUsHpQWGUsBFKL-/preview",
            previewUrl: "https://drive.google.com/file/d/11uVrT-3CUb7NQXDSfXUsHpQWGUsBFKL-/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "3.5",
            tags: ["module-5", "ipr", "copyrights"]
          },
          {
            id: "rmipr-6",
            title: "Model Question Papers 1,2,3",
            description: "Model question papers 1, 2, and 3",
            fileUrl: "https://drive.google.com/file/d/1-30gK3LYRL6J1zgepkqzaOmc4OvD0AnG",
            previewUrl: "https://drive.google.com/file/d/1-30gK3LYRL6J1zgepkqzaOmc4OvD0AnG/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "4.2",
            tags: ["model-papers", "multiple", "practice"]
          },
          {
            id: "rmipr-7",
            title: "Model Question Papers 1,2,3 Answers",
            description: "Model question papers with answers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1BBkuv6CHqrWqP7szFL1uzA3gsXzdntCu",
            previewUrl: "https://drive.google.com/file/d/1BBkuv6CHqrWqP7szFL1uzA3gsXzdntCu/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "4.8",
            tags: ["model-papers", "solutions", "answers"]
          },
          {
            id: "rmipr-8",
            title: "Vtu referred textbook",
            description: "VTU referred textbook for Research Methodology and IPR",
            fileUrl: "https://drive.google.com/uc?export=download&id=12O0-tvBgZSwbtYPTUpvAfscoUDC4Xeqy",
            previewUrl: "https://drive.google.com/file/d/12O0-tvBgZSwbtYPTUpvAfscoUDC4Xeqy/preview",
            type: "textbook",
            category: "reference",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "7.5",
            tags: ["textbook", "reference", "vtu"]
          },
          {
            id: "rmipr-9",
            title: "Model Question Paper 1 Answer",
            description: "Model question paper 1 with answer",
            fileUrl: "https://drive.google.com/file/d/1doZ5uKEGadaTKXStgbpREZlKHEGlKbNI",
            previewUrl: "https://drive.google.com/file/d/1doZ5uKEGadaTKXStgbpREZlKHEGlKbNI/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "4.0",
            tags: ["model-paper", "solutions", "answer"]
          },
          {
            id: "rmipr-13",
            title: "Model Question Paper 1 Answer",
            description: "Model question paper 1 with answer",
            fileUrl: "https://drive.google.com/file/d/1iS_zGfCD8DxYnkYr_8Xqsqmuusfs95UQ",
            previewUrl: "https://drive.google.com/file/d/1iS_zGfCD8DxYnkYr_8Xqsqmuusfs95UQ/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "4.0",
            tags: ["model-paper", "solutions", "answer"]
          },
          {
            id: "rmipr-10",
            title: "Syllabus Copy",
            description: "Course syllabus copy",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Yz5HhA-uMsA_C2CQOgD06Xyh5_C2tsHX",
            previewUrl: "https://drive.google.com/file/d/1Yz5HhA-uMsA_C2CQOgD06Xyh5_C2tsHX/preview",
            type: "syllabus",
            category: "reference",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "1.5",
            tags: ["syllabus", "course-outline", "structure"]
          },
          {
            id: "rmipr-11",
            title: "Question Paper",
            description: "Question paper for Research Methodology and IPR",
            fileUrl: "https://drive.google.com/file/d/1-30gK3LYRL6J1zgepkqzaOmc4OvD0AnG/preview",
            previewUrl: "https://drive.google.com/file/d/1-30gK3LYRL6J1zgepkqzaOmc4OvD0AnG/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "3.0",
            tags: ["question-paper", "exam", "research"]
          },
          {
            id: "rmipr-14",
            title: "Module 1 Study Notes: Introduction & Types of Research",
            description: "Comprehensive notes on the meaning, objectives, motivation, and types of engineering research. Covers foundational concepts for Research Methodology.",
            fileUrl: "https://drive.google.com/uc?export=download&id=13NnRHqpgwWeIBTC_-n2zJ07N30bko6QG",
            previewUrl: "https://drive.google.com/file/d/13NnRHqpgwWeIBTC_-n2zJ07N30bko6QG/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "~1.5 MB",
            tags: ["module-1", "introduction", "research-types", "foundation"]
          },
          {
            id: "rmipr-15",
            title: "Module 2 Study Notes: Literature Review & Background",
            description: "Notes detailing the primary goals and importance of literature review in research, including how to connect existing knowledge to new findings.",
            fileUrl: "https://drive.google.com/uc?export=download&id=1mijoqzZNm3_BSimHtVVMJiw31duDtHUr",
            previewUrl: "https://drive.google.com/file/d/1mijoqzZNm3_BSimHtVVMJiw31duDtHUr/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "~1.3 MB",
            tags: ["module-2", "literature-review", "background", "knowledge-foundation"]
          },
          {
            id: "rmipr-18",
            title: "Module 3 Study Notes: Literature Review & Background",
            description: "Notes detailing the primary goals and importance of literature review in research, including how to connect existing knowledge to new findings.",
            fileUrl: "https://drive.google.com/file/d/1XEoeNpfXNQGLu-Ui-UqCBWNcBB2D59ZU",
            previewUrl: "https://drive.google.com/file/d/1XEoeNpfXNQGLu-Ui-UqCBWNcBB2D59ZU/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "~1.3 MB",
            tags: ["module-2", "literature-review", "background", "knowledge-foundation"]
          },

          {
            id: "rmipr-16",
            title: "Module 4 Study Notes: TBD",
            description: "Study notes for Module 4 of Research Methodology and IPR. Content details to be confirmed upon file access.",
            fileUrl: "https://drive.google.com/uc?export=download&id=1jvJK7D10u9PENv0iF95Dka-G8joHKmSR",
            previewUrl: "https://drive.google.com/file/d/1jvJK7D10u9PENv0iF95Dka-G8joHKmSR/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "~1.0 MB",
            tags: ["module-4"]
          },
          {
            id: "rmipr-17",
            title: "Module 5 Study Notes: TBD",
            description: "Study notes for Module 5 of Research Methodology and IPR. Content details to be confirmed upon file access.",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Td0exJs9ggNyIlryHpzvAFNSMX-bPcF4",
            previewUrl: "https://drive.google.com/file/d/1Td0exJs9ggNyIlryHpzvAFNSMX-bPcF4/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "~0.8 MB",
            tags: ["module-5"]
          },
          {
            id: "rmipr-19",
            title: "Importent Questions ",
            description: "Study notes for Module 5 of Research Methodology and IPR. Content details to be confirmed upon file access.",
            fileUrl: "https://drive.google.com/file/d/1d-SzYZ0ICYaKfucCeeIpqRsovFT-UOtG",
            previewUrl: "https://drive.google.com/file/d/1d-SzYZ0ICYaKfucCeeIpqRsovFT-UOtG/preview",
            type: "notes",
            category: "important-questions",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "~0.8 MB",
            tags: ["module-5"]
          },
          {
            id: "rmipr-20",
            title: "PYQ-DEC-JAN",
            description: "Model question papers 1, 2, and 3",
            fileUrl: "https://drive.google.com/file/d/112lKJ-Nbx5_Y-opWoMU0-Z1padwzOJMt",
            previewUrl: "https://drive.google.com/file/d/112lKJ-Nbx5_Y-opWoMU0-Z1padwzOJMt/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "4.2",
            tags: ["model-papers", "multiple", "practice"]
          },
          {
            id: "rmipr-21",
            title: "PYQ_JUNE-JULY",
            description: "Model question papers 1, 2, and 3",
            fileUrl: "https://drive.google.com/file/d/1DYiUNFOI_UH7PpMGAKf_g8MS3ko-ebym",
            previewUrl: "https://drive.google.com/file/d/1DYiUNFOI_UH7PpMGAKf_g8MS3ko-ebym/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "4.2",
            tags: ["model-papers", "multiple", "practice"]
          },
          {
            id: "rmipr-12",
            title: "Question Bank",
            description: "Question bank for Research Methodology and IPR",
            fileUrl: "https://drive.google.com/file/d/1Tvb9MaFIMgO90CNGqjNgnE54LvJZzxPe",
            previewUrl: "https://drive.google.com/file/d/1Tvb9MaFIMgO90CNGqjNgnE54LvJZzxPe/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2026-01-02",
            fileSize: "3.5",
            tags: ["question-bank", "practice", "research"]
          }
        ]
      },
      {
        title: "Environmental Studies",
        code: "21EV57",
        vtuCode: "21EV57/57",
        credits: 1,
        modules: [
          {
            id: "env-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1 with important MCQ and Answers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1yfCrkfXgeO8yUx9wRmX6wz1509qW_GlY",
            previewUrl: "https://drive.google.com/file/d/1yfCrkfXgeO8yUx9wRmX6wz1509qW_GlY/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-05-01",
            fileSize: "4.0",
            tags: ["module-1", "environment", "mcq"]
          },
          {
            id: "env-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2 with important MCQ and Answers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1w9AwlVfM3PsVxngPSS7NETWU6whW1NWd",
            previewUrl: "https://drive.google.com/file/d/1w9AwlVfM3PsVxngPSS7NETWU6whW1NWd/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-05-03",
            fileSize: "3.9",
            tags: ["module-2", "environment", "mcq"]
          },
          {
            id: "env-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3 with important MCQ and Answers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RoIoRI6EnsV-zYuH8CypsDgQ3fYpRiZb",
            previewUrl: "https://drive.google.com/file/d/1RoIoRI6EnsV-zYuH8CypsDgQ3fYpRiZb/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-05-05",
            fileSize: "4.1",
            tags: ["module-3", "environment", "mcq"]
          },
          {
            id: "env-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4 with important MCQ and Answers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RtXR6_GctxPPbdFib0xW2hODsU5-m69k",
            previewUrl: "https://drive.google.com/file/d/1RtXR6_GctxPPbdFib0xW2hODsU5-m69k/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-05-07",
            fileSize: "3.8",
            tags: ["module-4", "environment", "mcq"]
          },
          {
            id: "env-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5 with important MCQ and Answers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1UFLg7HbwbTEUUycO1Lf5XYTNisMF8Mjk",
            previewUrl: "https://drive.google.com/file/d/1UFLg7HbwbTEUUycO1Lf5XYTNisMF8Mjk/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-05-09",
            fileSize: "4.2",
            tags: ["module-5", "environment", "mcq"]
          },
          {
            id: "env-6",
            title: "All Module: Notes Simplified",
            description: "Comprehensive simplified notes for All Modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=1TZndebMHZrzJ3ZNFxo5sGDnjO1_hy0-i",
            previewUrl: "https://drive.google.com/file/d/1TZndebMHZrzJ3ZNFxo5sGDnjO1_hy0-i/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-05-11",
            fileSize: "5.5",
            tags: ["complete", "simplified", "all-modules"]
          },
          {
            id: "env-7",
            title: "All Module: Notes",
            description: "Comprehensive notes for All Modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=1oknJRqu_blQ28SQD-vhJAgw_yo1Mp2aF",
            previewUrl: "https://drive.google.com/file/d/1oknJRqu_blQ28SQD-vhJAgw_yo1Mp2aF/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-05-13",
            fileSize: "6.0",
            tags: ["complete", "detailed", "all-modules"]
          },
          {
            id: "env-8",
            title: "Question Bank",
            description: "Question bank for Environmental Studies",
            fileUrl: "https://drive.google.com/uc?export=download&id=1tW1jd9r3Kof_8Y4SbI592C_BTkrcwL3W",
            previewUrl: "https://drive.google.com/file/d/1tW1jd9r3Kof_8Y4SbI592C_BTkrcwL3W/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-05-15",
            fileSize: "4.5",
            tags: ["question-bank", "practice", "environment"]
          },
          {
            id: "env-9",
            title: "Question Bank 2",
            description: "Additional question bank for Environmental Studies",
            fileUrl: "https://drive.google.com/uc?export=download&id=14fYP5dgZp4EURk-Mr1WeFlWVCeZTeiRt",
            previewUrl: "https://drive.google.com/file/d/14fYP5dgZp4EURk-Mr1WeFlWVCeZTeiRt/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-05-17",
            fileSize: "4.2",
            tags: ["question-bank", "additional", "environment"]
          },
          {
            id: "env-10",
            title: "Question Paper With Answers",
            description: "Question paper with answers for Environmental Studies",
            fileUrl: "https://drive.google.com/uc?export=download&id=1R-hi6-za7sokZhVqQsyKv9m56ge6wDCL",
            previewUrl: "https://drive.google.com/file/d/1R-hi6-za7sokZhVqQsyKv9m56ge6wDCL/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-05-19",
            fileSize: "4.8",
            tags: ["question-paper", "answers", "solved"]
          },
          {
            id: "env-11",
            title: "Question Paper",
            description: "Question paper for Environmental Studies",
            fileUrl: "https://drive.google.com/uc?export=download&id=1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0",
            previewUrl: "https://drive.google.com/file/d/1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-05-21",
            fileSize: "3.0",
            tags: ["question-paper", "exam", "environment"]
          }
        ]
      },
      {
        title: "Unix System Programming",
        code: "BCS515C",
        vtuCode: "BCS515C",
        credits: 2,
        modules: [
          {
            id: "unix-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=18FJ3L2iS5xmoFRhHkP-dXSLCIgsbWYMV",
            previewUrl: "https://drive.google.com/file/d/18FJ3L2iS5xmoFRhHkP-dXSLCIgsbWYMV/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-06-01",
            fileSize: "3.8",
            tags: ["module-1", "unix", "system-programming"]
          },
          {
            id: "unix-2",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1_OFLcnjDroW2P92YjL9AaC8aouxWwzc_",
            previewUrl: "https://drive.google.com/file/d/1_OFLcnjDroW2P92YjL9AaC8aouxWwzc_/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-06-03",
            fileSize: "4.0",
            tags: ["module-3", "unix", "file-systems"]
          },
          {
            id: "unix-3",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1bIP47YM8xyXOW7odP_IzeKgspt9pq8iD",
            previewUrl: "https://drive.google.com/file/d/1bIP47YM8xyXOW7odP_IzeKgspt9pq8iD/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-06-05",
            fileSize: "4.2",
            tags: ["module-4", "unix", "processes"]
          },
          {
            id: "unix-4",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=12Uwd_ACK7vWfnnvTxr0HD7RbuazbloZg",
            previewUrl: "https://drive.google.com/file/d/12Uwd_ACK7vWfnnvTxr0HD7RbuazbloZg/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-06-07",
            fileSize: "3.9",
            tags: ["module-5", "unix", "signals"]
          },
          {
            id: "unix-5",
            title: "Module QP SOLUTION",
            description: "Module question paper solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1TuS1E1iSPJ7G5vyfcreNjq4_m6O6ZFuQ",
            previewUrl: "https://drive.google.com/file/d/1TuS1E1iSPJ7G5vyfcreNjq4_m6O6ZFuQ/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-06-09",
            fileSize: "4.5",
            tags: ["module", "solutions", "exam-prep"]
          },
          {
            id: "unix-6",
            title: "previous year QP SOLUTION",
            description: "Previous year question paper solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=11Siw_HL7A-YPM5S0McJzu4TSwfNZG8lW",
            previewUrl: "https://drive.google.com/file/d/11Siw_HL7A-YPM5S0McJzu4TSwfNZG8lW/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-06-11",
            fileSize: "4.8",
            tags: ["previous-year", "solutions", "solved"]
          },
          {
            id: "unix-7",
            title: "ALL_IN_ONE_QP",
            description: "All-in-one question paper collection",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Blttayw5q6cGL7OLd1ufoV5hGv5PZLPH",
            previewUrl: "https://drive.google.com/file/d/1Blttayw5q6cGL7OLd1ufoV5hGv5PZLPH/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-06-13",
            fileSize: "5.2",
            tags: ["all-in-one", "complete", "question-papers"]
          },
          {
            id: "unix-8",
            title: "MQP",
            description: "Model question paper",
            fileUrl: "https://drive.google.com/uc?export=download&id=1uLiZKT2rA7GMgqMaYzH7IAGu5KcgOSgv",
            previewUrl: "https://drive.google.com/file/d/1uLiZKT2rA7GMgqMaYzH7IAGu5KcgOSgv/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-06-15",
            fileSize: "3.5",
            tags: ["model-paper", "practice", "exam"]
          },
          {
            id: "unix-9",
            title: "Question Paper",
            description: "Question paper for Unix System Programming",
            fileUrl: "https://drive.google.com/uc?export=download&id=1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0",
            previewUrl: "https://drive.google.com/file/d/1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-06-17",
            fileSize: "3.2",
            tags: ["question-paper", "exam", "unix"]
          },
          {
            id: "unix-10",
            title: "Question Bank",
            description: "Question bank for Unix System Programming",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-06-19",
            fileSize: "3.8",
            tags: ["question-bank", "practice", "unix"]
          }
        ]
      },
      {
        title: "THEORY OF COMPUTATION",
        code: "BCS503",
        vtuCode: "BCS503",
        credits: 3,
        modules: [
          {
            id: "toc-1",
            title: "Handwritten notes 1 to 5: Module",
            description: "Comprehensive handwritten notes for all modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=1y5THYjPLyslh5Iee8aM32Ia2alIu2UxE",
            previewUrl: "https://drive.google.com/file/d/1y5THYjPLyslh5Iee8aM32Ia2alIu2UxE/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-03-01",
            fileSize: "5.8",
            tags: ["handwritten", "all-modules", "complete"]
          },
          {
            id: "toc-2",
            title: "BCS503 MQP SOLUTION SAMPLE 1",
            description: "Model question paper solutions sample 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1OfbbBXT1eYl-mAruZYJZzNiRotujQe5E",
            previewUrl: "https://drive.google.com/file/d/1OfbbBXT1eYl-mAruZYJZzNiRotujQe5E/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-03-03",
            fileSize: "4.2",
            tags: ["model-paper", "solutions", "sample-1"]
          },
          {
            id: "toc-3",
            title: "BCS503 MQP 1 SOLUTION SAMPLE 1",
            description: "Model question paper 1 solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1FrvIgJ-jQjWZ0ECR0zSP0e1JizJaAWXE",
            previewUrl: "https://drive.google.com/file/d/1FrvIgJ-jQjWZ0ECR0zSP0e1JizJaAWXE/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-03-05",
            fileSize: "4.0",
            tags: ["model-paper", "solutions", "mqp-1"]
          },
          {
            id: "toc-4",
            title: "BCS503 MQP 2 SOLUTION SAMPLE 1",
            description: "Model question paper 2 solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1uo_V8O6catQ2rKKqEmHYPL4TMcvr8Yf9",
            previewUrl: "https://drive.google.com/file/d/1uo_V8O6catQ2rKKqEmHYPL4TMcvr8Yf9/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-03-07",
            fileSize: "4.1",
            tags: ["model-paper", "solutions", "mqp-2"]
          },
          {
            id: "toc-5",
            title: "Handwritten notes 1: Module",
            description: "Handwritten notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1G85ydZwjQIMWA9hRoEpUsxkM-2XxJo2S",
            previewUrl: "https://drive.google.com/file/d/1G85ydZwjQIMWA9hRoEpUsxkM-2XxJo2S/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-03-09",
            fileSize: "3.2",
            tags: ["handwritten", "module-1", "automata"]
          },
          {
            id: "toc-6",
            title: "Handwritten notes 2: Module",
            description: "Handwritten notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=17Cr8IrutEVGkYRkrFQQ5Se_GOeKEVVvZ",
            previewUrl: "https://drive.google.com/file/d/17Cr8IrutEVGkYRkrFQQ5Se_GOeKEVVvZ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-03-11",
            fileSize: "3.5",
            tags: ["handwritten", "module-2", "regular-expressions"]
          },
          {
            id: "toc-7",
            title: "Handwritten notes 3: Module",
            description: "Handwritten notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1cOIvOdI_tUPnrosDre1bIvzs59SR_y0R",
            previewUrl: "https://drive.google.com/file/d/1cOIvOdI_tUPnrosDre1bIvzs59SR_y0R/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-03-13",
            fileSize: "3.8",
            tags: ["handwritten", "module-3", "context-free"]
          },
          {
            id: "toc-8",
            title: "Handwritten notes 4: Module",
            description: "Handwritten notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Tm2YYtKwxOmV-u7y-06zQjnU5RV_Ucdz",
            previewUrl: "https://drive.google.com/file/d/1Tm2YYtKwxOmV-u7y-06zQjnU5RV_Ucdz/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-03-15",
            fileSize: "3.6",
            tags: ["handwritten", "module-4", "turing-machines"]
          },
          {
            id: "toc-9",
            title: "Handwritten notes 1 to 5: Module",
            description: "Comprehensive handwritten notes for all modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=1lUbrSa_Uh1TyDMykO6Fd6KHz5cH8VCSe",
            previewUrl: "https://drive.google.com/file/d/1lUbrSa_Uh1TyDMykO6Fd6KHz5cH8VCSe/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-03-17",
            fileSize: "5.5",
            tags: ["handwritten", "complete", "all-modules"]
          },
          {
            id: "toc-10",
            title: "Text Book",
            description: "Text Book for Theory of Computation",
            fileUrl: "https://drive.google.com/uc?export=download&id=1EspkLcP6HUvDXcNgMJxLn1RFpK2uELQJ",
            previewUrl: "https://drive.google.com/file/d/1EspkLcP6HUvDXcNgMJxLn1RFpK2uELQJ/preview",
            type: "textbook",
            category: "reference",
            essential: true,
            uploadedDate: "2024-03-19",
            fileSize: "7.8",
            tags: ["textbook", "reference", "official"]
          },
          {
            id: "toc-11",
            title: "Question Paper",
            description: "Question paper for Theory of Computation",
            fileUrl: "https://drive.google.com/uc?export=download&id=1UqP3Q51_T-0aGTk8QQeBjWSF2y4oeEto",
            previewUrl: "https://drive.google.com/file/d/1UqP3Q51_T-0aGTk8QQeBjWSF2y4oeEto/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-03-21",
            fileSize: "3.1",
            tags: ["question-paper", "exam", "toc"]
          },
          {
            id: "toc-12",
            title: "Question Bank",
            description: "Question bank for Theory of Computation",
            fileUrl: "https://drive.google.com/uc?export=download&id=1UqP3Q51_T-0aGTk8QQeBjWSF2y4oeEto",
            previewUrl: "https://drive.google.com/file/d/1UqP3Q51_T-0aGTk8QQeBjWSF2y4oeEto/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-03-23",
            fileSize: "3.1",
            tags: ["question-bank", "practice", "toc"]
          },
        ],
      },

    ],
    6: [
      {
        title: "MACHINE LEARNING",
        code: "BCS602",
        vtuCode: "BCS602",
        credits: 4,
        modules: [
          {
            id: "ml-1",
            title: "Module 1: Printed Notes",
            description: "Comprehensive printed notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1vIOfJoUkztNLjem_LKYMHTjcIMBQfp5R",
            previewUrl: "https://drive.google.com/file/d/1vIOfJoUkztNLjem_LKYMHTjcIMBQfp5R/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-07-01",
            fileSize: "4.2",
            tags: ["module-1", "machine-learning", "printed"]
          },
          {
            id: "ml-2",
            title: "Module 1: Handwritten Notes",
            description: "Comprehensive handwritten notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1as_KO1nBNv8e2pfSFtZpV6PACpiFg6Sr",
            previewUrl: "https://drive.google.com/file/d/1as_KO1nBNv8e2pfSFtZpV6PACpiFg6Sr/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-07-03",
            fileSize: "4.5",
            tags: ["module-1", "machine-learning", "handwritten"]
          },
          {
            id: "ml-3",
            title: "Module 2: Printed Notes",
            description: "Comprehensive printed notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Pv2FopOV8qSK4ezduuHf9uu75_--ZZMp",
            previewUrl: "https://drive.google.com/file/d/1Pv2FopOV8qSK4ezduuHf9uu75_--ZZMp/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-07-05",
            fileSize: "4.3",
            tags: ["module-2", "machine-learning", "printed"]
          },
          {
            id: "ml-4",
            title: "Module 2: Handwritten Notes",
            description: "Comprehensive handwritten notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1stxqnFNrIXWTHDWRCVu5aUUGrUEgaLvj",
            previewUrl: "https://drive.google.com/file/d/1stxqnFNrIXWTHDWRCVu5aUUGrUEgaLvj/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-07-07",
            fileSize: "4.6",
            tags: ["module-2", "machine-learning", "handwritten"]
          },
          {
            id: "ml-5",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1-DxemhvmqNYt88f4o8DkflhS9aGcVV2A",
            previewUrl: "https://drive.google.com/file/d/1-DxemhvmqNYt88f4o8DkflhS9aGcVV2A/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-07-09",
            fileSize: "4.4",
            tags: ["module-3", "machine-learning", "algorithms"]
          },
          {
            id: "ml-6",
            title: "Module 3: Handwritten Notes",
            description: "Comprehensive handwritten notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1_CpczQqssz0J5Vq_MIjKnXIj50t-8_T5",
            previewUrl: "https://drive.google.com/file/d/1_CpczQqssz0J5Vq_MIjKnXIj50t-8_T5/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-07-11",
            fileSize: "4.7",
            tags: ["module-3", "machine-learning", "handwritten"]
          },
          {
            id: "ml-7",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=18YvPZyMk_jcQfjG3qLdcXztpNHr0NNOb",
            previewUrl: "https://drive.google.com/file/d/18YvPZyMk_jcQfjG3qLdcXztpNHr0NNOb/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-07-13",
            fileSize: "4.3",
            tags: ["module-4", "machine-learning", "neural-networks"]
          },
          {
            id: "ml-8",
            title: "Module 4: Handwritten Notes",
            description: "Comprehensive handwritten notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1lpYM4IR4uFmOXZJBVBm4IijUULF98b8J",
            previewUrl: "https://drive.google.com/file/d/1lpYM4IR4uFmOXZJBVBm4IijUULF98b8J/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-07-15",
            fileSize: "4.8",
            tags: ["module-4", "machine-learning", "handwritten"]
          },
          {
            id: "ml-9",
            title: "All Module: Handwritten Notes",
            description: "Comprehensive handwritten notes for all modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=1s1vnHxEibTMwJzV1HP-ZhomeTYhe_5zS",
            previewUrl: "https://drive.google.com/file/d/1s1vnHxEibTMwJzV1HP-ZhomeTYhe_5zS/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-07-17",
            fileSize: "6.5",
            tags: ["complete", "all-modules", "handwritten"]
          },
          {
            id: "ml-10",
            title: "All Module: Handwritten Notes",
            description: "Additional comprehensive handwritten notes for all modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=1E9jMlLo3bnFDb22KdFo2bPvHbK56BZz0",
            previewUrl: "https://drive.google.com/file/d/1E9jMlLo3bnFDb22KdFo2bPvHbK56BZz0/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-07-19",
            fileSize: "6.8",
            tags: ["complete", "all-modules", "handwritten", "additional"]
          },
          {
            id: "ml-11",
            title: "Problems",
            description: "Machine learning problems and exercises",
            fileUrl: "https://drive.google.com/uc?export=download&id=1bT_kUBDQpE5odP3uUmCMvszwsH4Cq7WN",
            previewUrl: "https://drive.google.com/file/d/1bT_kUBDQpE5odP3uUmCMvszwsH4Cq7WN/preview",
            type: "problems",
            category: "practice",
            essential: true,
            uploadedDate: "2024-07-21",
            fileSize: "4.2",
            tags: ["problems", "exercises", "practice"]
          },
          {
            id: "ml-12",
            title: "LAB MANUAL 1-2",
            description: "Lab manual for experiments 1-2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ZQ8AEyGwraBDbbCNtvY62xM74ViLrFPA",
            previewUrl: "https://drive.google.com/file/d/1ZQ8AEyGwraBDbbCNtvY62xM74ViLrFPA/preview",
            type: "lab-manual",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-07-23",
            fileSize: "3.8",
            tags: ["lab-manual", "experiments", "practical"]
          },
          {
            id: "ml-13",
            title: "LAB MANUAL 3-20",
            description: "Lab manual for experiments 3-20",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ndp2mLOwunQSmH40V9C1vHm2BMS4unPy",
            previewUrl: "https://drive.google.com/file/d/1ndp2mLOwunQSmH40V9C1vHm2BMS4unPy/preview",
            type: "lab-manual",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2024-07-25",
            fileSize: "5.2",
            tags: ["lab-manual", "experiments", "complete"]
          }
        ]
      },
      {
        title: "Microcontrollers & Embedded Systems",
        code: "BCO601",
        vtuCode: "BCO601",
        credits: 4,
        modules: [
          {
            id: "mces-1",
            title: "Module 1: Notes",
            description: "Introduction to Microcontrollers & Embedded Systems",
            fileUrl: "https://drive.google.com/uc?export=download&id=12zswzZT0O9GPnRwyv57JIRgUFqXy3DWz",
            previewUrl: "https://drive.google.com/file/d/12zswzZT0O9GPnRwyv57JIRgUFqXy3DWz/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-08-01",
            fileSize: "4.0",
            tags: ["module-1", "microcontrollers", "embedded-systems"]
          },
          {
            id: "mces-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1rYAlndSz3uDaCMYrGj7gI4vF3QDMGdhT",
            previewUrl: "https://drive.google.com/file/d/1rYAlndSz3uDaCMYrGj7gI4vF3QDMGdhT/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-08-03",
            fileSize: "4.3",
            tags: ["module-2", "microcontrollers", "architecture"]
          },
          {
            id: "mces-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1T7kIj3ZNSX3wu8KaLL9oOENtBIdkv7Sy",
            previewUrl: "https://drive.google.com/file/d/1T7kIj3ZNSX3wu8KaLL9oOENtBIdkv7Sy/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-08-05",
            fileSize: "4.1",
            tags: ["module-3", "microcontrollers", "programming"]
          },
          {
            id: "mces-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1qqoG9YtqwPYxNgojLWIqcX2CA_dJHcuz",
            previewUrl: "https://drive.google.com/file/d/1qqoG9YtqwPYxNgojLWIqcX2CA_dJHcuz/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-08-07",
            fileSize: "4.4",
            tags: ["module-4", "embedded-systems", "interfacing"]
          },
          {
            id: "mces-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1I3OZbeKUcTssEvuUgJ3gBHc5vwSSlDeU",
            previewUrl: "https://drive.google.com/file/d/1I3OZbeKUcTssEvuUgJ3gBHc5vwSSlDeU/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-08-09",
            fileSize: "4.2",
            tags: ["module-5", "embedded-systems", "applications"]
          },
          {
            id: "mces-6",
            title: "Question Paper",
            description: "Question paper for Microcontrollers & Embedded Systems",
            fileUrl: "https://drive.google.com/uc?export=download&id=1BmqvVe8WhNCRsXdVT3K-4x8sJbKWDq0l",
            previewUrl: "https://drive.google.com/file/d/1BmqvVe8WhNCRsXdVT3K-4x8sJbKWDq0l/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-08-11",
            fileSize: "3.5",
            tags: ["question-paper", "exam", "microcontrollers"]
          },
          {
            id: "mces-7",
            title: "Model Question Paper",
            description: "Model question paper for Microcontrollers & Embedded Systems",
            fileUrl: "https://drive.google.com/uc?export=download&id=1BUbRTKVfkXgLlLsmZ5AqD7ANrvRQzC3D",
            previewUrl: "https://drive.google.com/file/d/1BUbRTKVfkXgLlLsmZ5AqD7ANrvRQzC3D/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-08-13",
            fileSize: "3.7",
            tags: ["model-paper", "practice", "exam-prep"]
          }
        ]
      },
      {
        title: "CLOUD COMPUTING",
        code: "BCS601,BIS613D",
        vtuCode: "BCS601,BIS613D",
        credits: 3,
        modules: [
          {
            id: "cloud-1",
            title: "Module 1: TextBook",
            description: "Textbook for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ZApTMHVXsrJA6aF7O9b1rtCU0bgCh-F6",
            previewUrl: "https://drive.google.com/file/d/1ZApTMHVXsrJA6aF7O9b1rtCU0bgCh-F6/preview",
            type: "textbook",
            category: "reference",
            essential: true,
            uploadedDate: "2024-09-01",
            fileSize: "8.2",
            tags: ["module-1", "cloud-computing", "textbook"]
          },
          {
            id: "cloud-2",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1NPmQwk24g1U-yrdO2lOw9E4mya6lpoPE",
            previewUrl: "https://drive.google.com/file/d/1NPmQwk24g1U-yrdO2lOw9E4mya6lpoPE/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-09-03",
            fileSize: "4.3",
            tags: ["module-1", "cloud-computing", "fundamentals"]
          },
          {
            id: "cloud-3",
            title: "Module 1: Important Question And Answer",
            description: "Important questions and answers for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1p6_qanjmcbp1z7X9XYrKZxy1dwfSLO4R",
            previewUrl: "https://drive.google.com/file/d/1p6_qanjmcbp1z7X9XYrKZxy1dwfSLO4R/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-09-05",
            fileSize: "4.8",
            tags: ["module-1", "important-questions", "answers"]
          },
          {
            id: "cloud-4",
            title: "Module 2: TextBook",
            description: "Textbook for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1EXuR0payVH-8ccg2mruLupBy5ZwruLkT",
            previewUrl: "https://drive.google.com/file/d/1EXuR0payVH-8ccg2mruLupBy5ZwruLkT/preview",
            type: "textbook",
            category: "reference",
            essential: true,
            uploadedDate: "2024-09-07",
            fileSize: "8.5",
            tags: ["module-2", "cloud-computing", "textbook"]
          },
          {
            id: "cloud-5",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1-ZYHoSxwv6GLvurc_6blVPb-xZ0o25_f",
            previewUrl: "https://drive.google.com/file/d/1-ZYHoSxwv6GLvurc_6blVPb-xZ0o25_f/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-09-09",
            fileSize: "4.5",
            tags: ["module-2", "cloud-computing", "virtualization"]
          },
          {
            id: "cloud-6",
            title: "Module 2: Important Question And Answer",
            description: "Important questions and answers for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1VtTmTwtnJgrTo5SO6ktKCVjsKtFiSzTs",
            previewUrl: "https://drive.google.com/file/d/1VtTmTwtnJgrTo5SO6ktKCVjsKtFiSzTs/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-09-11",
            fileSize: "4.9",
            tags: ["module-2", "important-questions", "answers"]
          },
          {
            id: "cloud-7",
            title: "Module 3: TextBook",
            description: "Textbook for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1XaV8jqXNY1gLhNGz5Ooeb9fH1RiwsyFF",
            previewUrl: "https://drive.google.com/file/d/1XaV8jqXNY1gLhNGz5Ooeb9fH1RiwsyFF/preview",
            type: "textbook",
            category: "reference",
            essential: true,
            uploadedDate: "2024-09-13",
            fileSize: "8.7",
            tags: ["module-3", "cloud-computing", "textbook"]
          },
          {
            id: "cloud-8",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1jVks2-brbrctcM1KhPH33nMuicleRn_n",
            previewUrl: "https://drive.google.com/file/d/1jVks2-brbrctcM1KhPH33nMuicleRn_n/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-09-15",
            fileSize: "4.6",
            tags: ["module-3", "cloud-computing", "cloud-services"]
          },
          {
            id: "cloud-9",
            title: "Module 3: Important Question And Answer",
            description: "Important questions and answers for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1f46eleEZ5BzTIpFbFNuvbd_NO7JOZYzf",
            previewUrl: "https://drive.google.com/file/d/1f46eleEZ5BzTIpFbFNuvbd_NO7JOZYzf/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-09-17",
            fileSize: "5.0",
            tags: ["module-3", "important-questions", "answers"]
          },
          {
            id: "cloud-10",
            title: "Module 4: TextBook",
            description: "Textbook for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1_0ekslPWpChk5Mm6xpONsT9rQnuURaBE",
            previewUrl: "https://drive.google.com/file/d/1_0ekslPWpChk5Mm6xpONsT9rQnuURaBE/preview",
            type: "textbook",
            category: "reference",
            essential: true,
            uploadedDate: "2024-09-19",
            fileSize: "8.9",
            tags: ["module-4", "cloud-computing", "textbook"]
          },
          {
            id: "cloud-11",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1FPIHsv04ljMbw7isfuoEsJnVTK56ZKty",
            previewUrl: "https://drive.google.com/file/d/1FPIHsv04ljMbw7isfuoEsJnVTK56ZKty/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-09-21",
            fileSize: "4.7",
            tags: ["module-4", "cloud-computing", "cloud-security"]
          },
          {
            id: "cloud-12",
            title: "Module 4: Important Question And Answer",
            description: "Important questions and answers for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1L3YdFrlAUaCA-Syp8LaPMAZQWIA5Wb7R",
            previewUrl: "https://drive.google.com/file/d/1L3YdFrlAUaCA-Syp8LaPMAZQWIA5Wb7R/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-09-23",
            fileSize: "5.1",
            tags: ["module-4", "important-questions", "answers"]
          },
          {
            id: "cloud-13",
            title: "Module 5: TextBook",
            description: "Textbook for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1HEz_iq2KqhKVqI5v3NuEQn_W8vUhvzsV",
            previewUrl: "https://drive.google.com/file/d/1HEz_iq2KqhKVqI5v3NuEQn_W8vUhvzsV/preview",
            type: "textbook",
            category: "reference",
            essential: true,
            uploadedDate: "2024-09-25",
            fileSize: "9.2",
            tags: ["module-5", "cloud-computing", "textbook"]
          },
          {
            id: "cloud-14",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1FPIHsv04ljMbw7isfuoEsJnVTK56ZKty",
            previewUrl: "https://drive.google.com/file/d/1FPIHsv04ljMbw7isfuoEsJnVTK56ZKty/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-09-27",
            fileSize: "4.8",
            tags: ["module-5", "cloud-computing", "future-trends"]
          },
          {
            id: "cloud-15",
            title: "Module 5: Important Question And Answer",
            description: "Important questions and answers for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ODEnH_HoXvKM2YkbdOClGOunKKp3FVuQ",
            previewUrl: "https://drive.google.com/file/d/1ODEnH_HoXvKM2YkbdOClGOunKKp3FVuQ/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-09-29",
            fileSize: "5.3",
            tags: ["module-5", "important-questions", "answers"]
          },
          {
            id: "cloud-16",
            title: "Question papers",
            description: "Collection of question papers",
            fileUrl: "https://drive.google.com/uc?export=download&id=11aOchNzYu0p5nvYKYtoa3iZKG2x-SK6B",
            previewUrl: "https://drive.google.com/file/d/11aOchNzYu0p5nvYKYtoa3iZKG2x-SK6B/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-10-01",
            fileSize: "4.5",
            tags: ["question-papers", "collection", "exam"]
          },
          {
            id: "cloud-17",
            title: "Model Question paper",
            description: "Model question paper for Cloud Computing",
            fileUrl: "https://drive.google.com/uc?export=download&id=1lNZUZNCCaJM33y_kzv3sbJSird2AmCRM",
            previewUrl: "https://drive.google.com/file/d/1lNZUZNCCaJM33y_kzv3sbJSird2AmCRM/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-10-03",
            fileSize: "3.8",
            tags: ["model-paper", "practice", "exam-prep"]
          },
          {
            id: "cloud-18",
            title: "Module-01",
            description: "Additional Module 1 resources",
            fileUrl: "https://drive.google.com/uc?export=download&id=1L7Gr2245GJAX8N8ea1PHRDhThtYlxciu",
            previewUrl: "https://drive.google.com/file/d/1L7Gr2245GJAX8N8ea1PHRDhThtYlxciu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-10-05",
            fileSize: "4.0",
            tags: ["module-1", "additional", "resources"]
          }
        ]
      }, {
        title: "WATER CONSERVATION AND RAIN WATER HARVESTING",
        code: "BCV654A",
        vtuCode: "BCV654A",
        credits: 2,
        modules: [
          {
            id: "water-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1OFNgSgI4Px2intbbHgOQ69MqyYormpC5",
            previewUrl: "https://drive.google.com/file/d/1OFNgSgI4Px2intbbHgOQ69MqyYormpC5/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-01",
            fileSize: "3.8",
            tags: ["module-1", "water-conservation", "basics"]
          },
          {
            id: "water-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o75o8ehfrU3_CdRDtJaGWexPTzRm9kyx",
            previewUrl: "https://drive.google.com/file/d/1o75o8ehfrU3_CdRDtJaGWexPTzRm9kyx/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-03",
            fileSize: "4.0",
            tags: ["module-2", "water-conservation", "techniques"]
          },
          {
            id: "water-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1S4q9i8syf1XDzkrEw5eLMxAcMoFNKXT7",
            previewUrl: "https://drive.google.com/file/d/1S4q9i8syf1XDzkrEw5eLMxAcMoFNKXT7/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-05",
            fileSize: "3.9",
            tags: ["module-3", "rainwater", "harvesting"]
          },
          {
            id: "water-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1lBGkgrmOzt9R44h2TEL6k35PjSysKRqI",
            previewUrl: "https://drive.google.com/file/d/1lBGkgrmOzt9R44h2TEL6k35PjSysKRqI/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-07",
            fileSize: "4.1",
            tags: ["module-4", "water-management", "systems"]
          },
          {
            id: "water-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=12SKXDIzZGq7YlLIXKMf4SewXVrabG5oL",
            previewUrl: "https://drive.google.com/file/d/12SKXDIzZGq7YlLIXKMf4SewXVrabG5oL/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-09",
            fileSize: "4.2",
            tags: ["module-5", "water-conservation", "applications"]
          },
          {
            id: "water-6",
            title: "MQPS",
            description: "Model question paper solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1bOrd1-U9omf_IH3ZS5gWPceSfP01O4a8",
            previewUrl: "https://drive.google.com/file/d/1bOrd1-U9omf_IH3ZS5gWPceSfP01O4a8/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-11-11",
            fileSize: "4.5",
            tags: ["model-paper", "solutions", "exam-prep"]
          }
        ]
      },
      {
        title: "Cryptography & Network Security",
        code: "BCO601",
        vtuCode: "BCO601",
        credits: 3,
        modules: [
          {
            id: "crypto-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RmrMh00z0WNpkbwZlUDKWIBN1y88_mHv",
            previewUrl: "https://drive.google.com/file/d/1RmrMh00z0WNpkbwZlUDKWIBN1y88_mHv/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-13",
            fileSize: "4.3",
            tags: ["module-1", "cryptography", "security"]
          },
          {
            id: "crypto-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1OmN17Z7hhKrgAS8FTzSNcDcK8Xm2xkIg",
            previewUrl: "https://drive.google.com/file/d/1OmN17Z7hhKrgAS8FTzSNcDcK8Xm2xkIg/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-15",
            fileSize: "4.5",
            tags: ["module-2", "cryptography", "algorithms"]
          },
          {
            id: "crypto-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=15ZbDolvXRC1BLQ6amOkoxEgEXub-XWAu",
            previewUrl: "https://drive.google.com/file/d/15ZbDolvXRC1BLQ6amOkoxEgEXub-XWAu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-17",
            fileSize: "4.4",
            tags: ["module-3", "network-security", "protocols"]
          }
        ]
      },
      {
        title: "Blockchain Technology",
        code: "BIC702",
        vtuCode: "BIC702",
        credits: 3,
        modules: [
          {
            id: "blockchain-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1n8aHhTbYBXxa7GeHlSzXmHyS2GxnblHO",
            previewUrl: "https://drive.google.com/file/d/1n8aHhTbYBXxa7GeHlSzXmHyS2GxnblHO/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-19",
            fileSize: "4.2",
            tags: ["module-1", "blockchain", "basics"]
          },
          {
            id: "blockchain-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1x2F2hB0y3nLkGXt1jircZsSqsoa4Y4n9",
            previewUrl: "https://drive.google.com/file/d/1x2F2hB0y3nLkGXt1jircZsSqsoa4Y4n9/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-21",
            fileSize: "4.5",
            tags: ["module-2", "blockchain", "cryptocurrency"]
          },
          {
            id: "blockchain-3",
            title: "Module 1 to 3: Handwritten Notes",
            description: "Handwritten notes for Module 1 to 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1aVBwZ8K9iHTS_uTiROIZjYcNovQUbv3b",
            previewUrl: "https://drive.google.com/file/d/1aVBwZ8K9iHTS_uTiROIZjYcNovQUbv3b/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-23",
            fileSize: "5.8",
            tags: ["handwritten", "modules-1-3", "complete"]
          }
        ]
      },
      {
        title: "Natural Language Processing",
        code: "BAI601",
        vtuCode: "BAI601",
        credits: 3,
        modules: [
          {
            id: "nlp-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=13jOlNUysp9ENDhTwPf0Fj8VxXeobudjS",
            previewUrl: "https://drive.google.com/file/d/13jOlNUysp9ENDhTwPf0Fj8VxXeobudjS/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-25",
            fileSize: "4.3",
            tags: ["module-1", "nlp", "introduction"]
          },
          {
            id: "nlp-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1IOzlC-IKH7EP1JVRl8UWfi84v4V9aj_D",
            previewUrl: "https://drive.google.com/file/d/1IOzlC-IKH7EP1JVRl8UWfi84v4V9aj_D/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-11-27",
            fileSize: "4.6",
            tags: ["module-2", "nlp", "processing"]
          },
          {
            id: "nlp-3",
            title: "Question Paper",
            description: "Question paper for Natural Language Processing",
            fileUrl: "https://drive.google.com/uc?export=download&id=1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0",
            previewUrl: "https://drive.google.com/file/d/1WF1xwH9qupTMAh1LQ1jjG6_eW7gLSoU0/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-11-29",
            fileSize: "3.5",
            tags: ["question-paper", "exam", "nlp"]
          },
          {
            id: "nlp-4",
            title: "Question Bank",
            description: "Question bank for Natural Language Processing",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W",
            previewUrl: "https://drive.google.com/file/d/1Cac42RDBC9UtXGKfUi5Me14FG-aLc-6W/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-12-01",
            fileSize: "4.0",
            tags: ["question-bank", "practice", "nlp"]
          }
        ]
      },
      {
        title: "ARTIFICIAL INTELLIGENCE",
        code: "21CS69",
        vtuCode: "21CS69/69",
        credits: 3,
        modules: [
          {
            id: "ai6-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-12-03",
            fileSize: "4.2",
            tags: ["module-1", "ai", "introduction"]
          },
          {
            id: "ai6-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-12-05",
            fileSize: "4.3",
            tags: ["module-2", "ai", "search-algorithms"]
          },
          {
            id: "ai6-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-12-07",
            fileSize: "4.4",
            tags: ["module-3", "ai", "knowledge-representation"]
          },
          {
            id: "ai6-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-12-09",
            fileSize: "4.5",
            tags: ["module-4", "ai", "planning"]
          },
          {
            id: "ai6-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-12-11",
            fileSize: "4.6",
            tags: ["module-5", "ai", "learning"]
          },
          {
            id: "ai6-6",
            title: "Question Paper",
            description: "Question paper for AI",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-12-13",
            fileSize: "3.8",
            tags: ["question-paper", "exam", "ai"]
          },
          {
            id: "ai6-7",
            title: "Question Bank",
            description: "Question bank for AI",
            fileUrl: "https://drive.google.com/uc?export=download&id=1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu",
            previewUrl: "https://drive.google.com/file/d/1o73EvSDKnuy5qcoLitiaCSAYZ4PeMNSu/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-12-15",
            fileSize: "4.2",
            tags: ["question-bank", "practice", "ai"]
          }
        ]
      },
      {
        title: "BIOLOLY FOR ENGINEERS",
        code: "21BE70",
        vtuCode: "21BE70/70",
        credits: 2,
        modules: [
          {
            id: "bio6-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1T8wYGZdPx8V0QeGDMb3cAOifdLFZXoZk",
            previewUrl: "https://drive.google.com/file/d/1T8wYGZdPx8V0QeGDMb3cAOifdLFZXoZk/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-12-17",
            fileSize: "3.9",
            tags: ["module-1", "biology", "introduction"]
          },
          {
            id: "bio6-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Tkra5ZzuWkKlfd99gBlp97EhjYzIAUXj",
            previewUrl: "https://drive.google.com/file/d/1Tkra5ZzuWkKlfd99gBlp97EhjYzIAUXj/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-12-19",
            fileSize: "4.1",
            tags: ["module-2", "biology", "cells"]
          },
          {
            id: "bio6-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=19VqgzZgvaE5Wt_aDcuR7pQH2StnzAqRF",
            previewUrl: "https://drive.google.com/file/d/19VqgzZgvaE5Wt_aDcuR7pQH2StnzAqRF/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-12-21",
            fileSize: "4.2",
            tags: ["module-3", "biology", "genetics"]
          },
          {
            id: "bio6-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1mR8sVnrpFZlFhQd61EsdBQ5u6N5IKWPd",
            previewUrl: "https://drive.google.com/file/d/1mR8sVnrpFZlFhQd61EsdBQ5u6N5IKWPd/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-12-23",
            fileSize: "4.3",
            tags: ["module-4", "biology", "biotechnology"]
          },
          {
            id: "bio6-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=12NRJCozzG3BmFdob8kcHd8Oe2yYx0xQ8",
            previewUrl: "https://drive.google.com/file/d/12NRJCozzG3BmFdob8kcHd8Oe2yYx0xQ8/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-12-25",
            fileSize: "4.4",
            tags: ["module-5", "biology", "applications"]
          },
          {
            id: "bio6-6",
            title: "Question Paper",
            description: "Question paper for Biology",
            fileUrl: "https://drive.google.com/uc?export=download&id=1h_udrhNRqd0UiwdM8bVeH_PTXyWsVcKB",
            previewUrl: "https://drive.google.com/file/d/1h_udrhNRqd0UiwdM8bVeH_PTXyWsVcKB/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-12-27",
            fileSize: "3.5",
            tags: ["question-paper", "exam", "biology"]
          },
          {
            id: "bio6-7",
            title: "Question Paper 2",
            description: "Additional question paper for Biology",
            fileUrl: "https://drive.google.com/uc?export=download&id=1aD7ZjnBroS5GvDCcULUJ-F9mrkRgU826",
            previewUrl: "https://drive.google.com/file/d/1aD7ZjnBroS5GvDCcULUJ-F9mrkRgU826/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-12-29",
            fileSize: "3.6",
            tags: ["question-paper", "additional", "biology"]
          },
        ],
      },

      {
        title: "Integrated Waste Management for Smart City",
        code: "21IW64",
        vtuCode: "21IW64/64",
        credits: 3,
        modules: [
          {
            id: "waste-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1dBQCqNBkdiD4OCUQ6DBc1nBI-Y-KxlcN",
            previewUrl: "https://drive.google.com/file/d/1dBQCqNBkdiD4OCUQ6DBc1nBI-Y-KxlcN/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-10-07",
            fileSize: "4.2",
            tags: ["module-1", "waste-management", "smart-city"]
          },
          {
            id: "waste-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=11QzUQBK3S2efVbnewtgO7WQFAk2O_COy",
            previewUrl: "https://drive.google.com/file/d/11QzUQBK3S2efVbnewtgO7WQFAk2O_COy/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-10-09",
            fileSize: "4.5",
            tags: ["module-2", "waste-management", "collection"]
          },
          {
            id: "waste-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1YK0ldDnPKk-BeoGc2-FLTiQvp4VPV_Jh",
            previewUrl: "https://drive.google.com/file/d/1YK0ldDnPKk-BeoGc2-FLTiQvp4VPV_Jh/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-10-11",
            fileSize: "4.3",
            tags: ["module-3", "waste-management", "treatment"]
          },
          {
            id: "waste-4",
            title: "Module 3: Handwritten Notes",
            description: "Handwritten notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1iv8ii49L4Y5gu4KYnC3iNOzq5Yr9cQV_",
            previewUrl: "https://drive.google.com/file/d/1iv8ii49L4Y5gu4KYnC3iNOzq5Yr9cQV_/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-10-13",
            fileSize: "4.7",
            tags: ["module-3", "handwritten", "waste-management"]
          },
          {
            id: "waste-5",
            title: "Module 4: Handwritten Notes",
            description: "Handwritten notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1P3uNan2NQgPmgzJHn2RynnAG6cdXL7Ze",
            previewUrl: "https://drive.google.com/file/d/1P3uNan2NQgPmgzJHn2RynnAG6cdXL7Ze/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-10-15",
            fileSize: "4.6",
            tags: ["module-4", "handwritten", "recycling"]
          },
          {
            id: "waste-6",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ggsq9j83sq2fNWG5mkC63_WNLsyAb7E_",
            previewUrl: "https://drive.google.com/file/d/1ggsq9j83sq2fNWG5mkC63_WNLsyAb7E_/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-10-17",
            fileSize: "4.4",
            tags: ["module-4", "waste-management", "disposal"]
          },
          {
            id: "waste-7",
            title: "Module 5: Handwritten Notes",
            description: "Handwritten notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1vsFXG-Fy-YiEbiftYygWhxE_pCzKOSWs",
            previewUrl: "https://drive.google.com/file/d/1vsFXG-Fy-YiEbiftYygWhxE_pCzKOSWs/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-10-19",
            fileSize: "4.8",
            tags: ["module-5", "handwritten", "smart-solutions"]
          },
          {
            id: "waste-8",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1iEVf2H-03N6XmXLr_8Arzw7veRWJxYzA",
            previewUrl: "https://drive.google.com/file/d/1iEVf2H-03N6XmXLr_8Arzw7veRWJxYzA/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-10-21",
            fileSize: "4.5",
            tags: ["module-5", "waste-management", "sustainability"]
          },
          {
            id: "waste-9",
            title: "All Modules: Notes",
            description: "Comprehensive notes for all modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=152YwgokdAv6Dvc59kHz-vtMp2IL9L9A6",
            previewUrl: "https://drive.google.com/file/d/152YwgokdAv6Dvc59kHz-vtMp2IL9L9A6/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-10-23",
            fileSize: "6.2",
            tags: ["complete", "all-modules", "comprehensive"]
          },
          {
            id: "waste-10",
            title: "MQP-BCV654C",
            description: "Model question paper BCV654C",
            fileUrl: "https://drive.google.com/uc?export=download&id=1S6IqRQY87HsRhsqKC3CWsljih5zQoWt-",
            previewUrl: "https://drive.google.com/file/d/1S6IqRQY87HsRhsqKC3CWsljih5zQoWt-/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-10-25",
            fileSize: "3.8",
            tags: ["model-paper", "exam", "waste-management"]
          },
          {
            id: "waste-11",
            title: "MQPS-BCV654C",
            description: "Model question paper solutions BCV654C",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RXzRXZKEf3q60oNmuWiCC4bqr8KYhFPa",
            previewUrl: "https://drive.google.com/file/d/1RXzRXZKEf3q60oNmuWiCC4bqr8KYhFPa/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-10-27",
            fileSize: "4.5",
            tags: ["model-paper", "solutions", "answers"]
          }

        ]
      }
    ],
    7: [
      {
        title: "MACHINE LEARNING",
        code: "BIC703",
        vtuCode: "BIC703/703",
        credits: 4,
        modules: [
          {
            id: "ml7-1",
            title: "Module 1: Printed Notes",
            description: "Comprehensive printed notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1vIOfJoUkztNLjem_LKYMHTjcIMBQfp5R",
            previewUrl: "https://drive.google.com/file/d/1vIOfJoUkztNLjem_LKYMHTjcIMBQfp5R/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-01",
            fileSize: "4.2",
            tags: ["module-1", "machine-learning", "printed", "BIC703"]
          },
          {
            id: "ml7-2",
            title: "Module 2: Printed Notes",
            description: "Comprehensive printed notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Pv2FopOV8qSK4ezduuHf9uu75_--ZZMp",
            previewUrl: "https://drive.google.com/file/d/1Pv2FopOV8qSK4ezduuHf9uu75_--ZZMp/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-03",
            fileSize: "4.3",
            tags: ["module-2", "machine-learning", "printed", "BIC703"]
          },
          {
            id: "ml7-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1-DxemhvmqNYt88f4o8DkflhS9aGcVV2A",
            previewUrl: "https://drive.google.com/file/d/1-DxemhvmqNYt88f4o8DkflhS9aGcVV2A/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-05",
            fileSize: "4.4",
            tags: ["module-3", "machine-learning", "algorithms", "BIC703"]
          },
          {
            id: "ml7-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=18YvPZyMk_jcQfjG3qLdcXztpNHr0NNOb",
            previewUrl: "https://drive.google.com/file/d/18YvPZyMk_jcQfjG3qLdcXztpNHr0NNOb/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-07",
            fileSize: "4.3",
            tags: ["module-4", "machine-learning", "neural-networks", "BIC703"]
          },
          {
            id: "ml7-5",
            title: "All Module: Handwritten Notes",
            description: "Comprehensive handwritten notes for all modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=1E9jMlLo3bnFDb22KdFo2bPvHbK56BZz0",
            previewUrl: "https://drive.google.com/file/d/1E9jMlLo3bnFDb22KdFo2bPvHbK56BZz0/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-09",
            fileSize: "6.5",
            tags: ["complete", "all-modules", "handwritten", "BIC703"]
          },
          {
            id: "ml7-6",
            title: "All Module: Handwritten Notes",
            description: "Additional comprehensive handwritten notes for all modules",
            fileUrl: "https://drive.google.com/uc?export=download&id=1E9jMlLo3bnFDb22KdFo2bPvHbK56BZz0",
            previewUrl: "https://drive.google.com/file/d/1E9jMlLo3bnFDb22KdFo2bPvHbK56BZz0/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-11",
            fileSize: "6.5",
            tags: ["complete", "all-modules", "handwritten", "additional", "BIC703"]
          },
          {
            id: "ml7-7",
            title: "Problems",
            description: "Machine learning problems and exercises",
            fileUrl: "https://drive.google.com/uc?export=download&id=1bT_kUBDQpE5odP3uUmCMvszwsH4Cq7WN",
            previewUrl: "https://drive.google.com/file/d/1bT_kUBDQpE5odP3uUmCMvszwsH4Cq7WN/preview",
            type: "problems",
            category: "practice",
            essential: true,
            uploadedDate: "2025-01-13",
            fileSize: "4.2",
            tags: ["problems", "exercises", "practice", "BIC703"]
          },
          {
            id: "ml7-8",
            title: "LAB MANUAL 1-2",
            description: "Lab manual for experiments 1-2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ZQ8AEyGwraBDbbCNtvY62xM74ViLrFPA",
            previewUrl: "https://drive.google.com/file/d/1ZQ8AEyGwraBDbbCNtvY62xM74ViLrFPA/preview",
            type: "lab-manual",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2025-01-15",
            fileSize: "3.8",
            tags: ["lab-manual", "experiments", "practical", "BIC703"]
          },
          {
            id: "ml7-9",
            title: "LAB MANUAL 3-20",
            description: "Lab manual for experiments 3-20",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ndp2mLOwunQSmH40V9C1vHm2BMS4unPy",
            previewUrl: "https://drive.google.com/file/d/1ndp2mLOwunQSmH40V9C1vHm2BMS4unPy/preview",
            type: "lab-manual",
            category: "lab-manual",
            essential: true,
            uploadedDate: "2025-01-17",
            fileSize: "5.2",
            tags: ["lab-manual", "experiments", "complete", "BIC703"]
          }
        ]
      },
      {
        title: "The software quality challenge",
        code: "BIS714B",
        vtuCode: "BIS714B/714B",
        credits: 3,
        modules: [
          {
            id: "sqc-1",
            title: "Top Study Notes: Complete Software Quality Engineering – Set 01",
            description: "Complete, exam-oriented notes covering all 5 modules with clear explanations, diagrams, examples, and VTU important questions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1FASS4k2QRC_GOqxUVWcsoS_tDeoIJV1c",
            previewUrl: "https://drive.google.com/file/d/1FASS4k2QRC_GOqxUVWcsoS_tDeoIJV1c/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-19",
            fileSize: "6.8",
            tags: ["complete", "exam-oriented", "software-quality", "BIS714B"]
          },
          {
            id: "sqc-2",
            title: "Module 1: Last-Minute Revision Notes & Important Q/A",
            description: "Concise revision of Introduction to Software Quality, Quality Challenges, Cost of Quality, and VTU's most asked questions with model answers",
            fileUrl: "https://drive.google.com/uc?export=download&id=1BWIc0iPpG3GjHj00YyYGK6d4vE9lHYdE",
            previewUrl: "https://drive.google.com/file/d/1BWIc0iPpG3GjHj00YyYGK6d4vE9lHYdE/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-21",
            fileSize: "3.5",
            tags: ["module-1", "revision", "important-qa", "BIS714B"]
          },
          {
            id: "sqc-3",
            title: "Module 2: Last-Minute Revision Notes & Important Q/A",
            description: "Quick recap of Quality Models (McCall, ISO 9126), ISO 9001, SQA Standards, and Software Metrics with solved important questions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1QZonHjuFxQpOpWm39K8ugLvz2lPwR8Tc",
            previewUrl: "https://drive.google.com/file/d/1QZonHjuFxQpOpWm39K8ugLvz2lPwR8Tc/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-23",
            fileSize: "3.8",
            tags: ["module-2", "revision", "quality-models", "BIS714B"]
          },
          {
            id: "sqc-4",
            title: "Module 3: Last-Minute Revision Notes & Important Q/A",
            description: "Focused revision on Testing Levels, Black-Box & White-Box Techniques, Test Case Design, and Defect Life Cycle with previous year Q/A",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Vi5_2ClB6PABCQ6EjBzDLmSwKJtLAdL0",
            previewUrl: "https://drive.google.com/file/d/1Vi5_2ClB6PABCQ6EjBzDLmSwKJtLAdL0/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-25",
            fileSize: "4.0",
            tags: ["module-3", "revision", "software-testing", "BIS714B"]
          },
          {
            id: "sqc-5",
            title: "Module 4: Last-Minute Revision Notes & Important Q/A",
            description: "Revision notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1dHX5FZcfojic9oysv9_aA32RTUYtkzvA",
            previewUrl: "https://drive.google.com/file/d/1dHX5FZcfojic9oysv9_aA32RTUYtkzvA/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-27",
            fileSize: "3.7",
            tags: ["module-4", "revision", "quality-assurance", "BIS714B"]
          },
          {
            id: "sqc-6",
            title: "Module 5: Last-Minute Revision Notes & Important Q/A",
            description: "Final revision notes on CMMI, Six Sigma, Process Improvement, Defect Prevention, and key questions with answers for VTU exams",
            fileUrl: "https://drive.google.com/uc?export=download&id=1npzJmFzBaD3B3HW2NCv1k3RIybOiS5f9",
            previewUrl: "https://drive.google.com/file/d/1npzJmFzBaD3B3HW2NCv1k3RIybOiS5f9/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-29",
            fileSize: "4.2",
            tags: ["module-5", "revision", "process-improvement", "BIS714B"]
          },
          {
            id: "sqc-7",
            title: "Top Study Notes: Complete Software Quality Engineering – Set 02",
            description: "Alternate complete notes set for revision, including simplified concepts, key points, and last-minute exam preparation material",
            fileUrl: "https://drive.google.com/uc?export=download&id=1IGnWxsfCgYmH0y-G-B5L0PJiEIu46V2j",
            previewUrl: "https://drive.google.com/file/d/1IGnWxsfCgYmH0y-G-B5L0PJiEIu46V2j/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-01-31",
            fileSize: "6.5",
            tags: ["complete", "alternate", "revision", "BIS714B"]
          },
          {
            id: "sqc-8",
            title: "Module 1: Introduction to Software Quality (Printed Notes)",
            description: "Introduction to software quality, quality challenges, errors vs defects, cost of quality, and the role of quality assurance in software engineering",
            fileUrl: "https://drive.google.com/uc?export=download&id=1jRFYhJ_qFwyLUdOCfRT7_uAdCqIilj5M",
            previewUrl: "https://drive.google.com/file/d/1jRFYhJ_qFwyLUdOCfRT7_uAdCqIilj5M/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-02",
            fileSize: "4.3",
            tags: ["module-1", "printed", "introduction", "BIS714B"]
          },
          {
            id: "sqc-9",
            title: "Module 2: Software Quality Models & Standards (Printed Notes)",
            description: "Software quality models, ISO quality standards, software metrics, and quality measurement techniques as per VTU syllabus",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RXccBLtUX8myHoLwrhylV0reZTpo8gGB",
            previewUrl: "https://drive.google.com/file/d/1RXccBLtUX8myHoLwrhylV0reZTpo8gGB/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-04",
            fileSize: "4.5",
            tags: ["module-2", "printed", "quality-models", "BIS714B"]
          },
          {
            id: "sqc-10",
            title: "Module 3: Software Testing Fundamentals",
            description: "Testing principles, levels of testing, black-box and white-box techniques, test case design, and defect life cycle",
            fileUrl: "https://drive.google.com/uc?export=download&id=1VzolDybW9lxf2ankJkXqAItFnC-sb9yJ",
            previewUrl: "https://drive.google.com/file/d/1VzolDybW9lxf2ankJkXqAItFnC-sb9yJ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-06",
            fileSize: "4.6",
            tags: ["module-3", "software-testing", "fundamentals", "BIS714B"]
          },
          {
            id: "sqc-11",
            title: "Module 4: Software Quality Assurance & Reviews",
            description: "Software quality assurance activities, reviews, inspections, audits, and verification versus validation concepts",
            fileUrl: "https://drive.google.com/uc?export=download&id=18-piP3-clRxXvctyCN-D-thJDGSZihBK",
            previewUrl: "https://drive.google.com/file/d/18-piP3-clRxXvctyCN-D-thJDGSZihBK/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-08",
            fileSize: "4.4",
            tags: ["module-4", "quality-assurance", "reviews", "BIS714B"]
          },
          {
            id: "sqc-12",
            title: "Module 5: Process Improvement & Advanced Quality Topics",
            description: "Process improvement models, CMMI, Six Sigma basics, defect prevention techniques, and quality management tools",
            fileUrl: "https://drive.google.com/uc?export=download&id=1AsrHV1U6o8N38JtM8BcCJIsxd_f2cEjq",
            previewUrl: "https://drive.google.com/file/d/1AsrHV1U6o8N38JtM8BcCJIsxd_f2cEjq/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-10",
            fileSize: "4.7",
            tags: ["module-5", "process-improvement", "cmmi", "BIS714B"]
          }
        ]
      },
      {
        title: "BIG DATA ANALYTICS",
        code: "BCS714D",
        vtuCode: "BCS714D/714D",
        credits: 4,
        modules: [
          {
            id: "bda-1",
            title: "Module 1: Notes",
            description: "Introduction to Big Data Analytics",
            fileUrl: "https://drive.google.com/uc?export=download&id=1m-shcpTo6-9AYBT1wmeG1ylKMhwCIIUM",
            previewUrl: "https://drive.google.com/file/d/1m-shcpTo6-9AYBT1wmeG1ylKMhwCIIUM/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-12",
            fileSize: "4.3",
            tags: ["module-1", "big-data", "introduction", "BCS714D"]
          },
          {
            id: "bda-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1MQ2F7H2HN4eOg_cz1-USa2nk0SkGOcS0",
            previewUrl: "https://drive.google.com/file/d/1MQ2F7H2HN4eOg_cz1-USa2nk0SkGOcS0/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-14",
            fileSize: "4.5",
            tags: ["module-2", "big-data", "hadoop", "BCS714D"]
          },
          {
            id: "bda-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=19gV561ZmM4ktBLFfKEL0Riqy1rhRwuDa",
            previewUrl: "https://drive.google.com/file/d/19gV561ZmM4ktBLFfKEL0Riqy1rhRwuDa/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-16",
            fileSize: "4.4",
            tags: ["module-3", "big-data", "mapreduce", "BCS714D"]
          },
          {
            id: "bda-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ChwcleUUaFG8jIWI7Z6lQIAFtkpue4yQ",
            previewUrl: "https://drive.google.com/file/d/1ChwcleUUaFG8jIWI7Z6lQIAFtkpue4yQ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-18",
            fileSize: "4.6",
            tags: ["module-4", "big-data", "spark", "BCS714D"]
          },
          {
            id: "bda-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1graCHdRSVXvChRcXKdkWWPhP6ZH2XxfO",
            previewUrl: "https://drive.google.com/file/d/1graCHdRSVXvChRcXKdkWWPhP6ZH2XxfO/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-20",
            fileSize: "4.7",
            tags: ["module-5", "big-data", "applications", "BCS714D"]
          },
          {
            id: "bda-6",
            title: "ALL Question Paper",
            description: "All question papers for Big Data Analytics",
            fileUrl: "https://drive.google.com/uc?export=download&id=1YyscUweUvfoV0BP0RQvrUREgv7mOpmAS",
            previewUrl: "https://drive.google.com/file/d/1YyscUweUvfoV0BP0RQvrUREgv7mOpmAS/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2025-02-22",
            fileSize: "4.8",
            tags: ["all-papers", "collection", "exam", "BCS714D"]
          },
          {
            id: "bda-7",
            title: "ALL Question Paper solutions",
            description: "All question paper solutions for Big Data Analytics",
            fileUrl: "https://drive.google.com/uc?export=download&id=1m9VH6NBghr7IWFk2v798RrMbLXeZQahf",
            previewUrl: "https://drive.google.com/file/d/1m9VH6NBghr7IWFk2v798RrMbLXeZQahf/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2025-02-24",
            fileSize: "5.2",
            tags: ["solutions", "all-papers", "answers", "BCS714D"]
          }
        ]
      },
      {
        title: "Cryptography & Network Security",
        code: "BCO601",
        vtuCode: "BCO601/601",
        credits: 4,
        modules: [
          {
            id: "cns7-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1RmrMh00z0WNpkbwZlUDKWIBN1y88_mHv",
            previewUrl: "https://drive.google.com/file/d/1RmrMh00z0WNpkbwZlUDKWIBN1y88_mHv/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-26",
            fileSize: "4.3",
            tags: ["module-1", "cryptography", "security", "BCO601"]
          },
          {
            id: "cns7-2",
            title: "Module 1: Notes",
            description: "Additional comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=16A5UzpyCUdcbLMvPx5rxfgDAlhrDFmx0",
            previewUrl: "https://drive.google.com/file/d/16A5UzpyCUdcbLMvPx5rxfgDAlhrDFmx0/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-02-28",
            fileSize: "4.5",
            tags: ["module-1", "additional", "cryptography", "BCO601"]
          },
          {
            id: "cns7-10",
            title: "Module 1: Last Night Study Notes",
            description: "Concise revision notes for Module 1 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/uc?export=download&id=1TTeZQPI2EMqbCNaGCkXLWYP6AjV0ucDE",
            previewUrl: "https://drive.google.com/file/d/1TTeZQPI2EMqbCNaGCkXLWYP6AjV0ucDE/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2025-03-15",
            fileSize: "3.5",
            tags: ["module-1", "last-night-study", "revision", "exam-prep", "BCO601"]
          },
          {
            id: "cns7-3",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1OmN17Z7hhKrgAS8FTzSNcDcK8Xm2xkIg",
            previewUrl: "https://drive.google.com/file/d/1OmN17Z7hhKrgAS8FTzSNcDcK8Xm2xkIg/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-02",
            fileSize: "4.5",
            tags: ["module-2", "cryptography", "algorithms", "BCO601"]
          },
          {
            id: "cns7-4",
            title: "Module 2: Notes",
            description: "Additional comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1XGt_On6rVX6g-9QLo_ugWmu1wFA41XDw",
            previewUrl: "https://drive.google.com/file/d/1XGt_On6rVX6g-9QLo_ugWmu1wFA41XDw/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-04",
            fileSize: "4.6",
            tags: ["module-2", "additional", "algorithms", "BCO601"]
          },
          {
            id: "cns7-11",
            title: "Module 2: Last Night Study Notes",
            description: "Concise revision notes for Module 2 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/uc?export=download&id=1yL8IT1Gu-AtRg0EsQ7nUQ75mm5Pw-Fhm",
            previewUrl: "https://drive.google.com/file/d/1yL8IT1Gu-AtRg0EsQ7nUQ75mm5Pw-Fhm/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2025-03-16",
            fileSize: "3.6",
            tags: ["module-2", "last-night-study", "revision", "exam-prep", "BCO601"]
          },
          {
            id: "cns7-5",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=18VKZo6Ock9ghHOUZ2guBSkaVKtN_Bb0q",
            previewUrl: "https://drive.google.com/file/d/18VKZo6Ock9ghHOUZ2guBSkaVKtN_Bb0q/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-06",
            fileSize: "4.4",
            tags: ["module-3", "network-security", "protocols", "BCO601"]
          },
          {
            id: "cns7-12",
            title: "Module 3: Last Night Study Notes",
            description: "Concise revision notes for Module 3 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/uc?export=download&id=1GiruuYphhGLkcvBJ5TRLWm5Cc4J69KW1",
            previewUrl: "https://drive.google.com/file/d/1GiruuYphhGLkcvBJ5TRLWm5Cc4J69KW1/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2025-03-17",
            fileSize: "3.7",
            tags: ["module-3", "last-night-study", "revision", "exam-prep", "BCO601"]
          },
          {
            id: "cns7-6",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1djYC-nYh8uoSAICd1JYPollU3IoInmMm",
            previewUrl: "https://drive.google.com/file/d/1djYC-nYh8uoSAICd1JYPollU3IoInmMm/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-08",
            fileSize: "4.7",
            tags: ["module-4", "network-security", "authentication", "BCO601"]
          },
          {
            id: "cns7-13",
            title: "Module 4: Last Night Study Notes",
            description: "Concise revision notes for Module 4 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/uc?export=download&id=11GCQ2nBwthybjVN8qhD6UtU1gVdABB2n",
            previewUrl: "https://drive.google.com/file/d/11GCQ2nBwthybjVN8qhD6UtU1gVdABB2n/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2025-03-18",
            fileSize: "3.8",
            tags: ["module-4", "last-night-study", "revision", "exam-prep", "BCO601"]
          },
          {
            id: "cns7-7",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1JmDHb_V1kjM9IQUZbbslbIvS4OX8uro1",
            previewUrl: "https://drive.google.com/file/d/1JmDHb_V1kjM9IQUZbbslbIvS4OX8uro1/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-10",
            fileSize: "4.8",
            tags: ["module-5", "network-security", "applications", "BCO601"]
          },
          {
            id: "cns7-14",
            title: "Module 5: Last Night Study Notes",
            description: "Concise revision notes for Module 5 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/uc?export=download&id=1MIUaR6XXOD655dKQViEgKLmQZZWb9l50",
            previewUrl: "https://drive.google.com/file/d/1MIUaR6XXOD655dKQViEgKLmQZZWb9l50/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2025-03-19",
            fileSize: "3.9",
            tags: ["module-5", "last-night-study", "revision", "exam-prep", "BCO601"]
          },
          {
            id: "cns7-8",
            title: "ALL Question Paper",
            description: "All question papers for Cryptography & Network Security",
            fileUrl: "https://drive.google.com/uc?export=download&id=1BzdLI_W8Cw9CrnyoJip_OLKoEQu-fLpg",
            previewUrl: "https://drive.google.com/file/d/1BzdLI_W8Cw9CrnyoJip_OLKoEQu-fLpg/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2025-03-12",
            fileSize: "4.5",
            tags: ["all-papers", "collection", "exam", "BCO601"]
          },
          {
            id: "cns7-9",
            title: "ALL Question Paper",
            description: "All question papers for Cryptography & Network Security",
            fileUrl: "https://drive.google.com/file/d/1OKuuW3HnLFZD6PcGhMvW1FImjnI-8fxo",
            previewUrl: "https://drive.google.com/file/d/1BzdLI_W8Cw9CrnyoJip_OLKoEQu-fLpg/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2025-03-12",
            fileSize: "4.5",
            tags: ["all-papers", "collection", "exam", "BCO601"]
          },
          {
            id: "cns7-9",
            title: "CN&S",
            description: "Question bank for Cryptography & Network Security",
            fileUrl: "https://drive.google.com/uc?export=download&id=1aIH_vz0_6Aye_gTdpsnDyafawGGQzcqL",
            previewUrl: "https://drive.google.com/file/d/1aIH_vz0_6Aye_gTdpsnDyafawGGQzcqL/preview",
            type: "questions",
            category: "important-questions",
            essential: true,
            uploadedDate: "2025-03-14",
            fileSize: "4.2",
            tags: ["important-questions", "practice", "cns", "BCO601"]
          }
        ]
      },
      {
        title: "BLOCKCHAIN TECHNOLOGY",
        code: "BIC702",
        vtuCode: "BIC702/702",
        credits: 4,
        modules: [
          {
            id: "blockchain7-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=12CzjYxD_LtPpSa49H1gsEdQZJgZBYNi7",
            previewUrl: "https://drive.google.com/file/d/12CzjYxD_LtPpSa49H1gsEdQZJgZBYNi7/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-16",
            fileSize: "4.2",
            tags: ["module-1", "blockchain", "basics", "BIC702"]
          },
          {
            id: "blockchain7-2",
            title: "Module 2",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ueFQqgmgjVrfhBh_6anbno6pmjat85S-",
            previewUrl: "https://drive.google.com/file/d/1ueFQqgmgjVrfhBh_6anbno6pmjat85S-/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-18",
            fileSize: "4.5",
            tags: ["module-2", "blockchain", "cryptocurrency", "BIC702"]
          },
          {
            id: "blockchain7-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1FHPVvnGOt-ZpHIgpekFuSkAi6f4KiSfP",
            previewUrl: "https://drive.google.com/file/d/1FHPVvnGOt-ZpHIgpekFuSkAi6f4KiSfP/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-20",
            fileSize: "4.4",
            tags: ["module-3", "blockchain", "smart-contracts", "BIC702"]
          },
          {
            id: "blockchain7-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1PCkM767281tyr9p3vHi69sZpdOElgGEx",
            previewUrl: "https://drive.google.com/file/d/1PCkM767281tyr9p3vHi69sZpdOElgGEx/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-22",
            fileSize: "4.6",
            tags: ["module-4", "blockchain", "consensus", "BIC702"]
          },
          {
            id: "blockchain7-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=163O6oqpWGpXotwEXfHCDN-KPWzTnrTDQ",
            previewUrl: "https://drive.google.com/file/d/163O6oqpWGpXotwEXfHCDN-KPWzTnrTDQ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-24",
            fileSize: "4.7",
            tags: ["module-5", "blockchain", "applications", "BIC702"]
          },
          {
            id: "blockchain7-6",
            title: "important QA",
            description: "Question bank solutions for Blockchain Technology",
            fileUrl: "https://drive.google.com/uc?export=download&id=1aVOQct7SvLFpplBUstaJrvjQkP-6KSqh",
            previewUrl: "https://drive.google.com/file/d/1aVOQct7SvLFpplBUstaJrvjQkP-6KSqh/preview",
            type: "important-qa",
            category: "important-questions",
            essential: true,
            uploadedDate: "2025-03-26",
            fileSize: "4.9",
            tags: ["important-qa", "solutions", "answers", "BIC702"]
          }
        ]
      },
      {
        title: "CONSERVATION OF NATURAL RESOURCES",
        code: "BCV755B",
        vtuCode: "BCV755B/755B",
        credits: 3,
        modules: [
          {
            id: "cnr-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1 - Introduction to Natural Resources and Conservation",
            fileUrl: "https://drive.google.com/uc?export=download&id=1h1UqXof46bQOgNNm73esf2-PMZC8q5YO",
            previewUrl: "https://drive.google.com/file/d/1h1UqXof46bQOgNNm73esf2-PMZC8q5YO/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-04-15",
            fileSize: "3.8",
            tags: ["module-1", "natural-resources", "introduction", "BCV755B"]
          },
          {
            id: "cnr-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2 - Types of Natural Resources and their Distribution",
            fileUrl: "https://drive.google.com/uc?export=download&id=1gQErQ4JYcROokYtA_tvyPtTtYfhV54ZY",
            previewUrl: "https://drive.google.com/file/d/1gQErQ4JYcROokYtA_tvyPtTtYfhV54ZY/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-04-17",
            fileSize: "4.0",
            tags: ["module-2", "natural-resources", "distribution", "types", "BCV755B"]
          },
          {
            id: "cnr-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3 - Conservation Methods and Techniques",
            fileUrl: "https://drive.google.com/uc?export=download&id=10xKpz3oD-rL3a2PKoPcRxQMAAfdrf3Db",
            previewUrl: "https://drive.google.com/file/d/10xKpz3oD-rL3a2PKoPcRxQMAAfdrf3Db/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-04-19",
            fileSize: "4.2",
            tags: ["module-3", "conservation", "methods", "techniques", "BCV755B"]
          },
          {
            id: "cnr-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4 - Sustainable Development and Resource Management",
            fileUrl: "https://drive.google.com/uc?export=download&id=1NfVEEsGw9CDk5Q-1oV6d4TGNWr8XAMi-",
            previewUrl: "https://drive.google.com/file/d/1NfVEEsGw9CDk5Q-1oV6d4TGNWr8XAMi-/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-04-21",
            fileSize: "4.1",
            tags: ["module-4", "sustainable-development", "resource-management", "BCV755B"]
          },
          {
            id: "cnr-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5 - Policies, Legislation and Future Perspectives",
            fileUrl: "https://drive.google.com/uc?export=download&id=18qEysBsrRJKNszs9iehlcYBhXVDBYLGz",
            previewUrl: "https://drive.google.com/file/d/18qEysBsrRJKNszs9iehlcYBhXVDBYLGz/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-04-23",
            fileSize: "4.3",
            tags: ["module-5", "policies", "legislation", "future-perspectives", "BCV755B"]
          },
          {
            id: "cnr-6",
            title: "Important Questions",
            description: "Important questions and answers for Conservation of Natural Resources",
            fileUrl: "https://drive.google.com/file/d/1c1RSOovace8BaeF_1LbM_2DTeL4fyKFO",
            previewUrl: "https://drive.google.com/file/d/1c1RSOovace8BaeF_1LbM_2DTeL4fyKFO/preview",
            type: "solutions",
            category: "important-questions",
            essential: true,
            uploadedDate: "",
            fileSize: "3.9",
            tags: ["important-questions", "exam-prep", "answers", "BCV755B"]
          },
          {
            id: "cnr-7",
            title: "Previous Year Questions",
            description: "Important questions and answers for Conservation of Natural Resources",
            fileUrl: "Khttps://drive.google.com/file/d/1D5X9yRrnZ5T_r-jA0m1TQWOHAA2JyPi",
            previewUrl: "https://drive.google.com/file/d/1D5X9yRrnZ5T_r-jA0m1TQWOHAA2JyPiK/preview",
            type: "solutions",
            category: "pyq",
            essential: true,
            uploadedDate: "",
            fileSize: "3.9",
            tags: ["important-questions", "exam-prep", "all-papers", "BCV755B"]
          },
          {
            id: "cnr-9",
            title: "Module 1: Last Night Study Notes",
            description: "Concise revision notes for Module 5 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/file/d/1nTV44TrnMfkHxxPPjJEcXTlR2zqPvFjd",
            previewUrl: "https://drive.google.com/file/d/1nTV44TrnMfkHxxPPjJEcXTlR2zqPvFjd/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-03",
            fileSize: "3.9",
            tags: ["module-1", "last-night-study", "revision", "exam-prep", "BCV715B"]
          },
          {
            id: "cnr-10",
            title: "Module 2: Last Night Study Notes",
            description: "Concise revision notes for Module 2 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/file/d/1MBQcGuIgKHd7kjtC2i5helpayeRH-nv4",
            previewUrl: "https://drive.google.com/file/d/1MBQcGuIgKHd7kjtC2i5helpayeRH-nv4/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-03",
            fileSize: "3.9",
            tags: ["module-3", "last-night-study", "revision", "exam-prep", "BCV715B"]
          },
          {
            id: "cnr-10",
            title: "Module 2: Last Night Study Notes",
            description: "Concise revision notes for Module 2 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/file/d/1MBQcGuIgKHd7kjtC2i5helpayeRH-nv4",
            previewUrl: "https://drive.google.com/file/d/1MBQcGuIgKHd7kjtC2i5helpayeRH-nv4/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-03",
            fileSize: "3.9",
            tags: ["module-3", "last-night-study", "revision", "exam-prep", "BCV715B"]
          },

          {
            id: "cnr-11",
            title: "Module 3: Last Night Study Notes",
            description: "Concise revision notes for Module 3 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/file/d/1kFq1OPFN7Ef_wPzDaSvl4ExqpdRhFvGX",
            previewUrl: "https://drive.google.com/file/d/1kFq1OPFN7Ef_wPzDaSvl4ExqpdRhFvGX/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-03",
            fileSize: "3.9",
            tags: ["module-4", "last-night-study", "revision", "exam-prep", "BCV715B"]
          },
          {
            id: "cnr-12",
            title: "Module 5: Last Night Study Notes",
            description: "Concise revision notes for Module 5 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/file/d/1jCeAHEXGx-iYwdwqqrWsyMICNa3SNxLo",
            previewUrl: "https://drive.google.com/file/d/1jCeAHEXGx-iYwdwqqrWsyMICNa3SNxLo/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-03",
            fileSize: "3.9",
            tags: ["module-5", "last-night-study", "revision", "exam-prep", "BCV715B"]
          },
          {
            id: "cnr-12",
            title: "Module 1- 5: Last Night Study Notes ALL IN ONE",
            description: "Concise revision notes for Module 5 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/file/d/1v9VKTJjTLe5h0qIjYEe3FCX0JD9LMRZ8",
            previewUrl: "https://drive.google.com/file/d/1v9VKTJjTLe5h0qIjYEe3FCX0JD9LMRZ8/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-03",
            fileSize: "3.9",
            tags: ["module-5", "last-night-study", "revision", "exam-prep", "BCV715B"]
          },
          {
            id: "cnr-13",
            title: "Module 1- 5: Previous Year Question Paper Answers ALL IN ONE",
            description: "Concise revision notes for Module 5 - perfect for last-minute exam preparation",
            fileUrl: "https://drive.google.com/file/d/1v9VKTJjTLe5h0qIjYEe3FCX0JD9LMRZ8",
            previewUrl: "https://drive.google.com/file/d/1v9VKTJjTLe5h0qIjYEe3FCX0JD9LMRZ8/preview",
            type: "notes",
            category: "last-night",
            essential: true,
            uploadedDate: "2026-01-03",
            fileSize: "3.9",
            tags: ["module-5", "last-night-study", "revision", "exam-prep", "BCV715B"]
          },
          {
            id: "cnr-8",
            title: "Previous Year Questions",
            description: "Important questions and answers for Conservation of Natural Resources",
            fileUrl: "https://drive.google.com/file/d/1-dNfufKKZWO3I4EARVDYSURFB6KMGexz",
            previewUrl: "https://drive.google.com/file/d/1-dNfufKKZWO3I4EARVDYSURFB6KMGexz/preview",
            type: "solutions",
            category: "pyq",
            essential: true,
            uploadedDate: "",
            fileSize: "3.9",
            tags: ["important-questions", "exam-prep", "all-papers", "BCV755B"]
          },
        ],
      },
      {
        title: "Parallel Computing",
        code: "BCS702",
        vtuCode: "BCS702/702",
        credits: 4,
        modules: [
          {
            id: "pc-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/file/d/1Uw1uj3wpMaqS096LoX88QVGg_QIo0Rvi",
            previewUrl: "https://drive.google.com/file/d/1Uw1uj3wpMaqS096LoX88QVGg_QIo0Rvi/view",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-28",
            fileSize: "4.3",
            tags: ["module-1", "parallel-computing", "introduction", "BCS702"]
          },
          {
            id: "pc-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/file/d/1tpAAMjZ1ABWJavu85i0pq1bgmavvLgj0",
            previewUrl: "https://drive.google.com/file/d/1tpAAMjZ1ABWJavu85i0pq1bgmavvLgj0/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-03-30",
            fileSize: "4.6",
            tags: ["module-1", "handwritten", "parallel-computing", "BCS702"]
          },
          {
            id: "pc-3",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/file/d/1eV_ko0ME7sxddcYaqpPof900r_YYMbqW",
            previewUrl: "https://drive.google.com/file/d/1eV_ko0ME7sxddcYaqpPof900r_YYMbqW/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-04-01",
            fileSize: "4.5",
            tags: ["module-2", "parallel-computing", "architectures", "BCS702"]
          },

          {
            id: "pc-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/file/d/1mRpf0WQloD8Q_K4elO-sM1e3ugA1QPU6",
            previewUrl: "https://drive.google.com/file/d/1mRpf0WQloD8Q_K4elO-sM1e3ugA1QPU6/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-04-03",
            fileSize: "4.7",
            tags: ["module-4", "parallel-computing", "algorithms", "BCS702"]
          },
          {
            id: "pc-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/file/d/1rgOicbfyFCFB62LqIDYuLXc42_SsXGnZ",
            previewUrl: "https://drive.google.com/file/d/1rgOicbfyFCFB62LqIDYuLXc42_SsXGnZ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2025-04-05",
            fileSize: "4.8",
            tags: ["module-5", "parallel-computing", "applications", "BCS702"]
          },
          {
            id: "pc-6",
            title: "ALL Question Paper",
            description: "All question papers for Parallel Computing",
            fileUrl: "https://drive.google.com/uc?export=download&id=170ExErQsAgDRdAlwd2vRcYSu43RaIgb_",
            previewUrl: "https://drive.google.com/file/d/170ExErQsAgDRdAlwd2vRcYSu43RaIgb_/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2025-04-07",
            fileSize: "4.4",
            tags: ["all-papers", "collection", "exam", "BCS702"]
          },
          {
            id: "pc-7",
            title: "QB",
            description: "Question bank for Parallel Computing",
            fileUrl: "https://drive.google.com/uc?export=download&id=1gigxbfaP9OQJhGRlpmNvRu9H1UgDBcBc",
            previewUrl: "https://drive.google.com/file/d/1gigxbfaP9OQJhGRlpmNvRu9H1UgDBcBc/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2025-04-09",
            fileSize: "4.1",
            tags: ["question-bank", "practice", "parallel-computing", "BCS702"]
          }
        ]
      }
    ]

  },
  ece: {
    3: [
        {
        title: "Computer Organization and Architecture",
        code: "BEC306C",
        vtuCode: "BEC306C",
        credits: 3,
        modules: [
          {
            id: "coa-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/file/d/1k0htc1Tou68K4_T_mTRJcwLkvKjA9eN7/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1k0htc1Tou68K4_T_mTRJcwLkvKjA9eN7/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "5.2",
            tags: ["module-1", "coa", "architecture"]
          },
          {
            id: "coa-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/file/d/1RUqfBYICUsaAahIXE62y58RRb3K5ApU4/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1RUqfBYICUsaAahIXE62y58RRb3K5ApU4/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "4.8",
            tags: ["module-2", "coa", "architecture"]
          },
          {
            id: "coa-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/file/d/1MaRnUqF9PGwg65wgLljgcPgUlZtbo2zV/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1MaRnUqF9PGwg65wgLljgcPgUlZtbo2zV/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "5.0",
            tags: ["module-3", "coa", "architecture"]
          },
          {
            id: "coa-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/file/d/1H7Pb-ikLxSUWfzMOhXTyNcwwSsgEVDEJ/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1H7Pb-ikLxSUWfzMOhXTyNcwwSsgEVDEJ/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "4.5",
            tags: ["module-4", "coa", "architecture"]
          },
          {
            id: "coa-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/file/d/1zBLFZwCwCpjqOeqkyM4vyf4xtuFIKonn/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1zBLFZwCwCpjqOeqkyM4vyf4xtuFIKonn/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "4.7",
            tags: ["module-5", "coa", "architecture"]
          },
          {
            id: "coa-6",
            title: "Previous Year & Module Question Papers",
            description: "Collection of previous year and module-wise question papers",
            fileUrl: "https://drive.google.com/file/d/1EHnMkn1PkQRSocHJ8h8M9ht8W59qB1ZS/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1EHnMkn1PkQRSocHJ8h8M9ht8W59qB1ZS/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "5.5",
            tags: ["pyq", "question-paper", "exam", "coa"]
          },
          {
            id: "coa-7",
            title: "Previous Year QP Solutions",
            description: "Detailed solutions for previous year question papers",
            fileUrl: "https://drive.google.com/file/d/1b1aubqMWwZf0de7OjiahFlvM8wXB8fon/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1b1aubqMWwZf0de7OjiahFlvM8wXB8fon/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "4.2",
            tags: ["solutions", "solved-qp", "coa"]
          }
        ]
      },
      {
        title: "Digital System Design using Verilog",
        code: "BEC302",
        vtuCode: "BEC302",
        credits: 3,
        modules: [
          {
            id: "dsd-1",
            title: "Module 1: Notes",
            description: "Binary Systems and Logic Gates",
            fileUrl: "https://drive.google.com/file/d/1FHpWn7FL2dBONj95-1RbpCX5ynWReSKp/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1FHpWn7FL2dBONj95-1RbpCX5ynWReSKp/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "4.5",
            tags: ["module-1", "dsd", "verilog", "logic"]
          },
          {
            id: "dsd-2",
            title: "Module 2: Notes",
            description: "Combinational Logic Circuits",
            fileUrl: "https://drive.google.com/file/d/1zMPbKIAcleGtpU7w60T4Ew1ixmZBpAQ9/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1zMPbKIAcleGtpU7w60T4Ew1ixmZBpAQ9/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "4.2",
            tags: ["module-2", "dsd", "verilog", "combinational"]
          },
          {
            id: "dsd-3",
            title: "Module 3: Notes",
            description: "Sequential Logic Circuits",
            fileUrl: "https://drive.google.com/file/d/1Q90PaNtGb5xo6uXr7rPEH1tgu-_JPXX7/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1Q90PaNtGb5xo6uXr7rPEH1tgu-_JPXX7/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "4.8",
            tags: ["module-3", "dsd", "verilog", "sequential"]
          },
          {
            id: "dsd-4",
            title: "Module 4: Notes",
            description: "Verilog Data Flow Description",
            fileUrl: "https://drive.google.com/file/d/1JiatpNTUJKscm2Sp2HM14p2yZ9cPLlSf/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1JiatpNTUJKscm2Sp2HM14p2yZ9cPLlSf/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "4.3",
            tags: ["module-4", "dsd", "verilog", "dataflow"]
          },
          {
            id: "dsd-5",
            title: "Module 5: Notes",
            description: "Behavioral Description and Synthesis",
            fileUrl: "https://drive.google.com/file/d/12CdpSSBskGdO_Uk-JlMwjfV-7IVmxx-e/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/12CdpSSBskGdO_Uk-JlMwjfV-7IVmxx-e/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "4.6",
            tags: ["module-5", "dsd", "verilog", "synthesis"]
          },
          {
            id: "dsd-6",
            title: "Previous Year Question Paper",
            description: "Past question paper for DSD",
            fileUrl: "https://drive.google.com/file/d/1SYA9H_OjIPOtdledyKCMYr1tCLv0W471/view?usp=sharing",
            previewUrl: "https://drive.google.com/file/d/1SYA9H_OjIPOtdledyKCMYr1tCLv0W471/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-01-27",
            fileSize: "3.5",
            tags: ["pyq", "question-paper", "exam", "dsd"]
          },
          {
            id: "dsd-7",
            title: "Jan 2024 Question Paper",
            description: "Previous Year Question Paper - Jan 2024",
            fileUrl: "https://drive.google.com/file/d/1aWPdMXemf-rUdzJ56zXBgmnywi71keT-/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1aWPdMXemf-rUdzJ56zXBgmnywi71keT-/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2024", "dsd"]
          },
          {
            id: "dsd-8",
            title: "July 2024 Question Paper",
            description: "Previous Year Question Paper - July 2024",
            fileUrl: "https://drive.google.com/file/d/1tXFOkvoyxi9PB3ZN6BeXFAxk9aGHlro8/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1tXFOkvoyxi9PB3ZN6BeXFAxk9aGHlro8/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "july-2024", "dsd"]
          },
          {
            id: "dsd-9",
            title: "Model Question Paper (MQP)",
            description: "Model Question Paper for BEC302",
            fileUrl: "https://drive.google.com/file/d/1DyZxyX02nQG5MdtSgmSjZSFZOCw_MG5X/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1DyZxyX02nQG5MdtSgmSjZSFZOCw_MG5X/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "mqp", "dsd"]
          },
          {
            id: "dsd-10",
            title: "Jan 2025 Question Paper",
            description: "Previous Year Question Paper - Jan 2025",
            fileUrl: "https://drive.google.com/file/d/1sMO-3Xr4-_jfbpOUYinP-DOjKrUPCLa7/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1sMO-3Xr4-_jfbpOUYinP-DOjKrUPCLa7/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2025", "dsd"]
          },
          {
            id: "dsd-11",
            title: "Jun-July 2024 Question Paper",
            description: "Previous Year Question Paper - Jun-July 2024",
            fileUrl: "https://drive.google.com/file/d/1RQY233wo3E8iHJRxzfi4d_ckZlYQIV3Q/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1RQY233wo3E8iHJRxzfi4d_ckZlYQIV3Q/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jun-july-2024", "dsd"]
          },
          {
            id: "dsd-12",
            title: "Jan 2024 Question Paper (Alt)",
            description: "Previous Year Question Paper - Jan 2024 (Set 2)",
            fileUrl: "https://drive.google.com/file/d/1RatTgLh1lPwz-SopUiF4c704Rwf7PSOP/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1RatTgLh1lPwz-SopUiF4c704Rwf7PSOP/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2024", "dsd"]
          }
        ]
      },
      {
        title: "Mathematics For CSE",
        code: "BMATS301",
        vtuCode: "BMATS301",
        credits: 4,
        modules: [
          {
            id: "math3-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/file/d/1wMnLoK_lPI8G46cs94yCWv074OwXpS7B",
            previewUrl: "https://drive.google.com/file/d/1wMnLoK_lPI8G46cs94yCWv074OwXpS7B/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-25",
            fileSize: "3.8",
            tags: ["module-1", "mathematics", "theory"]
          },
          {
            id: "math3-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/file/d/1sr418op6UVyOSJBjNNLjereec4Ms98qE",
            previewUrl: "https://drive.google.com/file/d/1sr418op6UVyOSJBjNNLjereec4Ms98qE/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-01-25",
            fileSize: "3.5",
            tags: ["module-2", "mathematics", "theory"]
          },
          {
            id: "math3-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/file/d/1ioqyxJxAO64HRLBJFn24CaToa6m6fR7W",
            previewUrl: "https://drive.google.com/file/d/1ioqyxJxAO64HRLBJFn24CaToa6m6fR7W/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.6",
            tags: ["module-3", "mathematics", "theory"]
          },
          {
            id: "math3-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/file/d/1Flfs8mR4DT3Tk97rn19Bjvh8Oj-_L-Xp",
            previewUrl: "https://drive.google.com/file/d/1Flfs8mR4DT3Tk97rn19Bjvh8Oj-_L-Xp/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.4",
            tags: ["module-4", "mathematics", "theory"]
          },
          {
            id: "math3-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/file/d/1fKYDtg4pRm8-gv2HqUo1b3r0nw5A7Vxf",
            previewUrl: "https://drive.google.com/file/d/1fKYDtg4pRm8-gv2HqUo1b3r0nw5A7Vxf/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "3.2",
            tags: ["module-5", "mathematics", "theory"]
          },
          {
            id: "math3-6",
            title: "Hand Book",
            description: "Hand Book for Mathematics M3 for CSE",
            fileUrl: "https://drive.google.com/uc?export=download&id=1sw60XigOotMxYz7Z-kg4OOhCP_rTHosA",
            previewUrl: "https://drive.google.com/file/d/1sw60XigOotMxYz7Z-kg4OOhCP_rTHosA/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "4.2",
            tags: ["handbook", "reference", "complete"]
          },
          {
            id: "math3-7",
            title: "Model Question Paper Solutions 1",
            description: "Model Question Paper Solutions for Mathematics",
            fileUrl: "https://drive.google.com/file/d/1hgCehi2mfVkYhNfveEEZqCgLLoW4RIFF",
            previewUrl: "https://drive.google.com/file/d/1hgCehi2mfVkYhNfveEEZqCgLLoW4RIFF/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.8",
            tags: ["model-paper", "solutions", "practice"]
          },
          {
            id: "math3-8",
            title: "Model Question Paper Solutions 2",
            description: "Model Question Paper Solutions for Mathematics",
            fileUrl: "https://drive.google.com/uc?export=download&id=1nPXbLEwRwi_Kqe6ZErRvWNcUEHWyeK2c",
            previewUrl: "https://drive.google.com/file/d/1nPXbLEwRwi_Kqe6ZErRvWNcUEHWyeK2c/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-30",
            fileSize: "3.6",
            tags: ["model-paper", "solutions", "practice"]
          },
          {
            id: "math3-9",
            title: "Previous Year Question Paper",
            description: "Previous Year Question Paper for Mathematics",
            fileUrl: "https://drive.google.com/file/d/1tN6tJ98BmS1r_Z6LagP4S8JS-mqLPTnf",
            previewUrl: "https://drive.google.com/file/d/1tN6tJ98BmS1r_Z6LagP4S8JS-mqLPTnf/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-02-01",
            fileSize: "2.8",
            tags: ["PYQ", "previous-year", "exam"]
          },
          {
            id: "math3-10",
            title: "Question Bank",
            description: "Question Bank for Mathematics",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ZlfCQX1dAHU6UERsaOlEiA4PeSKWWNk5",
            previewUrl: "https://drive.google.com/file/d/1ZlfCQX1dAHU6UERsaOlEiA4PeSKWWNk5/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-02-03",
            fileSize: "3.5",
            tags: ["question-bank", "practice", "questions"]
          },
        ],
      },
      {
        title: "DATA STRUCTURES AND APPLICATIONS",
        code: "BCS304",
        vtuCode: "BCS304",
        credits: 4,
        modules: [
          {
            id: "dsa-1",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/file/d/1WV-nCHFlWs9xghqSSiMxi03XC9LkJsut",
            previewUrl: "https://drive.google.com/file/d/1WV-nCHFlWs9xghqSSiMxi03XC9LkJsut/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-2", "data-structures", "theory"]
          },
           {
            id: "dsa-8",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/file/d/1uPLLZ8O7DKno1RPoBM50WqYVUZXvnLGs",
            previewUrl: "https://drive.google.com/file/d/1uPLLZ8O7DKno1RPoBM50WqYVUZXvnLGs/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-15",
            fileSize: "3.5",
            tags: ["module-2", "data-structures", "theory"]
          },
          {
            id: "dsa-2",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=1HQxcfYqsHJyII7rd_2vuYZBI0srTO95s",
            previewUrl: "https://drive.google.com/file/d/1HQxcfYqsHJyII7rd_2vuYZBI0srTO95s/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-18",
            fileSize: "3.2",
            tags: ["module-3", "data-structures", "theory"]
          },
          {
            id: "dsa-3",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1yOHt9GHZR2vzglQ3JxhRCY_j9mh6M7rK",
            previewUrl: "https://drive.google.com/file/d/1yOHt9GHZR2vzglQ3JxhRCY_j9mh6M7rK/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-20",
            fileSize: "3.8",
            tags: ["module-4", "data-structures", "theory"]
          },
          {
            id: "dsa-4",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1E53vCWzN6WWbUZ37VHRESlznDMPvSfC5",
            previewUrl: "https://drive.google.com/file/d/1E53vCWzN6WWbUZ37VHRESlznDMPvSfC5/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2024-01-22",
            fileSize: "3.6",
            tags: ["module-5", "data-structures", "theory"]
          },
          {
            id: "dsa-5",
            title: "Previous Year Question Paper",
            description: "Previous Year Question Paper for DSA",
            fileUrl: "https://drive.google.com/file/d/1GLq4quNzdSomnGh6Y2ilFvjQuXM9JO6z",
            previewUrl: "https://drive.google.com/file/d/1GLq4quNzdSomnGh6Y2ilFvjQuXM9JO6z/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2024-01-24",
            fileSize: "2.8",
            tags: ["PYQ", "previous-year", "exam"]
          },
          {
            id: "dsa-6",
            title: "Question Paper With Solutions",
            description: "Question paper with solutions for DSA",
            fileUrl: "https://drive.google.com/uc?export=download&id=1NT_kKeN4Z0UiW-OhHwgq-8vxWoW2RRAS",
            previewUrl: "https://drive.google.com/file/d/1NT_kKeN4Z0UiW-OhHwgq-8vxWoW2RRAS/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2024-01-26",
            fileSize: "4.2",
            tags: ["solutions", "question-paper", "answers"]
          },
          {
            id: "dsa-7",
            title: "Question Bank",
            description: "Question bank for Data Structures",
            fileUrl: "https://drive.google.com/file/d/16hGQQlfOdePqioOpN0oBN8ZbQBAzlA2X",
            previewUrl: "https://drive.google.com/file/d/16hGQQlfOdePqioOpN0oBN8ZbQBAzlA2X/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2024-01-28",
            fileSize: "3.8",
            tags: ["question-bank", "practice", "questions"]
          },
          {
            id: "dsa-9",
            title: "ALL Question important-questions",
            description: "All question papers for Operating Systems",
            fileUrl: "https://drive.google.com/file/d/16hGQQlfOdePqioOpN0oBN8ZbQBAzlA2X",
            previewUrl: "https://drive.google.com/file/d/16hGQQlfOdePqioOpN0oBN8ZbQBAzlA2X/preview",
            type: "important-questions",
            category: "important-questions",
            essential: true,
            uploadedDate: "2025-03-12",
            fileSize: "4.5",
            tags: ["all-papers", "collection", "exam"]
          },
        ],
      },
      {
        title: "Network Analysis",
        code: "BEC304",
        vtuCode: "BEC304",
        credits: 3,
        modules: [
          {
            id: "na-1",
            title: "Jan 2024 Question Paper",
            description: "Previous Year Question Paper - Jan 2024",
            fileUrl: "https://drive.google.com/file/d/1t-BVvgEfOMVvN4IHNHFH0yYZPRW7d_rI/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1t-BVvgEfOMVvN4IHNHFH0yYZPRW7d_rI/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2024", "network-analysis"]
          },
          {
            id: "na-2",
            title: "July 2024 Question Paper",
            description: "Previous Year Question Paper - July 2024",
            fileUrl: "https://drive.google.com/file/d/1t4p9JtfdkJu-IEvSIU84vU4mYinE3KT6/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1t4p9JtfdkJu-IEvSIU84vU4mYinE3KT6/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "july-2024", "network-analysis"]
          },
          {
            id: "na-3",
            title: "Model Question Paper (MQP)",
            description: "Model Question Paper for Network Analysis",
            fileUrl: "https://drive.google.com/file/d/1QAMHkdLN1LDOQvkFOcWf1W7HddrBMy4O/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1QAMHkdLN1LDOQvkFOcWf1W7HddrBMy4O/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "mqp", "network-analysis"]
          },
          {
            id: "na-4",
            title: "Jan 2025 Question Paper",
            description: "Previous Year Question Paper - Jan 2025",
            fileUrl: "https://drive.google.com/file/d/1z6VT-5KnX_l7caf6CqfyU8Fa47WhNk5L/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1z6VT-5KnX_l7caf6CqfyU8Fa47WhNk5L/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2025", "network-analysis"]
          },
          {
            id: "na-5",
            title: "Jan 2024 Question Paper (Set 2)",
            description: "Previous Year Question Paper - Jan 2024 (Alt)",
            fileUrl: "https://drive.google.com/file/d/1o5vLQgoZN_F1b_wEjaeJoQegIOdgW2Uv/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1o5vLQgoZN_F1b_wEjaeJoQegIOdgW2Uv/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2024", "network-analysis"]
          },
          {
            id: "na-6",
            title: "June-July 2024 Question Paper",
            description: "Previous Year Question Paper - June-July 2024",
            fileUrl: "https://drive.google.com/file/d/1jMT8XpbqAQwKzzDkp6cy6l0PwMAJtPuf/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1jMT8XpbqAQwKzzDkp6cy6l0PwMAJtPuf/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jun-july-2024", "network-analysis"]
          },
          {
            id: "na-7",
            title: "Jan 2025 Question Paper (Set 2)",
            description: "Previous Year Question Paper - Jan 2025 (Alt)",
            fileUrl: "https://drive.google.com/file/d/1SfKR1u8PoEV25GN9sD8t3FYSIR4ZMrbt/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1SfKR1u8PoEV25GN9sD8t3FYSIR4ZMrbt/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2025", "network-analysis"]
          }
        ]
      },
    ],
    4: [
      {
        title: "Electromagnetics Theory",
        code: "BEC401",
        vtuCode: "BEC401",
        credits: 3,
        modules: [
          {
            id: "emt-1",
            title: "July 2024 Question Paper",
            description: "Previous Year Question Paper - July 2024",
            fileUrl: "https://drive.google.com/file/d/1J9uj1dVaVBWb2jDOHrSG7K9RZEGTLIMW/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1J9uj1dVaVBWb2jDOHrSG7K9RZEGTLIMW/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "july-2024", "electromagnetics"]
          },
          {
            id: "emt-2",
            title: "Model Question Paper (MQP)",
            description: "Model Question Paper",
            fileUrl: "https://drive.google.com/file/d/1ehYBhE-Mg0chQr8eGBGoVsV75XUGwo2B/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1ehYBhE-Mg0chQr8eGBGoVsV75XUGwo2B/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "mqp", "electromagnetics"]
          },
          {
            id: "emt-3",
            title: "Jan 2025 Question Paper",
            description: "Previous Year Question Paper - Jan 2025",
            fileUrl: "https://drive.google.com/file/d/1U4LfrGtTeu198HUfnE8o2M_R3hBvC_gj/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1U4LfrGtTeu198HUfnE8o2M_R3hBvC_gj/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2025", "electromagnetics"]
          },
          {
            id: "emt-4",
            title: "June-July 2024 Question Paper",
            description: "Previous Year Question Paper - June-July 2024",
            fileUrl: "https://drive.google.com/file/d/14o9teKO8-GPTovJ5-4yU6lQtFDCeuYm8/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/14o9teKO8-GPTovJ5-4yU6lQtFDCeuYm8/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jun-july-2024", "electromagnetics"]
          }
        ]
      },
      {
        title: "Principles of Communication System",
        code: "BEC402",
        vtuCode: "BEC402",
        credits: 3,
        modules: [
          {
            id: "pcs-1",
            title: "July 2024 Question Paper",
            description: "Previous Year Question Paper - July 2024",
            fileUrl: "https://drive.google.com/file/d/1-40_AsgxX2timCcVIBEKERqqhwb_Pryn/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1-40_AsgxX2timCcVIBEKERqqhwb_Pryn/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "july-2024", "communication-system"]
          },
          {
            id: "pcs-2",
            title: "Model Question Paper (MQP)",
            description: "Model Question Paper",
            fileUrl: "https://drive.google.com/file/d/19ZiZ6HI3A1--VEWnWh7yEBucmqjWhzVg/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/19ZiZ6HI3A1--VEWnWh7yEBucmqjWhzVg/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "mqp", "communication-system"]
          },
          {
            id: "pcs-3",
            title: "Jan 2025 Question Paper",
            description: "Previous Year Question Paper - Jan 2025",
            fileUrl: "https://drive.google.com/file/d/1qxv_CLPoC2dNPkZBzXuUlGPyXXC1V0dV/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1qxv_CLPoC2dNPkZBzXuUlGPyXXC1V0dV/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2025", "communication-system"]
          },
          {
            id: "pcs-4",
            title: "June-July 2024 Question Paper",
            description: "Previous Year Question Paper - June-July 2024",
            fileUrl: "https://drive.google.com/file/d/1hhcS29xDW5sN0NCbsNX_QAxq6enwKuH_/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1hhcS29xDW5sN0NCbsNX_QAxq6enwKuH_/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jun-july-2024", "communication-system"]
          }
        ]
      },
      {
        title: "Control Systems",
        code: "BEC403",
        vtuCode: "BEC403",
        credits: 3,
        modules: [
          {
            id: "cs-1",
            title: "July 2024 Question Paper",
            description: "Previous Year Question Paper - July 2024",
            fileUrl: "https://drive.google.com/file/d/1jJktOUM3TZLScfc2H5k0iLFIQQSkHPA1/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1jJktOUM3TZLScfc2H5k0iLFIQQSkHPA1/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "july-2024", "control-systems"]
          },
          {
            id: "cs-2",
            title: "Model Question Paper (MQP)",
            description: "Model Question Paper",
            fileUrl: "https://drive.google.com/file/d/14oonIJBEsBO7sAsPxuB_T9hHIVqO2fYW/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/14oonIJBEsBO7sAsPxuB_T9hHIVqO2fYW/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "mqp", "control-systems"]
          },
          {
            id: "cs-3",
            title: "Jan 2025 Question Paper (Set 1)",
            description: "Previous Year Question Paper - Jan 2025 (Set 1)",
            fileUrl: "https://drive.google.com/file/d/1JXOZ5pWRuDotWeTROehUSSR1_M9M8awS/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1JXOZ5pWRuDotWeTROehUSSR1_M9M8awS/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2025", "control-systems"]
          },
          {
            id: "cs-4",
            title: "June-July 2024 Question Paper",
            description: "Previous Year Question Paper - June-July 2024",
            fileUrl: "https://drive.google.com/file/d/1MlqGc7nVlEauaxF3lATwiVXoJoBQ6aXz/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1MlqGc7nVlEauaxF3lATwiVXoJoBQ6aXz/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jun-july-2024", "control-systems"]
          },
          {
            id: "cs-5",
            title: "Jan 2025 Question Paper (Set 2)",
            description: "Previous Year Question Paper - Jan 2025 (Set 2)",
            fileUrl: "https://drive.google.com/file/d/1Og5nA81EVaEVm3bR4iWavD89k09npk3a/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1Og5nA81EVaEVm3bR4iWavD89k09npk3a/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2025", "control-systems"]
          }
        ]
      },
      {
        title: "Microcontroller",
        code: "BEC405A",
        vtuCode: "BEC405A",
        credits: 3,
        modules: [
          {
            id: "mc-1",
            title: "July 2024 Question Paper",
            description: "Previous Year Question Paper - July 2024",
            fileUrl: "https://drive.google.com/file/d/1wNq3MpphmOwbt-VFE_5fRewgdktafjZK/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1wNq3MpphmOwbt-VFE_5fRewgdktafjZK/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "july-2024", "microcontroller"]
          },
          {
            id: "mc-2",
            title: "Model Question Paper (MQP)",
            description: "Model Question Paper",
            fileUrl: "https://drive.google.com/file/d/1x_918aG_WjyQ6KlXVkxAx-R8VYuUD8Y9/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1x_918aG_WjyQ6KlXVkxAx-R8VYuUD8Y9/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "mqp", "microcontroller"]
          },
          {
            id: "mc-3",
            title: "Jan 2025 Question Paper",
            description: "Previous Year Question Paper - Jan 2025",
            fileUrl: "https://drive.google.com/file/d/13Hnbhz64P38BVe0xYz9hqwddbQl0Ru6q/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/13Hnbhz64P38BVe0xYz9hqwddbQl0Ru6q/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jan-2025", "microcontroller"]
          },
          {
            id: "mc-4",
            title: "June-July 2024 Question Paper",
            description: "Previous Year Question Paper - June-July 2024",
            fileUrl: "https://drive.google.com/file/d/1o28Bl7_6FhiT7fa-dr0UQ1d6u7g7OKP3/view?usp=drive_link",
            previewUrl: "https://drive.google.com/file/d/1o28Bl7_6FhiT7fa-dr0UQ1d6u7g7OKP3/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-03",
            fileSize: "2.5",
            tags: ["pyq", "jun-july-2024", "microcontroller"]
          }
        ]
      }
    ],
    5: [
      {
        title: "Digital Communication",
        code: "BEC503",
        vtuCode: "BEC503",
        credits: 4,
        modules: [
          {
            id: "dc-1",
            title: "All Question Papers",
            description: "Complete collection of all question papers for Digital Communication",
            fileUrl: "https://drive.google.com/uc?export=download&id=1-17LanqQDcFIeEEAdT2z9f3H65t1a-Nd",
            previewUrl: "https://drive.google.com/file/d/1-17LanqQDcFIeEEAdT2z9f3H65t1a-Nd/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "5.2",
            tags: ["PYQ", "all-papers", "exam", "digital-communication"]
          },
          {
            id: "dc-2",
            title: "All Question Papers - Solutions",
            description: "Complete solutions for all question papers of Digital Communication",
            fileUrl: "https://drive.google.com/uc?export=download&id=1BLUIWB4tfooTd00t-gjsuoXDRLJWMfov",
            previewUrl: "https://drive.google.com/file/d/1BLUIWB4tfooTd00t-gjsuoXDRLJWMfov/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "6.8",
            tags: ["solutions", "solved", "answers", "digital-communication"]
          },
        ],
      },
      {
        title: "Technological Innovation Management and Entrepreneurship",
        code: "BEC501",
        vtuCode: "BEC501",
        credits: 3,
        modules: [
          {
            id: "time-1",
            title: "Module 1: Notes",
            description: "Comprehensive notes for Module 1",
            fileUrl: "https://drive.google.com/uc?export=download&id=1hO6pp6kuFbHHL1StNuV0fx3Kkt-er_3O",
            previewUrl: "https://drive.google.com/file/d/1hO6pp6kuFbHHL1StNuV0fx3Kkt-er_3O/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "3.5",
            tags: ["module-1", "time", "entrepreneurship"]
          },
          {
            id: "time-2",
            title: "Module 2: Notes",
            description: "Comprehensive notes for Module 2",
            fileUrl: "https://drive.google.com/uc?export=download&id=19SykU-FqlP7UIkeFMGuI9KZ3DrrbB5D5",
            previewUrl: "https://drive.google.com/file/d/19SykU-FqlP7UIkeFMGuI9KZ3DrrbB5D5/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "3.8",
            tags: ["module-2", "time", "entrepreneurship"]
          },
          {
            id: "time-3",
            title: "Module 3: Notes",
            description: "Comprehensive notes for Module 3",
            fileUrl: "https://drive.google.com/uc?export=download&id=177_CsmwY3UTHf4uO5qiGsG8v4AD5RBUo",
            previewUrl: "https://drive.google.com/file/d/177_CsmwY3UTHf4uO5qiGsG8v4AD5RBUo/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "4.0",
            tags: ["module-3", "time", "entrepreneurship"]
          },
          {
            id: "time-4",
            title: "Module 4: Notes",
            description: "Comprehensive notes for Module 4",
            fileUrl: "https://drive.google.com/uc?export=download&id=1vGvQMmST45pohzDbIhR16loqwIq20UD9",
            previewUrl: "https://drive.google.com/file/d/1vGvQMmST45pohzDbIhR16loqwIq20UD9/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "3.6",
            tags: ["module-4", "time", "entrepreneurship"]
          },
          {
            id: "time-5",
            title: "Module 5: Notes",
            description: "Comprehensive notes for Module 5",
            fileUrl: "https://drive.google.com/uc?export=download&id=1H-iW5ao27mb_ZcJx5HhR0xQwuu6n_yCP",
            previewUrl: "https://drive.google.com/file/d/1H-iW5ao27mb_ZcJx5HhR0xQwuu6n_yCP/preview",
            type: "notes",
            category: "notes",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "3.9",
            tags: ["module-5", "time", "entrepreneurship"]
          },
          {
            id: "time-6",
            title: "Dec-Jan Question Paper Solutions",
            description: "December-January question paper solutions",
            fileUrl: "https://drive.google.com/uc?export=download&id=1jzEpnSJ7mDJlS5lgR4AUrgAd-ntKRz4B",
            previewUrl: "https://drive.google.com/file/d/1jzEpnSJ7mDJlS5lgR4AUrgAd-ntKRz4B/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "4.5",
            tags: ["solutions", "dec-jan", "solved", "question-paper"]
          },
          {
            id: "time-7",
            title: "Jun-July Question Paper",
            description: "June-July question paper",
            fileUrl: "https://drive.google.com/uc?export=download&id=1ic4WdSsfgPpxNqudGWeTh-xYeIVOYWrb",
            previewUrl: "https://drive.google.com/file/d/1ic4WdSsfgPpxNqudGWeTh-xYeIVOYWrb/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "2.8",
            tags: ["PYQ", "jun-july", "question-paper"]
          },
          {
            id: "time-8",
            title: "Jun-July Makeup Question Paper",
            description: "June-July makeup question paper",
            fileUrl: "https://drive.google.com/uc?export=download&id=1qSmj67r7bYJfM8-KDvmt4BbL_yj3QZc8",
            previewUrl: "https://drive.google.com/file/d/1qSmj67r7bYJfM8-KDvmt4BbL_yj3QZc8/preview",
            type: "questions",
            category: "pyq",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "2.5",
            tags: ["PYQ", "jun-july", "makeup", "question-paper"]
          },
          {
            id: "time-9",
            title: "Model Question Paper (MQP)",
            description: "Model question paper for TIME",
            fileUrl: "https://drive.google.com/uc?export=download&id=1Er_L83h4iDUyxT0Rg1p7TUBWmpjpWM5X",
            previewUrl: "https://drive.google.com/file/d/1Er_L83h4iDUyxT0Rg1p7TUBWmpjpWM5X/preview",
            type: "questions",
            category: "question-bank",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "3.0",
            tags: ["model-paper", "MQP", "practice"]
          },
          {
            id: "time-10",
            title: "Model Question Paper Solutions (MQPS)",
            description: "Model question paper solutions for TIME",
            fileUrl: "https://drive.google.com/uc?export=download&id=1vLxPqQe6vpECDPtRTepwXGcRhmKNziFt",
            previewUrl: "https://drive.google.com/file/d/1vLxPqQe6vpECDPtRTepwXGcRhmKNziFt/preview",
            type: "solutions",
            category: "solved-qp",
            essential: true,
            uploadedDate: "2026-02-02",
            fileSize: "4.2",
            tags: ["solutions", "MQPS", "model-paper", "solved"]
          },
        ],
      },
    ]
  }
};